
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequiref920"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequiref920"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("b45Um", function(module, exports) {

$parcel$export(module.exports, "SignupPage", function () { return $f44a61d807a9ab2b$export$a2f4b65ede167ce5; });

var $loA2J = parcelRequire("loA2J");
parcelRequire("isAMu");
var $c5jpe = parcelRequire("c5jpe");
const $f44a61d807a9ab2b$export$a2f4b65ede167ce5 = ()=>/*#__PURE__*/ (0, $loA2J.jsx)((0, $c5jpe.SignupPageTemplate), {});

});
parcelRegister("isAMu", function(module, exports) {
$parcel$export(module.exports, "SignupPageTemplate", function () { return (parcelRequire("c5jpe")).SignupPageTemplate; });

var $c5jpe = parcelRequire("c5jpe");

});
parcelRegister("c5jpe", function(module, exports) {

$parcel$export(module.exports, "SignupPageTemplate", function () { return $e3807a1df759c2dd$export$7f87cfb81bb27126; });

var $7Knp0 = parcelRequire("7Knp0");

var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $9jWQb = parcelRequire("9jWQb");

var $3yLXo = parcelRequire("3yLXo");

var $jgJpJ = parcelRequire("jgJpJ");

var $f0Hih = parcelRequire("f0Hih");

var $iMdoL = parcelRequire("iMdoL");

var $cQk7Y = parcelRequire("cQk7Y");

var $fbaQ6 = parcelRequire("fbaQ6");

var $gAJUc = parcelRequire("gAJUc");

var $1syhO = parcelRequire("1syhO");

var $5KXGt = parcelRequire("5KXGt");
parcelRequire("ia5W9");
var $432Li = parcelRequire("432Li");

var $8rBqG = parcelRequire("8rBqG");

var $i6YkX = parcelRequire("i6YkX");

var $dKSUZ = parcelRequire("dKSUZ");

var $kqBSN = parcelRequire("kqBSN");

var $kYwmv = parcelRequire("kYwmv");

var $LBkMw = parcelRequire("LBkMw");

var $avirq = parcelRequire("avirq");

var $84uw8 = parcelRequire("84uw8");

var $8A1F4 = parcelRequire("8A1F4");

const $e3807a1df759c2dd$var$SignUpLayoutContainer = /*#__PURE__*/ (0, $iSvIT.lazy)(()=>// @ts-ignore
    (parcelRequire("9Qzri")));
const $e3807a1df759c2dd$export$7f87cfb81bb27126 = ({ featureFlags: featureFlags })=>{
    const location = (0, $5KXGt.useLocation)();
    const { bundle: useProductIntentBundle } = (0, $iMdoL.useProductIntent)(location.href);
    const { product: product, bundle: bundle, edition: edition, isN2NParam: isN2NParam, migrationSourceUuid: migrationSourceUuid, layout: layout, developer: developer } = (0, $fbaQ6.getQueryParams)(location.search);
    if ((0, $8A1F4.handleSignupRouteRedirects)({
        product: product,
        bundle: bundle
    })) return /*#__PURE__*/ (0, $loA2J.jsx)((0, $loA2J.Fragment), {});
    return /*#__PURE__*/ (0, $loA2J.jsx)($e3807a1df759c2dd$export$51898f39b04ffae9, {
        product: product !== null && product !== void 0 ? product : undefined,
        bundle: useProductIntentBundle,
        edition: edition,
        layout: layout,
        featureFlags: (0, $7Knp0._)({}, (0, $fbaQ6.defaultFeatureFlags), featureFlags),
        migrationSourceUuid: migrationSourceUuid,
        isN2NParam: isN2NParam,
        developer: developer
    });
};
const $e3807a1df759c2dd$export$51898f39b04ffae9 = ({ product: product, bundle: bundle, edition: edition, layout: layout, featureFlags: featureFlags, isN2NParam: isN2NParam, migrationSourceUuid: migrationSourceUuid, developer: developer })=>{
    (0, $9jWQb.useUFOComponentExperience)((0, $jgJpJ.ufoEventPaidSignupLandingPageLoad));
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $iSvIT.Suspense), {
        children: /*#__PURE__*/ (0, $loA2J.jsx)("div", {
            children: /*#__PURE__*/ (0, $loA2J.jsx)($e3807a1df759c2dd$var$SignUpComponent, {
                productParam: product,
                bundleOverride: bundle,
                editionOverride: edition,
                layout: layout,
                featureFlags: (0, $7Knp0._)({}, (0, $fbaQ6.defaultFeatureFlags), featureFlags),
                isN2NParam: isN2NParam,
                migrationSourceUuid: migrationSourceUuid,
                developer: developer
            })
        })
    });
};
// TODO: Temporary fix for hot-120109
// eslint-disable-next-line complexity
const $e3807a1df759c2dd$var$SignUpComponent = ({ productParam: productParam, bundleOverride: bundleOverride, editionOverride: editionOverride, layout: layout = "first-impressions", featureFlags: featureFlags, migrationSourceUuid: migrationSourceUuid, isN2NParam: _isN2NParam, developer: developer })=>{
    const { user: userProfile } = (0, $iMdoL.useUserContext)();
    const isNewUser = (0, $iMdoL.useNewUser)();
    const isJSW = (0, $iMdoL.useJiraIntent)();
    const isJSM = (0, $iMdoL.useJiraServiceManagementIntent)();
    const isJPD = (0, $iMdoL.useJiraProductDiscoveryIntent)();
    const isDevAI = (0, $iMdoL.useDevAiIntent)();
    const isLoom = (0, $iMdoL.useLoomIntent)();
    const isConfluence = (0, $iMdoL.useConfluenceIntent)();
    const isServiceCollection = (0, $iMdoL.useServiceCollectionIntent)();
    const isTeamworkCollection = (0, $iMdoL.useTeamworkCollectionIntent)();
    const countryCode = typeof window !== "undefined" ? window.countryCode : undefined;
    const blockedLocales = [
        "RU",
        "BY"
    ];
    const labels = (0, $fbaQ6.useLabelsLocalized)((0, $fbaQ6.defaultLabels));
    (0, $iSvIT.useEffect)(()=>{
        const getaaCompleteQueryObj = (0, $1syhO.getLocalStorage)((0, $cQk7Y.AA_AUTOCOMPLETE_POTENTIAL_CONVERSION_EVENT_LOCAL_STORAGE_KEY));
        if (getaaCompleteQueryObj) {
            const parsedStringifyAttributes = JSON.parse(getaaCompleteQueryObj);
            (0, $cQk7Y.sendConversionEventAlgolia)({
                objectID: parsedStringifyAttributes.objectID,
                queryID: parsedStringifyAttributes.queryID,
                position: parsedStringifyAttributes.position
            });
        }
    }, []);
    if (countryCode && blockedLocales.includes(countryCode)) return /*#__PURE__*/ (0, $loA2J.jsx)((0, $432Li.ErrorLocale), {
        locale: countryCode
    });
    if (userProfile.requestInProgress) return /*#__PURE__*/ (0, $loA2J.jsx)((0, $loA2J.Fragment), {});
    if (layout !== "standalone" && !migrationSourceUuid) {
        if (isJSW) return /*#__PURE__*/ (0, $loA2J.jsx)((0, $dKSUZ.JiraSignup), {});
        if (isJSM) return /*#__PURE__*/ (0, $loA2J.jsx)((0, $kYwmv.JsmSignup), {});
        if (isJPD) return /*#__PURE__*/ (0, $loA2J.jsx)((0, $kqBSN.JpdSignup), {});
        if (isDevAI) return /*#__PURE__*/ (0, $loA2J.jsx)((0, $i6YkX.DevAiSignup), {});
        if (isConfluence) return /*#__PURE__*/ (0, $loA2J.jsx)((0, $8rBqG.ConfluenceSignup), {});
        if (isLoom) return /*#__PURE__*/ (0, $loA2J.jsx)((0, $LBkMw.LoomSignup), {});
        if (isServiceCollection) return /*#__PURE__*/ (0, $loA2J.jsx)((0, $avirq.ServiceCollectionSignup), {});
        if (isTeamworkCollection) return /*#__PURE__*/ (0, $loA2J.jsx)((0, $84uw8.TeamworkCollectionSignup), {});
    }
    return $e3807a1df759c2dd$export$1e1127025be8705d({
        productParam: productParam,
        bundleOverride: bundleOverride,
        editionOverride: editionOverride,
        isNewUser: isNewUser,
        layout: layout,
        migrationSourceUuid: migrationSourceUuid,
        developer: developer
    }) ? /*#__PURE__*/ (0, $loA2J.jsx)((0, $5KXGt.ClientOnly), {
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $3yLXo.default), {
            bundle: bundleOverride,
            edition: editionOverride,
            isNewUser: isNewUser
        })
    }) : /*#__PURE__*/ (0, $loA2J.jsx)((0, $5KXGt.ClientOnly), {
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $f0Hih.default), {
            intentType: "form",
            productKey: bundleOverride,
            edition: editionOverride,
            children: /*#__PURE__*/ (0, $loA2J.jsx)($e3807a1df759c2dd$var$SignUpLayoutContainer, {
                layout: layout,
                allowSignupWithGoogle: true,
                allowSignupWithAllSocialOptions: true,
                bundleOverride: bundleOverride,
                editionOverride: editionOverride,
                productData: (0, $fbaQ6.defaultProductData),
                enableFreeBreachTest: true,
                labels: labels,
                firstImpressionsImageUrls: (0, $fbaQ6.firstImpressionsImageUrls),
                featureFlags: featureFlags
            })
        })
    });
};
function $e3807a1df759c2dd$export$1e1127025be8705d({ productParam: productParam, bundleOverride: bundleOverride, editionOverride: editionOverride, layout: layout, migrationSourceUuid: migrationSourceUuid, developer: developer }) {
    // the flows that return true here have already been split off above
    // this gate gives us confidence to remove this function and always return false
    if ((0, $gAJUc.checkFeatureFlagGate)((0, $gAJUc.featureFlags).signupModuleDeprecation)) return false;
    const isBxpkitOnly = ()=>{
        // show Bxpkit to all users with the standalone layout (paid embedded)
        if (layout === "standalone") return true;
        if (migrationSourceUuid) return true;
        if (developer) return true;
        const isMultiProductsParam = productParam === null || productParam === void 0 ? void 0 : productParam.includes(",");
        if (isMultiProductsParam) return true;
        return false;
    };
    if (isBxpkitOnly()) return false;
    const isJsw = bundleOverride === "jira-software" || !bundleOverride;
    const isConfluence = bundleOverride === "confluence";
    const isJsm = bundleOverride === "jira-service-management";
    const isFreeEdition = editionOverride === "free" || !editionOverride;
    // show Bxpkit if not one of three core products
    const isBxpUiSupportedBundle = isConfluence || isJsw || isJsm;
    if (!isBxpUiSupportedBundle) return false;
    // Pre-filter conditions for site picker / return to product experiment
    const isEligibleForSitePicker = (isJsw || isConfluence) && isFreeEdition;
    if (isEligibleForSitePicker) return true;
    return false;
}

});
parcelRegister("3yLXo", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b82786c494ea4d91$export$2e2bcd8739ae039; });

var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $g9kzu = parcelRequire("g9kzu");

var $jgJpJ = parcelRequire("jgJpJ");

var $f0Hih = parcelRequire("f0Hih");

var $iMdoL = parcelRequire("iMdoL");

var $dWbel = parcelRequire("dWbel");

var $2z7nN = parcelRequire("2z7nN");

var $WKdxa = parcelRequire("WKdxa");
/**
 * @deprecated Use AccountCreation or SiteActivation instead.
 */ const $b82786c494ea4d91$var$SignupModule = ({ bundle: bundle, edition: edition, isNewUser: isNewUser, emailFormOnly: emailFormOnly, animatedSocialBanner: animatedSocialBanner, hasRebrandedSignupFormStyles: hasRebrandedSignupFormStyles, bgColor: bgColor = "bgWhite", customSignInProviders: customSignInProviders, hideLegalText: hideLegalText })=>{
    var _profile_cohorts, _profile_cohorts1, _profile_cohorts2;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $g9kzu.useAnalyticsEvents)();
    const { profile: profile, user: user } = (0, $iMdoL.useUserContext)();
    const analyticsClient = (0, $dWbel.useAnalyticsClient)();
    const showLoadingSpinner = user.requestInProgress || user.isUserLoggedIn && profile.requestInProgress;
    (0, $iSvIT.useEffect)(()=>{
        (0, $jgJpJ.ufoEventSiteNameFormLoad).start({
            bundle: bundle,
            edition: edition
        });
        (0, $jgJpJ.ufoEventSignupFormLoad).start({
            bundle: bundle,
            edition: edition
        });
    }, [
        bundle,
        edition
    ]);
    (0, $iSvIT.useEffect)(()=>{
        var _profile_cohorts, _profile_cohorts1, _profile_cohorts2;
        if (!analyticsClient || profile.requestInProgress || user.requestInProgress) return;
        if (user.isUserLoggedIn) createAnalyticsEvent({
            eventType: "ui",
            action: "viewed",
            actionSubject: "siteNameComponent",
            containerId: "bxp-ui-signup",
            actionSubjectId: "standalone",
            attributes: {
                productKey: (0, $jgJpJ.getPrimaryProductKeyFromBundle)(bundle),
                edition: edition,
                userType: (_profile_cohorts = profile.cohorts) === null || _profile_cohorts === void 0 ? void 0 : _profile_cohorts.userType,
                domainType: (_profile_cohorts1 = profile.cohorts) === null || _profile_cohorts1 === void 0 ? void 0 : _profile_cohorts1.domainType,
                companyType: (_profile_cohorts2 = profile.cohorts) === null || _profile_cohorts2 === void 0 ? void 0 : _profile_cohorts2.companyType
            }
        }).fire();
        else createAnalyticsEvent({
            eventType: "ui",
            action: "viewed",
            actionSubject: "accountCreationComponent",
            containerId: "bxp-ui-signup",
            actionSubjectId: emailFormOnly ? "embedded" : "standalone",
            attributes: {
                productKey: (0, $jgJpJ.getPrimaryProductKeyFromBundle)(bundle),
                edition: edition
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        analyticsClient,
        user.isUserLoggedIn,
        user.requestInProgress,
        bundle,
        edition,
        emailFormOnly,
        profile.requestInProgress,
        (_profile_cohorts = profile.cohorts) === null || _profile_cohorts === void 0 ? void 0 : _profile_cohorts.userType,
        (_profile_cohorts1 = profile.cohorts) === null || _profile_cohorts1 === void 0 ? void 0 : _profile_cohorts1.domainType,
        (_profile_cohorts2 = profile.cohorts) === null || _profile_cohorts2 === void 0 ? void 0 : _profile_cohorts2.companyType
    ]);
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $WKdxa.SignupFormContextProvider), {
        bundle: bundle,
        edition: edition,
        children: /*#__PURE__*/ (0, $loA2J.jsx)("div", {
            "data-testid": "signup-module",
            children: /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                "aria-busy": user.requestInProgress,
                "aria-live": "polite",
                children: showLoadingSpinner ? /*#__PURE__*/ (0, $loA2J.jsx)((0, $2z7nN.FormLoading), {}) : !user.isUserLoggedIn ? /*#__PURE__*/ (0, $loA2J.jsx)((0, $loA2J.Fragment), {
                    children: /*#__PURE__*/ (0, $loA2J.jsxs)((0, $f0Hih.default), {
                        intentType: "form",
                        productKey: (0, $jgJpJ.getPrimaryProductKeyFromBundle)(bundle),
                        edition: edition,
                        children: [
                            /*#__PURE__*/ (0, $loA2J.jsx)((0, $2z7nN.SignupForm), {
                                emailFormOnly: emailFormOnly,
                                animatedSocialBanner: animatedSocialBanner,
                                hasRebrandedSignupFormStyles: hasRebrandedSignupFormStyles,
                                bgColor: bgColor,
                                customSignInProviders: customSignInProviders,
                                hideLegalText: hideLegalText
                            }),
                            /*#__PURE__*/ (0, $loA2J.jsx)((0, $2z7nN.SignupFormSuccessUFOEvent), {})
                        ]
                    })
                }) : /*#__PURE__*/ (0, $loA2J.jsx)((0, $f0Hih.default), {
                    intentType: "form",
                    productKey: (0, $jgJpJ.getPrimaryProductKeyFromBundle)(bundle),
                    edition: edition,
                    children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $2z7nN.SiteNameForm), {
                        isNewUser: isNewUser,
                        hasRebrandedSignupFormStyles: hasRebrandedSignupFormStyles,
                        bgColor: bgColor
                    })
                })
            })
        })
    });
};
var $b82786c494ea4d91$export$2e2bcd8739ae039 = $b82786c494ea4d91$var$SignupModule;

});

parcelRegister("ia5W9", function(module, exports) {
$parcel$export(module.exports, "ErrorLocale", function () { return (parcelRequire("432Li")).ErrorLocale; });
$parcel$export(module.exports, "InputSubmitButton", function () { return (parcelRequire("5cDws")).InputSubmitButton; });
$parcel$export(module.exports, "SignupDefault", function () { return (parcelRequire("6dDlC")).SignupDefault; });
$parcel$export(module.exports, "GetStartedHeading", function () { return (parcelRequire("esacZ")).GetStartedHeading; });
$parcel$export(module.exports, "Heading", function () { return (parcelRequire("esacZ")).Heading; });
$parcel$export(module.exports, "JPDGetStartedHeading", function () { return (parcelRequire("esacZ")).JPDGetStartedHeading; });
$parcel$export(module.exports, "CreateASiteHeading", function () { return (parcelRequire("3CPhp")).CreateASiteHeading; });
$parcel$export(module.exports, "NoCreditCardRequired", function () { return (parcelRequire("eZrnm")).NoCreditCardRequired; });
$parcel$export(module.exports, "SubmitButtonExistingUser", function () { return (parcelRequire("587P6")).SubmitButtonExistingUser; });
$parcel$export(module.exports, "InputEmail", function () { return (parcelRequire("cHXak")).InputEmail; });
$parcel$export(module.exports, "CreateAWorkspaceHeading", function () { return (parcelRequire("d5Q1l")).CreateAWorkspaceHeading; });
$parcel$export(module.exports, "SubHeading", function () { return (parcelRequire("8MW6j")).SubHeading; });
$parcel$export(module.exports, "WelcomeBackHeading", function () { return (parcelRequire("fy2K0")).WelcomeBackHeading; });
$parcel$export(module.exports, "SubmitButtonMessageNext", function () { return (parcelRequire("jN1Op")).SubmitButtonMessageNext; });
parcelRequire("fP3LK");
parcelRequire("5cDws");
parcelRequire("6dDlC");
parcelRequire("esacZ");
parcelRequire("3CPhp");
parcelRequire("eZrnm");
parcelRequire("587P6");
parcelRequire("cHXak");
parcelRequire("d5Q1l");
parcelRequire("8MW6j");
parcelRequire("fy2K0");
parcelRequire("jN1Op");

});
parcelRegister("fP3LK", function(module, exports) {
$parcel$export(module.exports, "ErrorLocale", function () { return (parcelRequire("432Li")).ErrorLocale; });
parcelRequire("432Li");

});
parcelRegister("432Li", function(module, exports) {

$parcel$export(module.exports, "ErrorLocale", function () { return $3f2f23ecce3cf0dc$export$33e78fd3ecccdefd; });
/* error-locale.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $f6qj2 = parcelRequire("f6qj2");

var $g9kzu = parcelRequire("g9kzu");

var $6IiXU = parcelRequire("6IiXU");

var $a6bec = parcelRequire("a6bec");
const $3f2f23ecce3cf0dc$export$33e78fd3ecccdefd = ({ locale: locale })=>{
    const intl = (0, $f6qj2.default)();
    const localeErrorHeader = intl.formatMessage({
        id: "BxpUiSignup.SignupForm.localeErrorHeader",
        defaultMessage: "We stand with Ukraine"
    });
    const localeErrorButtonText = intl.formatMessage({
        id: "BxpUiSignup.SignupForm.localeErrorButtonText",
        defaultMessage: "Learn more"
    });
    const localeErrorMessage = intl.formatMessage({
        id: "BxpUiSignup.SignupForm.localeErrorMessage",
        defaultMessage: "Following the Russian invasion of Ukraine, we are pausing the sale of new software in Russia and Belarus."
    });
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $g9kzu.useAnalyticsEvents)();
    (0, $iSvIT.useEffect)(()=>{
        createAnalyticsEvent({
            event: "blocked",
            action: "blocked",
            actionSubject: "signUp",
            actionSubjectId: "signUpForm",
            product: "marketing",
            blockType: "geoIP",
            blockValue: locale
        }).fire("signup");
    }, [
        createAnalyticsEvent,
        locale
    ]);
    return /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
        "data-testid": "error-locale",
        className: (0, $esG4f.default)([
            "_4cvr1h6o _1e0c1txw _2lx21bp4 _19pk1wug _2hwx1wug _otyr1wug _18u01wug _y3gn1h6o _p12f1m00 _ca0qidpf _u5f3gktf _n3tdidpf _19bvgktf"
        ]),
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                className: (0, $esG4f.default)([
                    "_4cvr1h6o _bfhk1hxd _1e0c1txw _4t3iuuw1 _1bah1h6o _6rthqslr _1bsb1osq _p12f1mjv"
                ]),
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $a6bec.AtlassianLogo), {
                    appearance: "brand"
                })
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("h2", {
                children: localeErrorHeader
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("p", {
                children: localeErrorMessage
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $6IiXU.default), {
                appearance: "link",
                href: "https://www.atlassian.com/blog/announcements/atlassian-stands-with-ukraine",
                children: localeErrorButtonText
            })
        ]
    });
};
const $3f2f23ecce3cf0dc$var$containerCss = null;
const $3f2f23ecce3cf0dc$var$logoContainerCss = null;

});


parcelRegister("5cDws", function(module, exports) {

$parcel$export(module.exports, "InputSubmitButton", function () { return $4eb3c441df9b5efd$export$8a1669598804b0aa; });
/* submit-input.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $f6qj2 = parcelRequire("f6qj2");

var $26kkA = parcelRequire("26kkA");

var $7OGW4 = parcelRequire("7OGW4");

var $axg8K = parcelRequire("axg8K");

var $jgJpJ = parcelRequire("jgJpJ");

var $iMdoL = parcelRequire("iMdoL");

var $1UUq1 = parcelRequire("1UUq1");

var $5ohHq = parcelRequire("5ohHq");

var $gAJUc = parcelRequire("gAJUc");
const $4eb3c441df9b5efd$export$8a1669598804b0aa = ()=>{
    var _useUserContext_product;
    const intl = (0, $f6qj2.default)();
    const { formError: formError, hasSubmitted: hasSubmitted, isReadyForInvalid: isReadyForInvalid, isSubmitting: isSubmitting, setIsEmailValid: setIsEmailValid, setIsReadyForInvalid: setIsReadyForInvalid, setTypeAheadEmail: setTypeAheadEmail, typeAheadEmail: typeAheadEmail } = (0, $axg8K.useAccountCreationContext)();
    const [isValid, setValid] = (0, $iSvIT.useState)();
    const [email, setEmail] = (0, $iSvIT.useState)(typeAheadEmail);
    const useUpdatedRegexPattern = (0, $gAJUc.checkFeatureFlagGate)((0, $gAJUc.featureFlags).signupAccountCreationEmailRegex);
    (0, $iSvIT.useEffect)(()=>{
        const isValid = (0, $jgJpJ.emailIsValid)(email, useUpdatedRegexPattern); // wait to show invalid state if the user is not finished typing
        if (!isValid && !isReadyForInvalid) {
            setValid(undefined);
            return;
        }
        setValid(isValid);
        setIsEmailValid(isValid);
    }, [
        email,
        setIsEmailValid,
        isReadyForInvalid,
        useUpdatedRegexPattern
    ]);
    const buttonText = intl.formatMessage({
        id: "signupForm.accountCreation.signupButton",
        defaultMessage: "Sign up"
    });
    const helperText = intl.formatMessage({
        id: "signupForm.accountCreation.helperText",
        defaultMessage: "Using a work email helps find teammates and boost collaboration."
    });
    const placeholderText = intl.formatMessage({
        id: "BxpUiSignup.SignupForm.emailPlaceholder",
        defaultMessage: "you@company.com"
    });
    const errorMessageText = intl.formatMessage({
        id: "BxpUiSignup.SignupForm.invalidEmail",
        defaultMessage: "Please enter a valid email address."
    });
    const labelText = intl.formatMessage({
        id: "BxpUiSignup.SignupForm.workEmail",
        defaultMessage: "Work email"
    });
    const productName = (_useUserContext_product = (0, $iMdoL.useUserContext)().product) === null || _useUserContext_product === void 0 ? void 0 : _useUserContext_product.key;
    return /*#__PURE__*/ (0, $loA2J.jsxs)((0, $loA2J.Fragment), {
        children: [
            /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                className: (0, $esG4f.default)([
                    "_1e0c1txw _4cvresu3 _1bah1yb4 _zulpftgi _6rth7vkz"
                ]),
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                        className: (0, $esG4f.default)([
                            "_1bsb1osq _zzqj183y _62vcmccc _1heubzd7 _1rwq1t4y _125x1syg _17rnbzd7 _1t2q1kw7 _1q9pbfng _12vqewfl _1vyiewfl _1p1fidpf _d78pglyw"
                        ]),
                        style: {
                            "--_1ikmwd8": (0, $43MIc.default)((0, $5ohHq.wacToken)("font.charlie.text")),
                            "--_1jvo4a6": (0, $43MIc.default)((0, $jgJpJ.fontSize).md)
                        },
                        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $26kkA.default), {
                            "aria-required": true,
                            isRequired: true,
                            label: /*#__PURE__*/ (0, $loA2J.jsx)("span", {
                                className: (0, $esG4f.default)([
                                    "_1e0c1o8l _p12f9wyc _1bsb1kdj"
                                ]),
                                children: labelText
                            }),
                            name: "email",
                            children: ({ fieldProps: fieldProps })=>/*#__PURE__*/ (0, $loA2J.jsx)("div", {
                                    className: (0, $esG4f.default)([
                                        isValid === true && "_1lo6qn1y",
                                        isValid === false && "_1lo61wfy"
                                    ]),
                                    children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $7OGW4.default), (0, $6iHNw._)((0, $7Knp0._)({}, fieldProps), {
                                        autoComplete: "email",
                                        "aria-describedby": "account_creation_email_help_text",
                                        elemAfterInput: /*#__PURE__*/ (0, $loA2J.jsx)((0, $axg8K.InputIcon), {
                                            valid: isValid
                                        }),
                                        onBlur: ()=>setIsReadyForInvalid(true),
                                        onChange: (e)=>{
                                            setEmail(e.target.value);
                                            setTypeAheadEmail(e.target.value);
                                            fieldProps.onChange(e);
                                        },
                                        placeholder: placeholderText,
                                        testId: "email_field",
                                        type: "email",
                                        value: email
                                    }))
                                })
                        })
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $1UUq1.Button), {
                            type: "submit",
                            isDisabled: isSubmitting || hasSubmitted && !formError,
                            isLoading: isSubmitting || hasSubmitted && !formError,
                            dataEventProps: {
                                "data-product-key": productName,
                                "data-event": "clicked",
                                "data-event-component": "linkButton",
                                "data-event-container": "signup",
                                "data-label": "sign-up",
                                "data-label-english": "Sign up"
                            },
                            className: (0, $esG4f.default)([
                                "_1wybf6fq _4t3i4vtr _o5721q9c"
                            ]),
                            children: buttonText
                        })
                    })
                ]
            }),
            isValid === false ? /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                id: "account_creation_email_help_text",
                role: "alert",
                className: (0, $esG4f.default)([
                    "_19pkidpf _2hwx1wug _otyridpf _18u01wug _y3gn1h6o _1wybepq8 _vwz4bs82 _syaznbxb"
                ]),
                style: {
                    "--_1h1y5xv": (0, $43MIc.default)((0, $jgJpJ.fontSize).xs)
                },
                children: errorMessageText
            }) : helperText ? /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                id: "account_creation_email_help_text",
                className: (0, $esG4f.default)([
                    "_19pkidpf _2hwx1wug _otyridpf _18u01wug _y3gn1h6o _1wybepq8 _vwz4bs82 _syaz131l"
                ]),
                style: {
                    "--_1h1y5xv": (0, $43MIc.default)((0, $jgJpJ.fontSize).xs)
                },
                children: helperText
            }) : null
        ]
    });
};
const $4eb3c441df9b5efd$var$containerCss = null;
const $4eb3c441df9b5efd$var$inputCss = null;
const $4eb3c441df9b5efd$var$labelChildCss = null;
const $4eb3c441df9b5efd$var$buttonCss = null;
const $4eb3c441df9b5efd$var$supportingText = null;
const $4eb3c441df9b5efd$var$helpTextCss = null;
const $4eb3c441df9b5efd$var$errorMessageCss = null;
const $4eb3c441df9b5efd$var$inputInvalidCss = null;
const $4eb3c441df9b5efd$var$inputValidCss = null;

});

parcelRegister("6dDlC", function(module, exports) {

$parcel$export(module.exports, "SignupDefault", function () { return $151bc48420452b03$export$f40c117d87f58af; });

var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $dhmEV = parcelRequire("dhmEV");

var $fbaQ6 = parcelRequire("fbaQ6");

var $4KDmv = parcelRequire("4KDmv");

var $lrVTP = parcelRequire("lrVTP");

const $151bc48420452b03$var$SignUpLayoutContainer = /*#__PURE__*/ (0, $iSvIT.lazy)(()=>// @ts-ignore
    (parcelRequire("9Qzri")));
const $151bc48420452b03$export$f40c117d87f58af = ()=>{
    const location = (0, $lrVTP.useLocation)();
    const labels = (0, $fbaQ6.useLabelsLocalized)((0, $fbaQ6.defaultLabels));
    var _location_search;
    const { bundle: bundle, edition: edition, layout: layout } = (0, $fbaQ6.getQueryParams)((_location_search = location === null || location === void 0 ? void 0 : location.search) !== null && _location_search !== void 0 ? _location_search : "");
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $4KDmv.ClientOnly), {
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dhmEV.default), {
            intentType: "form",
            productKey: bundle,
            edition: edition,
            children: /*#__PURE__*/ (0, $loA2J.jsx)($151bc48420452b03$var$SignUpLayoutContainer, {
                layout: layout,
                allowSignupWithGoogle: true,
                allowSignupWithAllSocialOptions: true,
                bundleOverride: bundle,
                editionOverride: edition,
                productData: (0, $fbaQ6.defaultProductData),
                enableFreeBreachTest: true,
                labels: labels,
                firstImpressionsImageUrls: (0, $fbaQ6.firstImpressionsImageUrls),
                featureFlags: (0, $fbaQ6.defaultFeatureFlags)
            })
        })
    });
};

});
parcelRegister("9Qzri", function(module, exports) {












module.exports = Promise.all([
    (parcelRequire("frKV3"))((parcelRequire("hzK4Z")).resolve("jc5H5")),
    (parcelRequire("frKV3"))((parcelRequire("hzK4Z")).resolve("h8hZK")),
    (parcelRequire("frKV3"))((parcelRequire("hzK4Z")).resolve("8KBcn")),
    (parcelRequire("frKV3"))((parcelRequire("hzK4Z")).resolve("fr48Q")),
    (parcelRequire("frKV3"))((parcelRequire("hzK4Z")).resolve("2waUd")),
    (parcelRequire("frKV3"))((parcelRequire("hzK4Z")).resolve("639I8"))
]).then(()=>parcelRequire("60TN5"));

});
parcelRegister("frKV3", function(module, exports) {
"use strict";

var $jhlcP = parcelRequire("jhlcP");
module.exports = $jhlcP(function(bundle) {
    return new Promise(function(resolve, reject) {
        // Add a global function to handle when the script loads.
        var globalName = "i".concat(("" + Math.random()).slice(2));
        $parcel$global[globalName] = function(m) {
            resolve(m);
            cleanup();
        };
        // Remove script on load or error
        var cleanup = function() {
            delete $parcel$global[globalName];
            script.onerror = null;
            script.remove();
        };
        // Append an inline script tag into the document head
        var script = document.createElement("script");
        script.async = true;
        script.type = "module";
        script.charset = "utf-8";
        script.textContent = "import * as m from '".concat(bundle, "'; ").concat(globalName, "(m);");
        script.onerror = function(e) {
            reject(e);
            cleanup();
        };
        document.head.appendChild(script);
    });
});

});
parcelRegister("jhlcP", function(module, exports) {
"use strict";
var $039f3a07df33262a$var$cachedBundles = {};
var $039f3a07df33262a$var$cachedPreloads = {};
var $039f3a07df33262a$var$cachedPrefetches = {};
function $039f3a07df33262a$var$getCache(type) {
    switch(type){
        case "preload":
            return $039f3a07df33262a$var$cachedPreloads;
        case "prefetch":
            return $039f3a07df33262a$var$cachedPrefetches;
        default:
            return $039f3a07df33262a$var$cachedBundles;
    }
}
module.exports = function(loader, type) {
    return function(bundle) {
        var cache = $039f3a07df33262a$var$getCache(type);
        if (cache[bundle]) return cache[bundle];
        return cache[bundle] = loader.apply(null, arguments).catch(function(e) {
            delete cache[bundle];
            throw e;
        });
    };
};

});


parcelRegister("hzK4Z", function(module, exports) {

$parcel$export(module.exports, "register", function () { return $ccb972f8f1c5733b$export$6503ec6e8aabbaf; }, function (v) { return $ccb972f8f1c5733b$export$6503ec6e8aabbaf = v; });
$parcel$export(module.exports, "resolve", function () { return $ccb972f8f1c5733b$export$f7ad0328861e2f03; }, function (v) { return $ccb972f8f1c5733b$export$f7ad0328861e2f03 = v; });
var $ccb972f8f1c5733b$export$6503ec6e8aabbaf;
var $ccb972f8f1c5733b$export$f7ad0328861e2f03;
"use strict";
var $ccb972f8f1c5733b$var$mapping = new Map();
function $ccb972f8f1c5733b$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$ccb972f8f1c5733b$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $ccb972f8f1c5733b$var$resolve(id) {
    var resolved = $ccb972f8f1c5733b$var$mapping.get(id);
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$ccb972f8f1c5733b$export$6503ec6e8aabbaf = $ccb972f8f1c5733b$var$register;
$ccb972f8f1c5733b$export$f7ad0328861e2f03 = $ccb972f8f1c5733b$var$resolve;

});



parcelRegister("esacZ", function(module, exports) {

$parcel$export(module.exports, "JPDGetStartedHeading", function () { return $8d8e8366d588f10d$export$1c65fb7cfb572551; });
$parcel$export(module.exports, "Heading", function () { return $8d8e8366d588f10d$export$a8a3e93435678ff9; });
$parcel$export(module.exports, "GetStartedHeading", function () { return $8d8e8366d588f10d$export$32ef2fbdeab4d330; });
/* get-started-heading.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $dFnC9 = parcelRequire("dFnC9");

var $5ohHq = parcelRequire("5ohHq");
const $8d8e8366d588f10d$export$1c65fb7cfb572551 = ()=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)($8d8e8366d588f10d$export$a8a3e93435678ff9, {
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
            id: "BxpSignup.accountCreation.cobrandedHeader.jpd",
            defaultMessage: "Get <scribbleSpan>started</scribbleSpan> with{br}Jira Product Discovery",
            values: {
                br: /*#__PURE__*/ (0, $loA2J.jsx)("br", {}),
                scribbleSpan: $8d8e8366d588f10d$var$scribbleSpan
            }
        })
    });
};
const $8d8e8366d588f10d$export$32ef2fbdeab4d330 = ({ productName: productName })=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)($8d8e8366d588f10d$export$a8a3e93435678ff9, {
        children: productName ? /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
            id: "BxpSignup.accountCreation.cobrandedHeader",
            defaultMessage: "Get <scribbleSpan>started</scribbleSpan> with {productName}",
            values: {
                scribbleSpan: $8d8e8366d588f10d$var$scribbleSpan,
                productName: productName
            }
        }) : /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
            id: "BxpSignup.accountCreation.cobrandedHeader.noProductName",
            defaultMessage: "Get <scribbleSpan>started</scribbleSpan>",
            values: {
                scribbleSpan: $8d8e8366d588f10d$var$scribbleSpan
            }
        })
    });
};
const $8d8e8366d588f10d$export$a8a3e93435678ff9 = ({ children: children })=>/*#__PURE__*/ (0, $loA2J.jsx)("h1", {
        className: (0, $esG4f.default)([
            "_syaz1hlo _ect41pz4 _1wybzwfg _k48p1fw0 _vwz410nf _19pkbh6h _2hwxidpf _otyrbh6h _18u0idpf _y3gn1h6o"
        ]),
        style: {
            "--_188070z": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.primary.black")),
            "--_1h6bnby": (0, $43MIc.default)((0, $5ohHq.wacToken)("font.charlie.display"))
        },
        children: children
    });
const $8d8e8366d588f10d$var$scribbleSpan = (children)=>/*#__PURE__*/ (0, $loA2J.jsxs)("span", {
        className: (0, $esG4f.default)([
            "_kqswh2mm"
        ]),
        children: [
            children,
            /*#__PURE__*/ (0, $loA2J.jsx)("svg", {
                "aria-hidden": true,
                viewBox: "0 0 105 17",
                className: (0, $esG4f.default)([
                    "_lswu6nkb _4t3io7ao _u7co1bs0 _1e02idpf _kqswstnw _t9ec1bh4 _1bsb1l8a"
                ]),
                style: {
                    "--_1vwzriw": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.primary.yellow"))
                },
                children: /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                    d: "M104.435 9.68613C86.4938 6.51631 73.1262 13.83 55.0489 7.43996C54.1658 10.0608 51.9298 13.3276 48.6487 13.3318C51.3855 13.3082 55.8543 6.49074 51.3954 11.0379C48.7638 14.5108 37.5257 10.0724 46.1409 13.2376C40.1743 12.5113 34.7527 8.16936 30.7652 4.31768C24.1184 -1.18196 29.0775 9.35501 24.148 14.5541C17.1646 21.7785 -3.47552 2.46837 0.735557 2.51293C3.38441 4.93365 6.96197 6.46719 8.41505 9.13148C34.4142 25.1383 15.8926 -4.08831 31.4374 0.975475C56.6666 21.4402 44.0238 3.05288 58.9761 4.49783C67.6031 11.908 104.856 0.972575 104.442 9.68622L104.435 9.68613Z"
                })
            })
        ]
    });
const $8d8e8366d588f10d$var$accentImageCss = null;
const $8d8e8366d588f10d$var$scribbleSpanCss = null;
const $8d8e8366d588f10d$var$h1Css = null; /**
                     * preserves the product name on one line when possible, but doesn't overflow the container (which white-space: nowrap would do)
                     *
                     * Get started with Jira: one line
                     * Get started with Service Collection: two lines
                     * Get started with Service Collection Ultra Premium Edition Plus: three lines
                     */ 
// @ts-ignore
const $8d8e8366d588f10d$var$productNameCss = null;

});

parcelRegister("3CPhp", function(module, exports) {

$parcel$export(module.exports, "CreateASiteHeading", function () { return $099b44ba7e5bf81c$export$579c0fd7de5e1861; });
/* create-a-site-heading.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $dFnC9 = parcelRequire("dFnC9");

var $5ohHq = parcelRequire("5ohHq");
const $099b44ba7e5bf81c$export$579c0fd7de5e1861 = ()=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        className: (0, $esG4f.default)([
            "_syaz1hlo"
        ]),
        style: {
            "--_188070z": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.primary.black"))
        },
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
            id: "signupForm.accountCreation.cobrandedLoggedOutHeader",
            defaultMessage: `Create a <accentImage>site</accentImage>`,
            values: {
                accentImage: $099b44ba7e5bf81c$var$accentImage
            }
        })
    });
};
const $099b44ba7e5bf81c$var$accentImage = (children)=>/*#__PURE__*/ (0, $loA2J.jsxs)("span", {
        className: (0, $esG4f.default)([
            "_kqswh2mm"
        ]),
        children: [
            children,
            /*#__PURE__*/ (0, $loA2J.jsxs)("svg", {
                "aria-hidden": "true",
                viewBox: "0 0 57 52",
                className: (0, $esG4f.default)([
                    "_lswuh727 _4t3i1ex1 _152td439 _rjxp1muf _kqswstnw _1bsb1mcy"
                ]),
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                        d: "M43.9096 31.989C44.2964 32.1979 50.1032 30.4768 48.3209 29.7729C47.7086 29.434 47.1876 29.537 47.0824 30.1563C46.7711 29.0152 45.8277 30.6914 45.2428 30.3744C45.338 29.5426 43.9174 31.4167 44.1295 30.5384C37.6167 30.3944 25.6493 39.724 40.8255 33.2041C39.218 33.0188 40.6554 32.5298 41.3794 32.6287C40.4962 33.7793 43.3258 32.5457 43.8251 32.1261C42.9181 32.2503 44.3277 31.315 43.9065 31.9866L43.9096 31.989Z"
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                        d: "M31.1742 23.4941C32.0038 23.3481 34.8483 17.2583 35.2257 16.6666C35.7963 15.2515 33.8616 15.3637 33.6797 16.5353C33.5454 16.7474 33.1876 18.4271 32.7181 17.7781C31.123 18.3209 31.2287 21.2383 29.8684 21.5744C30.1331 21.9302 29.6966 22.4398 29.8375 22.6819C29.4217 22.6843 29.2562 23.2605 29.3603 23.2987C27.7702 24.9228 30.1396 26.3595 30.8463 24.2051C30.9274 24.2847 31.3634 23.8695 31.1748 23.4996L31.1742 23.4941Z"
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                        d: "M8.6666 15.2222C8.02491 16.2514 7.96222 15.2487 8.28065 14.7497C9.05234 15.52 8.82473 13.5428 8.54045 13.0616C8.52243 13.2717 8.17 13.3446 8.18227 12.9105C9.08124 13.2088 9.17211 7.72002 7.35544 10.3155C7.36042 10.4093 8.06672 10.4491 7.84889 10.5596C6.77715 10.3778 7.53675 11.2383 7.62227 11.4811C7.06702 11.477 7.58662 11.707 7.35778 11.7688C6.60614 11.4733 7.8784 12.8725 7.13341 12.5375C6.01834 13.7974 7.55678 16.2818 6.53876 17.2452C7.79737 17.9053 5.99454 21.9334 8.35492 20.3752C8.8673 18.6393 9.14873 17.2179 8.6666 15.2222Z"
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                        d: "M21.257 4.74268C19.536 4.31212 19.9685 8.08877 19.2823 9.11742C18.2988 10.3626 15.0337 23.7231 18.3519 20.2458C19.306 16.1939 20.7963 13.0387 21.3321 7.97975C21.4791 7.16432 22.4539 4.63025 21.257 4.74268Z"
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                        d: "M37.0965 44.953C36.1393 46.3589 34.6992 44.6262 33.7861 45.783C32.4207 48.0004 45.1215 48.6579 44.6732 46.3948C44.025 44.501 38.0156 45.7761 37.0965 44.953Z"
                    })
                ]
            })
        ]
    });
const $099b44ba7e5bf81c$var$accentImageCss = null;
const $099b44ba7e5bf81c$var$scribbleSpanCss = null;
const $099b44ba7e5bf81c$var$headingCss = null;

});

parcelRegister("eZrnm", function(module, exports) {

$parcel$export(module.exports, "NoCreditCardRequired", function () { return $d6ce1f7820310693$export$fcb2a6b9b0e7a09a; });
/* no-credit-card-required.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $f6qj2 = parcelRequire("f6qj2");
const $d6ce1f7820310693$export$fcb2a6b9b0e7a09a = ()=>{
    const { formatMessage: formatMessage } = (0, $f6qj2.default)();
    return /*#__PURE__*/ (0, $loA2J.jsx)("p", {
        className: (0, $esG4f.default)([
            "_1wybdlk8 _k48pbfng _1dyzt94y _19pkzwfg _2hwxidpf _otyrzwfg _18u0idpf _y3gn1h6o _1p1dangw"
        ]),
        children: formatMessage({
            id: "WacSignupForm.FirstImpressions.noCreditCardRequiredFooter",
            defaultMessage: "No credit card required"
        })
    });
};
const $d6ce1f7820310693$var$noCreditCardRequiredCss = null;

});

parcelRegister("587P6", function(module, exports) {

$parcel$export(module.exports, "SubmitButtonExistingUser", function () { return $c05bbaf8b796fbd5$export$e9e0ae87001e8e1b; });

var $loA2J = parcelRequire("loA2J");

var $f6qj2 = parcelRequire("f6qj2");

var $fsv0y = parcelRequire("fsv0y");
const $c05bbaf8b796fbd5$export$e9e0ae87001e8e1b = ()=>{
    const intl = (0, $f6qj2.default)();
    const submitMessage = intl.formatMessage({
        id: "WacSignupForm.FirstImpressions.submitButtonLabel",
        defaultMessage: "Agree"
    });
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $fsv0y.SubmitButton), {
        submitMessage: submitMessage
    });
};

});

parcelRegister("cHXak", function(module, exports) {

$parcel$export(module.exports, "InputEmail", function () { return $a343063f24483feb$export$497a6aaf7dad75ee; });
/* input-email.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $dFnC9 = parcelRequire("dFnC9");

var $6IiXU = parcelRequire("6IiXU");

var $26kkA = parcelRequire("26kkA");

var $7OGW4 = parcelRequire("7OGW4");

var $jgJpJ = parcelRequire("jgJpJ");

var $5ohHq = parcelRequire("5ohHq");
const $a343063f24483feb$export$497a6aaf7dad75ee = ({ email: email })=>{
    return email ? /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $26kkA.default), {
                isDisabled: true,
                name: "email",
                label: /*#__PURE__*/ (0, $loA2J.jsx)("span", {
                    className: (0, $esG4f.default)([
                        "_syaz1hlo _ect4bzd7 _1wybdlk8 _k48p1nn1"
                    ]),
                    style: {
                        "--_188070z": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.primary.black")),
                        "--_1ikmwd8": (0, $43MIc.default)((0, $5ohHq.wacToken)("font.charlie.text"))
                    },
                    children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                        id: "BxpUiSignup.nameSite.inputEmailLabel",
                        defaultMessage: "Work email"
                    })
                }),
                children: ({ fieldProps: fieldProps })=>/*#__PURE__*/ (0, $loA2J.jsx)("div", {
                        className: (0, $esG4f.default)([
                            "_1cgv7vkz _1b7z1nn1 _jxt4bzd7 _1f3hi2wt _nrq3ftgi _1npwi2wt _aszrftgi"
                        ]),
                        style: {
                            "--_1ikmwd8": (0, $43MIc.default)((0, $5ohHq.wacToken)("font.charlie.text"))
                        },
                        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $7OGW4.default), (0, $6iHNw._)((0, $7Knp0._)({
                            type: "text"
                        }, fieldProps), {
                            value: email
                        }))
                    })
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $6IiXU.default), {
                appearance: "link",
                onClick: ()=>{
                    window.location.href = (0, $jgJpJ.getSwitchAccountUrl)();
                },
                className: (0, $esG4f.default)([
                    "_18zrgrf3"
                ]),
                children: /*#__PURE__*/ (0, $loA2J.jsx)("span", {
                    className: (0, $esG4f.default)([
                        "_1wyb8oy7 _syazrbzz"
                    ]),
                    style: {
                        "--_djwknj": (0, $43MIc.default)((0, $jgJpJ.fontSize).sm)
                    },
                    children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                        id: "BxpUiSignup.nameSite.switchAccountText",
                        defaultMessage: "Sign in with a different Atlassian account"
                    })
                })
            })
        ]
    }) : null;
};
const $a343063f24483feb$var$inputCss = null;
const $a343063f24483feb$var$labelCss = null;
const $a343063f24483feb$var$switchAccountCss = null;
const $a343063f24483feb$var$switchAccountInnerCss = null;

});

parcelRegister("d5Q1l", function(module, exports) {

$parcel$export(module.exports, "CreateAWorkspaceHeading", function () { return $7c3f2853de56ed1d$export$e5bbc44a458bfe26; });
/* create-a-workspace-heading.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $dFnC9 = parcelRequire("dFnC9");

var $5ohHq = parcelRequire("5ohHq");
const $7c3f2853de56ed1d$export$e5bbc44a458bfe26 = ()=>/*#__PURE__*/ (0, $loA2J.jsx)("h1", {
        className: (0, $esG4f.default)([
            "_1wybzwfg _k48p1fw0 _vwz410nf _19pkbh6h _2hwxidpf _otyrbh6h _18u0idpf _y3gn1h6o"
        ]),
        children: /*#__PURE__*/ (0, $loA2J.jsxs)("span", {
            className: (0, $esG4f.default)([
                "_kqswh2mm"
            ]),
            children: [
                /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                    id: "signup.createAWorkspace",
                    defaultMessage: "Create a workspace"
                }),
                /*#__PURE__*/ (0, $loA2J.jsxs)("svg", {
                    "aria-hidden": "true",
                    viewBox: "0 0 57 52",
                    className: (0, $esG4f.default)([
                        "_lswu6nkb _4t3i1ex1 _u7co1y44 _rjxp1muf _kqswstnw _1bsb1mcy"
                    ]),
                    style: {
                        "--_1vwzriw": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.primary.yellow"))
                    },
                    children: [
                        /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                            d: "M43.9096 31.989C44.2964 32.1979 50.1032 30.4768 48.3209 29.7729C47.7086 29.434 47.1876 29.537 47.0824 30.1563C46.7711 29.0152 45.8277 30.6914 45.2428 30.3744C45.338 29.5426 43.9174 31.4167 44.1295 30.5384C37.6167 30.3944 25.6493 39.724 40.8255 33.2041C39.218 33.0188 40.6554 32.5298 41.3794 32.6287C40.4962 33.7793 43.3258 32.5457 43.8251 32.1261C42.9181 32.2503 44.3277 31.315 43.9065 31.9866L43.9096 31.989Z"
                        }),
                        /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                            d: "M31.1742 23.4941C32.0038 23.3481 34.8483 17.2583 35.2257 16.6666C35.7963 15.2515 33.8616 15.3637 33.6797 16.5353C33.5454 16.7474 33.1876 18.4271 32.7181 17.7781C31.123 18.3209 31.2287 21.2383 29.8684 21.5744C30.1331 21.9302 29.6966 22.4398 29.8375 22.6819C29.4217 22.6843 29.2562 23.2605 29.3603 23.2987C27.7702 24.9228 30.1396 26.3595 30.8463 24.2051C30.9274 24.2847 31.3634 23.8695 31.1748 23.4996L31.1742 23.4941Z"
                        }),
                        /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                            d: "M8.6666 15.2222C8.02491 16.2514 7.96222 15.2487 8.28065 14.7497C9.05234 15.52 8.82473 13.5428 8.54045 13.0616C8.52243 13.2717 8.17 13.3446 8.18227 12.9105C9.08124 13.2088 9.17211 7.72002 7.35544 10.3155C7.36042 10.4093 8.06672 10.4491 7.84889 10.5596C6.77715 10.3778 7.53675 11.2383 7.62227 11.4811C7.06702 11.477 7.58662 11.707 7.35778 11.7688C6.60614 11.4733 7.8784 12.8725 7.13341 12.5375C6.01834 13.7974 7.55678 16.2818 6.53876 17.2452C7.79737 17.9053 5.99454 21.9334 8.35492 20.3752C8.8673 18.6393 9.14873 17.2179 8.6666 15.2222Z"
                        }),
                        /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                            d: "M21.257 4.74268C19.536 4.31212 19.9685 8.08877 19.2823 9.11742C18.2988 10.3626 15.0337 23.7231 18.3519 20.2458C19.306 16.1939 20.7963 13.0387 21.3321 7.97975C21.4791 7.16432 22.4539 4.63025 21.257 4.74268Z"
                        }),
                        /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                            d: "M37.0965 44.953C36.1393 46.3589 34.6992 44.6262 33.7861 45.783C32.4207 48.0004 45.1215 48.6579 44.6732 46.3948C44.025 44.501 38.0156 45.7761 37.0965 44.953Z"
                        })
                    ]
                })
            ]
        })
    });
const $7c3f2853de56ed1d$var$accentImageCss = null;
const $7c3f2853de56ed1d$var$accentImageParentCss = null;
const $7c3f2853de56ed1d$var$headingCss = null;

});

parcelRegister("8MW6j", function(module, exports) {

$parcel$export(module.exports, "SubHeading", function () { return $7a82930c0e44530d$export$210dc657affc8afd; });
/* sub-heading.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
const $7a82930c0e44530d$export$210dc657affc8afd = ({ children: children })=>/*#__PURE__*/ (0, $loA2J.jsx)("p", {
        className: (0, $esG4f.default)([
            "_19pkftgi _2hwxidpf _otyr7vkz _18u0idpf _y3gn1h6o"
        ]),
        children: children
    });
const $7a82930c0e44530d$var$subheadingCss = null;

});

parcelRegister("fy2K0", function(module, exports) {

$parcel$export(module.exports, "WelcomeBackHeading", function () { return $f528694145333a59$export$f8a24991e7eb3d8f; });
/* welcome-back-heading.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $dFnC9 = parcelRequire("dFnC9");

var $jgJpJ = parcelRequire("jgJpJ");

var $iMdoL = parcelRequire("iMdoL");

var $5ohHq = parcelRequire("5ohHq");
const $f528694145333a59$export$f8a24991e7eb3d8f = ()=>{
    const { user: user } = (0, $iMdoL.useUserContext)();
    if (!user.isUserLoggedIn) return null;
    const name = (0, $jgJpJ.getFirstName)(user.name);
    return /*#__PURE__*/ (0, $loA2J.jsx)("h1", {
        className: (0, $esG4f.default)([
            "_1wybzwfg _k48p1fw0 _vwz410nf _19pkbh6h _2hwxidpf _otyrbh6h _18u0idpf _y3gn1h6o"
        ]),
        children: name.length ? /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
            id: "BxpSignup.SiteExpansionForm.cobrandedHeader",
            defaultMessage: "<scribbleSpan>Welcome</scribbleSpan> back, {name}",
            values: {
                name: name,
                scribbleSpan: $f528694145333a59$var$scribbleSpan
            }
        }) : /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
            id: "signup.welcomeBackNoName",
            defaultMessage: "<scribbleSpan>Welcome</scribbleSpan> back",
            values: {
                scribbleSpan: $f528694145333a59$var$scribbleSpan
            }
        })
    });
};
const $f528694145333a59$var$scribbleSpan = (children)=>/*#__PURE__*/ (0, $loA2J.jsxs)("span", {
        className: (0, $esG4f.default)([
            "_kqswh2mm"
        ]),
        children: [
            children,
            /*#__PURE__*/ (0, $loA2J.jsx)("svg", {
                "aria-hidden": true,
                viewBox: "0 0 105 17",
                className: (0, $esG4f.default)([
                    "_lswu6nkb _4t3io7ao _u7co1bs0 _1e02idpf _kqswstnw _t9ec1bh4 _1bsb1l8a"
                ]),
                style: {
                    "--_1vwzriw": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.primary.yellow"))
                },
                children: /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                    d: "M104.435 9.68613C86.4938 6.51631 73.1262 13.83 55.0489 7.43996C54.1658 10.0608 51.9298 13.3276 48.6487 13.3318C51.3855 13.3082 55.8543 6.49074 51.3954 11.0379C48.7638 14.5108 37.5257 10.0724 46.1409 13.2376C40.1743 12.5113 34.7527 8.16936 30.7652 4.31768C24.1184 -1.18196 29.0775 9.35501 24.148 14.5541C17.1646 21.7785 -3.47552 2.46837 0.735557 2.51293C3.38441 4.93365 6.96197 6.46719 8.41505 9.13148C34.4142 25.1383 15.8926 -4.08831 31.4374 0.975475C56.6666 21.4402 44.0238 3.05288 58.9761 4.49783C67.6031 11.908 104.856 0.972575 104.442 9.68622L104.435 9.68613Z"
                })
            })
        ]
    });
const $f528694145333a59$var$accentImageCss = null;
const $f528694145333a59$var$headingCss = null;
const $f528694145333a59$var$scribbleSpanCss = null;

});

parcelRegister("jN1Op", function(module, exports) {

$parcel$export(module.exports, "SubmitButtonMessageNext", function () { return $007e5d46701ea037$export$eab894fbb6777d1c; });

var $loA2J = parcelRequire("loA2J");

var $f6qj2 = parcelRequire("f6qj2");

var $fsv0y = parcelRequire("fsv0y");
const $007e5d46701ea037$export$eab894fbb6777d1c = ()=>{
    const intl = (0, $f6qj2.default)();
    const submitMessage = intl.formatMessage({
        id: "WacSignupForm.upgradeButtonText.messageNext",
        defaultMessage: "Next"
    });
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $fsv0y.SubmitButton), {
        submitMessage: submitMessage
    });
};

});


parcelRegister("8rBqG", function(module, exports) {

$parcel$export(module.exports, "ConfluenceSignup", function () { return $48072b14425f892a$export$50998478fcad0009; });

var $loA2J = parcelRequire("loA2J");

var $iMdoL = parcelRequire("iMdoL");

var $6ScjV = parcelRequire("6ScjV");

var $6ZE25 = parcelRequire("6ZE25");
const $48072b14425f892a$export$50998478fcad0009 = ()=>{
    const { user: { isUserLoggedIn: isUserLoggedIn } } = (0, $iMdoL.useUserContext)();
    if (isUserLoggedIn) return /*#__PURE__*/ (0, $loA2J.jsx)((0, $6ScjV.LoggedInConfluence), {});
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $6ZE25.LoggedOutConfluence), {});
};

});
parcelRegister("6ScjV", function(module, exports) {

$parcel$export(module.exports, "LoggedInConfluence", function () { return $3f8ec453c310ce69$export$7899443e35ffdb87; });

var $loA2J = parcelRequire("loA2J");

var $iMdoL = parcelRequire("iMdoL");
parcelRequire("dHmj2");
var $eVx24 = parcelRequire("eVx24");
parcelRequire("5pqoK");
var $8Bkbe = parcelRequire("8Bkbe");
parcelRequire("STWoZ");
var $4pojm = parcelRequire("4pojm");
const $3f8ec453c310ce69$export$7899443e35ffdb87 = ()=>{
    const isStandard = (0, $iMdoL.useStandardIntent)();
    const isPremium = (0, $iMdoL.usePremiumIntent)();
    if (isStandard) return /*#__PURE__*/ (0, $loA2J.jsx)((0, $4pojm.LoggedInConfluenceStandard), {});
    if (isPremium) return /*#__PURE__*/ (0, $loA2J.jsx)((0, $8Bkbe.LoggedInConfluencePremium), {});
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $eVx24.LoggedInConfluenceFree), {});
};

});
parcelRegister("dHmj2", function(module, exports) {
$parcel$export(module.exports, "LoggedInConfluenceFree", function () { return (parcelRequire("eVx24")).LoggedInConfluenceFree; });
parcelRequire("eVx24");

});
parcelRegister("eVx24", function(module, exports) {

$parcel$export(module.exports, "LoggedInConfluenceFree", function () { return $49eafbfc598ebcd6$export$6f1d4f9d0052bd8d; });
/* logged-in-confluence-free.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $dFnC9 = parcelRequire("dFnC9");
parcelRequire("2BIIq");
var $3yLXo = parcelRequire("3yLXo");

var $iu8Ap = parcelRequire("iu8Ap");

var $47Euo = parcelRequire("47Euo");

var $iMdoL = parcelRequire("iMdoL");

var $4KDmv = parcelRequire("4KDmv");

var $1MbAx = parcelRequire("1MbAx");

var $gAJUc = parcelRequire("gAJUc");
parcelRequire("ia5W9");
var $d5Q1l = parcelRequire("d5Q1l");
var $8MW6j = parcelRequire("8MW6j");
var $fy2K0 = parcelRequire("fy2K0");
const $49eafbfc598ebcd6$export$6f1d4f9d0052bd8d = ()=>{
    const isNewUser = (0, $iMdoL.useNewUser)();
    if ((0, $gAJUc.checkFeatureFlagGate)((0, $gAJUc.featureFlags).signupModuleDeprecation)) return /*#__PURE__*/ (0, $loA2J.jsx)((0, $1MbAx.FeatureExposed), {
        experimentKey: "cfind-3467-signup-with-image-overlay",
        group: "isTreatment",
        children: /*#__PURE__*/ (0, $loA2J.jsxs)((0, $iu8Ap.ConfluenceOverlayTemplate), {
            size: "sm",
            children: [
                /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                    className: (0, $esG4f.default)([
                        "_1pfh1l27 _kiyaidpf"
                    ]),
                    children: isNewUser ? /*#__PURE__*/ (0, $loA2J.jsxs)((0, $loA2J.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $loA2J.jsx)((0, $d5Q1l.CreateAWorkspaceHeading), {}),
                            /*#__PURE__*/ (0, $loA2J.jsx)((0, $8MW6j.SubHeading), {
                                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                                    id: "BxpUiSignup.nameSite.subHeader.newWorkspaceSubHeader",
                                    defaultMessage: "This is the URL for your team to access Confluence. Most people use their team or company name."
                                })
                            })
                        ]
                    }) : /*#__PURE__*/ (0, $loA2J.jsxs)((0, $loA2J.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $loA2J.jsx)((0, $fy2K0.WelcomeBackHeading), {}),
                            /*#__PURE__*/ (0, $loA2J.jsx)((0, $8MW6j.SubHeading), {
                                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                                    id: "BxpUiSignup.nameSite.cobrandedSubHeader",
                                    defaultMessage: "It\u2019s free for up to 10 users - no credit card needed."
                                })
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)((0, $47Euo.default), {})
            ]
        })
    });
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $4KDmv.ClientOnly), {
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $3yLXo.default), {
            bundle: "confluence",
            edition: "free",
            isNewUser: isNewUser
        })
    });
};
const $49eafbfc598ebcd6$var$headerOffsetForBlueBackgroundCss = null;

});
parcelRegister("2BIIq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return (parcelRequire("3yLXo")).default; });

var $3yLXo = parcelRequire("3yLXo");
parcelRequire("gyE5e");

});
parcelRegister("gyE5e", function(module, exports) {
parcelRequire("3NC3z");

});
parcelRegister("3NC3z", function(module, exports) {
/**
 *  @deprecated Use products.ts in @/components/signup/utils instead
 */ var $9dd947d645495257$export$c654666118e350a8;
(function(OrgBasedProduct) {
    OrgBasedProduct["GUARD_PREMIUM"] = "GUARD_PREMIUM";
    OrgBasedProduct["GUARD_PREMIUM_DEMO"] = "GUARD_PREMIUM_DEMO";
    OrgBasedProduct["GUARD_STANDARD"] = "GUARD_STANDARD";
    OrgBasedProduct["ROVO_ORG"] = "ROVO_ORG";
    OrgBasedProduct["ROVO_ORG_DEMO"] = "ROVO_ORG_DEMO";
    OrgBasedProduct["ROVO_ORG_FREE"] = "ROVO_ORG_FREE";
    OrgBasedProduct["TWC_ORG_FREE"] = "TWC_ORG_FREE";
    OrgBasedProduct["TWC_ORG_STANDARD"] = "TWC_ORG_STANDARD";
    OrgBasedProduct["TWC_ORG_PREMIUM"] = "TWC_ORG_PREMIUM";
    OrgBasedProduct["TWC_ORG_PREMIUM_BILLED_SEPARATELY"] = "TWC_ORG_PREMIUM_BILLED_SEPARATELY";
    OrgBasedProduct["TWC_ORG_ENTERPRISE"] = "TWC_ORG_ENTERPRISE";
    OrgBasedProduct["STRATEGY_ORG_ENTERPRISE"] = "STRATEGY_ORG_ENTERPRISE";
})($9dd947d645495257$export$c654666118e350a8 || ($9dd947d645495257$export$c654666118e350a8 = {}));
const $9dd947d645495257$export$470b3b1706479a64 = {
    GUARD_PREMIUM: "2f5e5808-d501-450a-b246-b0bd50a0b72a",
    GUARD_PREMIUM_DEMO: "2081c1b7-2ad6-3e40-a7c2-5a7f876a38a7",
    GUARD_STANDARD: "1ac3b7dd-7141-414e-bc00-c890acc458b0",
    ROVO_ORG: "e7de08be-3d20-423e-b928-dd1fd325da7a",
    ROVO_ORG_DEMO: "df531ba8-186a-3924-96a3-23056fa96f3f",
    ROVO_ORG_FREE: "71f2d378-1960-4336-8e7b-6af35174650c",
    TWC_ORG_STANDARD: "7e16cb96-ade2-4220-9010-c71ef9a70cf2",
    TWC_ORG_PREMIUM: "b296663a-50d7-4e51-bc53-be058da00dad",
    TWC_ORG_PREMIUM_BILLED_SEPARATELY: "17c64528-3ce0-3ce5-8d61-26726b323416",
    TWC_ORG_ENTERPRISE: "cf0b0103-2f08-4c87-97cf-a69448d6e69a",
    TWC_ORG_FREE: "666dec82-def0-4675-8abe-171d26c968a0",
    STRATEGY_ORG_ENTERPRISE: "b7da0afa-6941-4010-9c29-cc8739f6fbf8"
};
const $9dd947d645495257$export$a20d8b3133159060 = {
    [$9dd947d645495257$export$470b3b1706479a64.GUARD_PREMIUM]: "GUARD_PREMIUM",
    [$9dd947d645495257$export$470b3b1706479a64.GUARD_PREMIUM_DEMO]: "GUARD_PREMIUM_DEMO",
    [$9dd947d645495257$export$470b3b1706479a64.GUARD_STANDARD]: "GUARD_STANDARD",
    [$9dd947d645495257$export$470b3b1706479a64.ROVO_ORG]: "ROVO_ORG",
    [$9dd947d645495257$export$470b3b1706479a64.ROVO_ORG_DEMO]: "ROVO_ORG_DEMO",
    [$9dd947d645495257$export$470b3b1706479a64.ROVO_ORG_FREE]: "ROVO_ORG_FREE",
    [$9dd947d645495257$export$470b3b1706479a64.TWC_ORG_FREE]: "TWC_ORG_FREE",
    [$9dd947d645495257$export$470b3b1706479a64.TWC_ORG_STANDARD]: "TWC_ORG_STANDARD",
    [$9dd947d645495257$export$470b3b1706479a64.TWC_ORG_PREMIUM]: "TWC_ORG_PREMIUM",
    [$9dd947d645495257$export$470b3b1706479a64.TWC_ORG_PREMIUM_BILLED_SEPARATELY]: "TWC_ORG_PREMIUM_BILLED_SEPARATELY",
    [$9dd947d645495257$export$470b3b1706479a64.TWC_ORG_ENTERPRISE]: "TWC_ORG_ENTERPRISE",
    [$9dd947d645495257$export$470b3b1706479a64.STRATEGY_ORG_ENTERPRISE]: "STRATEGY_ORG_ENTERPRISE"
};

});





parcelRegister("5pqoK", function(module, exports) {
$parcel$export(module.exports, "LoggedInConfluencePremium", function () { return (parcelRequire("8Bkbe")).LoggedInConfluencePremium; });
parcelRequire("8Bkbe");

});
parcelRegister("8Bkbe", function(module, exports) {

$parcel$export(module.exports, "LoggedInConfluencePremium", function () { return $d5caba71b41ea744$export$b95b7dbaa2ce1828; });

var $loA2J = parcelRequire("loA2J");

var $f6qj2 = parcelRequire("f6qj2");
parcelRequire("25Gvl");
var $lRUWQ = parcelRequire("lRUWQ");
const $d5caba71b41ea744$export$b95b7dbaa2ce1828 = ()=>{
    const { formatMessage: formatMessage } = (0, $f6qj2.default)();
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $lRUWQ.LoggedInConfluenceBlueWaveTemplate), {
        productEditionText: formatMessage({
            id: "WacSignupHeader.cloudPremium",
            defaultMessage: "Cloud Premium"
        })
    });
};

});
parcelRegister("25Gvl", function(module, exports) {
$parcel$export(module.exports, "LoggedInConfluenceBlueWaveTemplate", function () { return (parcelRequire("lRUWQ")).LoggedInConfluenceBlueWaveTemplate; });
$parcel$export(module.exports, "UnderlineWord", function () { return (parcelRequire("4hS2F")).UnderlineWord; });
parcelRequire("lRUWQ");
parcelRequire("8D1yP");
parcelRequire("4hS2F");

});
parcelRegister("lRUWQ", function(module, exports) {

$parcel$export(module.exports, "LoggedInConfluenceBlueWaveTemplate", function () { return $7066d60b7125cd81$export$92826040495825a8; });
/* logged-in-confluence-blue-wave-template.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $dFnC9 = parcelRequire("dFnC9");
var $f6qj2 = parcelRequire("f6qj2");

var $2lKjb = parcelRequire("2lKjb");

var $iu8Ap = parcelRequire("iu8Ap");

var $47Euo = parcelRequire("47Euo");

var $jgJpJ = parcelRequire("jgJpJ");

var $2ompn = parcelRequire("2ompn");

var $bhreu = parcelRequire("bhreu");
parcelRequire("ia5W9");
var $cHXak = parcelRequire("cHXak");
var $jN1Op = parcelRequire("jN1Op");
var $587P6 = parcelRequire("587P6");
var $eZrnm = parcelRequire("eZrnm");
parcelRequire("ddK6j");
var $bS7zZ = parcelRequire("bS7zZ");

var $fUha7 = parcelRequire("fUha7");
const $7066d60b7125cd81$export$92826040495825a8 = ({ productEditionText: productEditionText })=>{
    const { formatMessage: formatMessage } = (0, $f6qj2.default)();
    const { user: user } = (0, $2ompn.useUserContext)(); // Upgradeable Standard Sites Experiment
    const existingSites = (0, $bS7zZ.useGetExistingSites)();
    if (!user.isUserLoggedIn) return null;
    const username = (0, $jgJpJ.getFirstName)(user.name);
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $iu8Ap.BlueWaveTemplate), {
        productEditionText: productEditionText,
        socialProofLogos: /*#__PURE__*/ (0, $loA2J.jsx)((0, $fUha7.HubspotDockerTwilioGoPro), {}),
        tagline: formatMessage({
            id: "WacSignupForm.signupOfferingIncludesFeaturesSocialProofTextConfluence",
            defaultMessage: "Trusted by over 75,000 teams worldwide"
        }),
        valueProps: formatMessage({
            id: "WacSignupForm.signupOfferingIncludesFeaturesFreeConfluence",
            defaultMessage: "Kickstart team collaboration{newline}Increase transparency{newline}Capture all the knowledge{newline}Build admirable content"
        }, {
            newline: "{newline}"
        }).split("{newline}"),
        productLogos: [
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $2lKjb.ConfluenceLogo), {
                appearance: "inverse",
                size: "xlarge"
            }, "jsm")
        ],
        illustration: /*#__PURE__*/ (0, $loA2J.jsx)((0, $bhreu.Picture), {
            image: {
                src: "https://atlassian.com/dam/jcr:12b69d08-6ae8-4b14-ac1c-f3092ccaff97/Confluence%20Hero.svg",
                alt: ""
            }
        }),
        children: /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
            className: (0, $esG4f.default)([
                "_1e0c11p5 _zulpftgi _6rthckbl"
            ]),
            children: [
                /*#__PURE__*/ (0, $loA2J.jsx)("h2", {
                    className: (0, $esG4f.default)([
                        "_1wyb1tcg _k48pbfng _19pkidpf _2hwxidpf _otyridpf _18u0idpf _y3gn1h6o"
                    ]),
                    children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                        id: "WacSignupForm.signupFormPersonalizedGreeting",
                        defaultMessage: "Welcome back, {username}",
                        values: {
                            username: username
                        }
                    })
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)((0, $cHXak.InputEmail), {
                    email: user.email
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)((0, $47Euo.default), {
                    existingSites: existingSites,
                    UpgradeEligibleUser: existingSites ? /*#__PURE__*/ (0, $loA2J.jsx)((0, $47Euo.UpgradeEligibleUser), {
                        SubmitButton: /*#__PURE__*/ (0, $loA2J.jsx)((0, $jN1Op.SubmitButtonMessageNext), {})
                    }) : undefined,
                    ExistingUser: /*#__PURE__*/ (0, $loA2J.jsx)((0, $47Euo.ExistingUser), {
                        SitePicker: /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                            className: (0, $esG4f.default)([
                                "_84yz1wa3 _eeia15se _5pvqc4v4"
                            ]),
                            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $47Euo.SitePicker), {})
                        }),
                        SubmitButton: /*#__PURE__*/ (0, $loA2J.jsx)((0, $587P6.SubmitButtonExistingUser), {})
                    })
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)((0, $eZrnm.NoCreditCardRequired), {})
            ]
        })
    });
};
const $7066d60b7125cd81$var$containerCss = null;
const $7066d60b7125cd81$var$siteActivationHeadingCss = null;
const $7066d60b7125cd81$var$sitePickerCss = null;

});
parcelRegister("ddK6j", function(module, exports) {
$parcel$export(module.exports, "useGetExistingSites", function () { return (parcelRequire("bS7zZ")).useGetExistingSites; });
parcelRequire("bS7zZ");

});
parcelRegister("bS7zZ", function(module, exports) {

$parcel$export(module.exports, "useGetExistingSites", function () { return $a893f4017e2ca8da$export$f04b45a3c19b7cf; });

var $iSvIT = parcelRequire("iSvIT");

var $iMdoL = parcelRequire("iMdoL");

var $9iWJ8 = parcelRequire("9iWJ8");
function $a893f4017e2ca8da$export$f04b45a3c19b7cf() {
    var _upgradeableStandardSites_, _upgradableSites_;
    const upgradeableStandardSites = (0, $iMdoL.useUpgradableStandardSites)();
    const upgradableSites = (0, $iMdoL.useUpgradableSites)();
    var _upgradeableStandardSites__cloudId, _ref;
    const suggestedSiteCloudId = (_ref = (_upgradeableStandardSites__cloudId = upgradeableStandardSites === null || upgradeableStandardSites === void 0 ? void 0 : (_upgradeableStandardSites_ = upgradeableStandardSites[0]) === null || _upgradeableStandardSites_ === void 0 ? void 0 : _upgradeableStandardSites_.cloudId) !== null && _upgradeableStandardSites__cloudId !== void 0 ? _upgradeableStandardSites__cloudId : upgradableSites === null || upgradableSites === void 0 ? void 0 : (_upgradableSites_ = upgradableSites[0]) === null || _upgradableSites_ === void 0 ? void 0 : _upgradableSites_.cloudId) !== null && _ref !== void 0 ? _ref : "";
    const upgradeS2pExperiment = (0, $9iWJ8.useExperiment)((0, $9iWJ8.experiments).twcg907Astro540WacUpgradeS2p, {
        suggestedSiteCloudId: suggestedSiteCloudId
    });
    return (0, $iSvIT.useMemo)(()=>{
        const isEnrolledInExperiment = upgradeS2pExperiment && upgradeS2pExperiment.type === "enrolled";
        return isEnrolledInExperiment && upgradeS2pExperiment.value === "variation" ? [
            ...upgradeableStandardSites !== null && upgradeableStandardSites !== void 0 ? upgradeableStandardSites : [],
            ...upgradableSites !== null && upgradableSites !== void 0 ? upgradableSites : []
        ] : undefined;
    }, [
        upgradeS2pExperiment,
        upgradeableStandardSites,
        upgradableSites
    ]);
}

});


parcelRegister("fUha7", function(module, exports) {

$parcel$export(module.exports, "HubspotDockerTwilioGoPro", function () { return $b905f5723a0e4c00$export$7314c49b0f4c7701; });

var $loA2J = parcelRequire("loA2J");
const $b905f5723a0e4c00$export$7314c49b0f4c7701 = ()=>/*#__PURE__*/ (0, $loA2J.jsxs)("svg", {
        "aria-hidden": true,
        viewBox: "0 0 300 40",
        fill: "currentColor",
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M15.1 13.87v5.11h-4.7v-5.11H8.18v12.2h2.22v-4.93h4.7v4.93h2.23v-12.2H15.1zM24.46 22.13a1.85 1.85 0 1 1-3.69 0v-5.22h-2.11v5.23a4 4 0 0 0 7.91 0v-5.23h-2.11v5.22ZM40.13 17.44A1.3 1.3 0 0 1 41.62 16a3.21 3.21 0 0 1 2 1.05L45 15.47a4.33 4.33 0 0 0-3.24-1.59c-2.29 0-4 1.35-4 3.58 0 4.12 5 2.81 5 5.13a1.45 1.45 0 0 1-1.48 1.34 2.58 2.58 0 0 1-2.23-1.25l-1.54 1.59a4.54 4.54 0 0 0 3.65 1.82c2.18 0 3.93-1.35 3.93-3.48 0-4.61-5.05-3.18-5-5.17M71.37 24.13c-1.24 0-1.6-.54-1.6-1.37v-3.67h1.94v-1.85h-1.94v-2.45l-2.14 1v7.46c0 1.91 1.32 2.87 3.12 2.87a5.83 5.83 0 0 0 .84-.06l.53-1.92h-.75M32.51 17A3.27 3.27 0 0 0 30 18v-4h-2.1v7.4a4.44 4.44 0 0 0 4.28 4.69 4.63 4.63 0 0 0 4.72-4.56A4.47 4.47 0 0 0 32.51 17m0 7a2.4 2.4 0 1 1 2.4-2.4A2.39 2.39 0 0 1 32.5 24M55.51 21.42a4.64 4.64 0 0 0-4.72-4.57 4.46 4.46 0 0 0-4.28 4.7V29h2.12v-4a3.26 3.26 0 0 0 2.48 1 4.49 4.49 0 0 0 4.4-4.55m-2 0A2.4 2.4 0 1 1 51.1 19a2.39 2.39 0 0 1 2.4 2.41"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M62.33 16.82v-2.11a1.62 1.62 0 0 0 .94-1.46v-.05a1.61 1.61 0 0 0-1.62-1.62A1.61 1.61 0 0 0 60 13.2v.05a1.62 1.62 0 0 0 .94 1.46v2.11a4.62 4.62 0 0 0-2.18 1L53 13.28a1.76 1.76 0 0 0 .06-.46 1.84 1.84 0 1 0-1.84 1.83 1.89 1.89 0 0 0 .9-.24l5.68 4.42a4.63 4.63 0 0 0 .07 5.2l-1.77 1.73a1.23 1.23 0 0 0-.42-.07 1.51 1.51 0 1 0 1.5 1.51 1.54 1.54 0 0 0-.06-.43l1.71-1.71a4.62 4.62 0 0 0 5.61-7.33 4.68 4.68 0 0 0-2.11-.91m-.71 6.93A2.37 2.37 0 1 1 64 21.38a2.37 2.37 0 0 1-2.37 2.37"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M205.15 15.36h-3a.15.15 0 0 0-.14.14v1.75a.15.15 0 0 0 .14.13h3a.15.15 0 0 0 .14-.13V15.5c.03-.07-.04-.14-.14-.14Zm0 2.61h-5.82a.27.27 0 0 0-.21.13l-.79 2.9v.14L197.4 18a.23.23 0 0 0-.21-.13h-2.26a.28.28 0 0 0-.2.13l-.86 2.85v.14-.07l-.34-1.41-.38-1.4a.22.22 0 0 0-.21-.14h-4.56v-2.44a.17.17 0 0 0-.2-.14l-2.88.9c-.1 0-.14.06-.14.13V18h-.75a.14.14 0 0 0-.14.13v2.2a.14.14 0 0 0 .14.13h.75v2.68c0 1.88 1 2.78 2.92 2.78a4.6 4.6 0 0 0 2.05-.45v-2.29c0-.11-.1-.14-.17-.14a1.83 1.83 0 0 1-.82.17c-.52 0-.79-.2-.79-.79v-2H190a.15.15 0 0 0 .13-.14v-1.8l2.16 7.17a.26.26 0 0 0 .21.13h2.4a.28.28 0 0 0 .2-.13l1-3.19.52 1.64.48 1.51a.22.22 0 0 0 .2.14h2.4a.3.3 0 0 0 .21-.14l2.19-7.2v7.2a.15.15 0 0 0 .14.14h2.91a.15.15 0 0 0 .14-.14v-7.47a.15.15 0 0 0-.14-.17Zm3.85-2.61h-3a.15.15 0 0 0-.14.14v10.11a.15.15 0 0 0 .14.14h3a.15.15 0 0 0 .14-.14V15.5a.15.15 0 0 0-.14-.14Zm3.88 0h-3a.15.15 0 0 0-.14.14v1.75a.15.15 0 0 0 .14.13h3a.15.15 0 0 0 .14-.13V15.5a.198.198 0 0 0-.19-.14Zm0 2.61h-2.91a.14.14 0 0 0-.14.13v7.51a.15.15 0 0 0 .14.14h2.91a.15.15 0 0 0 .14-.14v-7.47a.15.15 0 0 0-.23-.14Zm4.84-.18a4.19 4.19 0 0 0-4.39 4.08 4.38 4.38 0 0 0 8.74 0 4.15 4.15 0 0 0-4.44-4.08Zm1.23 4.08a1.25 1.25 0 0 1-1.23 1.34 1.31 1.31 0 0 1-1.27-1.37 1.25 1.25 0 0 1 1.23-1.34 1.32 1.32 0 0 1 1.18 1.37ZM173.57 12a8.57 8.57 0 1 0 8.57 8.57 8.57 8.57 0 0 0-8.57-8.57Zm0 14.88a6.31 6.31 0 1 1 6.31-6.31 6.29 6.29 0 0 1-6.31 6.31Z"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("circle", {
                cx: "175.7",
                cy: "18.45",
                r: "1.78"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("circle", {
                cx: "175.7",
                cy: "22.7",
                r: "1.78"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("circle", {
                cx: "171.45",
                cy: "22.7",
                r: "1.78"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("circle", {
                cx: "171.45",
                cy: "18.45",
                r: "1.78"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M258.39 17.53c1.32 0 1.95-.23 1.95-.69v-2.28c0-.46-.63-.69-1.95-.69h-2.83c-1.32 0-1.95.22-1.95.68v2.29c0 .46.63.68 1.95.68Zm0 1.09h-2.83q-3.54 0-3.54-1.86v-2.12c0-1.25 1.18-1.86 3.54-1.86h2.83c2.37 0 3.55.61 3.55 1.86v2.12c0 1.24-1.18 1.86-3.55 1.86Z"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M288.78 17.53h-2.84c-1.32 0-1.95-.23-1.95-.69v-2.28c0-.46.63-.69 1.95-.69h2.84c1.32 0 1.94.23 1.94.69v2.28c0 .46-.62.69-1.94.69Zm0 1.09q3.54 0 3.54-1.86v-2.12c0-1.25-1.18-1.86-3.54-1.86h-2.84c-2.36 0-3.54.61-3.54 1.86v2.12q0 1.86 3.54 1.86Z"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M250.38 16.73v-1.47c0-.31-.19-.46-.59-.46h-3.46a.6.6 0 0 0 0 1.19h2.37v.79c0 .23-.31.46-.82.6a4.23 4.23 0 0 1-1.12.12H243c-1.52 0-2.28-.25-2.28-.76V13c0-.5.92-.73 2.73-.73h1.07c.41 0 .61-.18.61-.55s-.2-.55-.61-.55h-1.53a7.61 7.61 0 0 0-2.5.36c-.86.29-1.44.81-1.44 1.48v3.72c0 .7.47 1.2 1.41 1.52a8 8 0 0 0 2.53.35h3.82a6.58 6.58 0 0 0 2.37-.38c.83-.33 1.25-.83 1.25-1.5"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M273.44 14.08c0 .6-.74.78-2.21.78h-5.94v-2.57h5.94c1.47 0 2.21.17 2.21.77Zm.23-2.58a8.78 8.78 0 0 0-2.44-.31h-7.15a.49.49 0 0 0-.48.48v6.46c0 .32.2.49.59.49h.5c.38 0 .59-.17.59-.49V16h6a7.62 7.62 0 0 0 2.51-.35c.92-.33 1.39-.87 1.39-1.61v-1.2c-.05-.59-.54-1.04-1.51-1.34Z"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M280.69 12.78a6.84 6.84 0 0 0-2.95.33 1.63 1.63 0 0 0-1.17 1.47v3.57c0 .31.19.47.57.47h.48c.37 0 .57-.16.57-.47v-3.57c0-.51.62-.72 1.84-.72h.69c.4 0 .59-.19.59-.54s-.21-.54-.62-.54"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M239 28.02h11.57v-7.58H239v7.58z"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M252.92 28.02h11.57v-7.58h-11.57v7.58z"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M266.83 28.02h11.57v-7.58h-11.57v7.58z"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M280.75 28.02h11.57v-7.58h-11.57v7.58z"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M117.38 16a.63.63 0 0 0-.66.61v3.19a3.52 3.52 0 0 0-5 .54 3.62 3.62 0 0 0-.77 2.22 3.53 3.53 0 1 0 7 .12v-6a.67.67 0 0 0-.18-.47.78.78 0 0 0-.49-.18m-.84 7.4a2.21 2.21 0 0 1-1.17 1.18 2.26 2.26 0 0 1-1.73 0 2.13 2.13 0 0 1-1.15-1.17 2.21 2.21 0 0 1 0-1.71 2.13 2.13 0 0 1 1.15-1.17 2.26 2.26 0 0 1 1.73 0 2.15 2.15 0 0 1 1.17 1.18 2.07 2.07 0 0 1 0 1.69"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M124.74 20.06a3.56 3.56 0 1 0 1.05 2.61v-.12a3.75 3.75 0 0 0-.27-1.36 3.52 3.52 0 0 0-.78-1.13m-.45 3.33a2.2 2.2 0 0 1-.48.69 2.29 2.29 0 0 1-.69.47 2.26 2.26 0 0 1-1.73 0 2.18 2.18 0 0 1-1.17-1.16 2.2 2.2 0 0 1 1.17-2.89 2.35 2.35 0 0 1 1.73 0 2.2 2.2 0 0 1 .69.48 2.52 2.52 0 0 1 .48.69 2.32 2.32 0 0 1 0 1.72"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M139.32 19.66a.73.73 0 0 0-.2-.46 1.21 1.21 0 0 0-.22-.15 1 1 0 0 0-.25-.05.8.8 0 0 0-.36.09l-3.76 2.45v-4.88a.65.65 0 0 0-.18-.46.69.69 0 0 0-.47-.2.66.66 0 0 0-.66.65v8.75a.65.65 0 0 0 .18.46.64.64 0 0 0 .93 0 .62.62 0 0 0 .19-.46v-2.27l.76-.49 2.91 3.27a.59.59 0 0 0 .43.16.55.55 0 0 0 .26-.05.58.58 0 0 0 .21-.15 1.59 1.59 0 0 0 .15-.21 1 1 0 0 0 0-.25.76.76 0 0 0-.17-.46l-2.7-3 2.63-1.71a.57.57 0 0 0 .27-.54"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M128.39 21a2.34 2.34 0 0 1 .71-.48 2.48 2.48 0 0 1 .86-.17 2.13 2.13 0 0 1 .76.13 2.17 2.17 0 0 1 .68.41.64.64 0 0 0 .42.15.59.59 0 0 0 .48-.19.67.67 0 0 0 .19-.47.64.64 0 0 0-.23-.5A3.4 3.4 0 0 0 130 19a3.54 3.54 0 1 0 2.29 6.22.66.66 0 0 0 .21-.49.63.63 0 0 0-.61-.65.73.73 0 0 0-.43.13 2.28 2.28 0 0 1-.66.41 2 2 0 0 1-.76.14 2.18 2.18 0 0 1-.86-.18 2.1 2.1 0 0 1-.71-.47 2.23 2.23 0 0 1 0-3.14"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M152.41 19.47a1.28 1.28 0 0 0-.44-.27 2.4 2.4 0 0 0-.59-.13 4 4 0 0 0-.6 0 3.41 3.41 0 0 0-1.18.21 3.77 3.77 0 0 0-1 .57v-.13a.65.65 0 0 0-.69-.62.64.64 0 0 0-.63.62v5.74a.67.67 0 0 0 .69.63.65.65 0 0 0 .63-.63v-2.9a2.16 2.16 0 0 1 .17-.86 2 2 0 0 1 .48-.69 2.52 2.52 0 0 1 .69-.48 2.31 2.31 0 0 1 .86-.17 2.57 2.57 0 0 1 .87.15.64.64 0 0 0 .28.07.53.53 0 0 0 .25 0 .51.51 0 0 0 .21-.15.66.66 0 0 0 .15-.21 1 1 0 0 0 .05-.25.62.62 0 0 0-.18-.45"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M146.29 21.19A3.58 3.58 0 0 0 143 19a3.52 3.52 0 0 0-3.53 3.52 3.53 3.53 0 0 0 3.53 3.56 3.48 3.48 0 0 0 2.3-.85.77.77 0 0 0 .15-.16.68.68 0 0 0-.16-.93.67.67 0 0 0-.82.08l-.09.09a1.81 1.81 0 0 1-.63.36 1.91 1.91 0 0 1-.75.12 2.15 2.15 0 0 1-.71-.11 2.57 2.57 0 0 1-.62-.31 1.94 1.94 0 0 1-.49-.5 1.9 1.9 0 0 1-.31-.62h5a.67.67 0 0 0 .47-.19.54.54 0 0 0 .18-.46 4.08 4.08 0 0 0-.25-1.4m-5.39.72a1.7 1.7 0 0 1 .3-.62 2.08 2.08 0 0 1 1.12-.81 2 2 0 0 1 .69-.11 2 2 0 0 1 .69.11 2.27 2.27 0 0 1 1.42 1.43Z"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M109.77 17.47a3.18 3.18 0 0 0-2-.5 4.93 4.93 0 0 0-1 .09 3.78 3.78 0 0 0-1.7-2.55l-.35-.2-.22.32a4.4 4.4 0 0 0-.61 1.42 3.31 3.31 0 0 0 .4 2.64 4.63 4.63 0 0 1-1.75.43H86.88a.73.73 0 0 0-.75.73 11.41 11.41 0 0 0 .69 4 6.09 6.09 0 0 0 2.4 3.15 10.55 10.55 0 0 0 5.25 1.13 15.84 15.84 0 0 0 2.91-.27 12 12 0 0 0 3.81-1.38 10.6 10.6 0 0 0 2.59-2.12 14.3 14.3 0 0 0 2.54-4.36h.22a3.67 3.67 0 0 0 2.68-1 2.94 2.94 0 0 0 .7-1l.09-.3Z"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M88.34 18.65h2.1a.19.19 0 0 0 .18-.18v-1.89a.19.19 0 0 0-.18-.18h-2.1a.19.19 0 0 0-.19.18v1.89a.19.19 0 0 0 .19.18"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M91.24 18.65h2.1a.19.19 0 0 0 .18-.18v-1.89a.19.19 0 0 0-.18-.18h-2.1a.19.19 0 0 0-.19.18v1.89a.19.19 0 0 0 .19.18"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M94.2 18.65h2.1a.19.19 0 0 0 .19-.18v-1.89a.19.19 0 0 0-.19-.18h-2.1a.19.19 0 0 0-.19.18v1.89a.18.18 0 0 0 .19.18"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M97.11 18.65h2.1a.19.19 0 0 0 .19-.18v-1.89a.19.19 0 0 0-.19-.18h-2.1a.19.19 0 0 0-.19.18v1.89a.18.18 0 0 0 .19.18"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M91.24 16h2.1a.2.2 0 0 0 .18-.19v-1.93a.19.19 0 0 0-.18-.18h-2.1a.19.19 0 0 0-.19.18v1.89a.2.2 0 0 0 .19.19"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M94.2 16h2.1a.21.21 0 0 0 .19-.19v-1.93a.19.19 0 0 0-.19-.18h-2.1a.19.19 0 0 0-.19.18v1.89a.18.18 0 0 0 .19.19"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M97.11 16h2.1a.21.21 0 0 0 .19-.19v-1.93a.2.2 0 0 0-.19-.18h-2.1a.19.19 0 0 0-.19.18v1.89a.18.18 0 0 0 .19.19"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M97.11 13.26h2.1a.2.2 0 0 0 .19-.19v-1.88a.2.2 0 0 0-.19-.19h-2.1a.2.2 0 0 0-.19.19v1.88a.19.19 0 0 0 .19.19"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M100.05 18.65h2.1a.19.19 0 0 0 .18-.18v-1.89a.19.19 0 0 0-.18-.18h-2.1a.19.19 0 0 0-.19.18v1.89a.18.18 0 0 0 .19.18"
            })
        ]
    });

});


parcelRegister("8D1yP", function(module, exports) {

$parcel$export(module.exports, "LoggedOutConfluenceBlueWaveTemplate", function () { return $4f4da40538c750d4$export$5959bca4f1448999; });
/* logged-out-confluence-blue-wave-template.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $f6qj2 = parcelRequire("f6qj2");

var $2lKjb = parcelRequire("2lKjb");

var $axg8K = parcelRequire("axg8K");

var $iu8Ap = parcelRequire("iu8Ap");

var $bhreu = parcelRequire("bhreu");
parcelRequire("ia5W9");
var $eZrnm = parcelRequire("eZrnm");

var $fUha7 = parcelRequire("fUha7");
const $4f4da40538c750d4$export$5959bca4f1448999 = ({ productEditionText: productEditionText })=>{
    const { formatMessage: formatMessage } = (0, $f6qj2.default)();
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $iu8Ap.BlueWaveTemplate), {
        productEditionText: productEditionText,
        socialProofLogos: /*#__PURE__*/ (0, $loA2J.jsx)((0, $fUha7.HubspotDockerTwilioGoPro), {}),
        tagline: formatMessage({
            id: "WacSignupForm.signupOfferingIncludesFeaturesSocialProofTextConfluence",
            defaultMessage: "Trusted by over 75,000 teams worldwide"
        }),
        valueProps: formatMessage({
            id: "WacSignupForm.signupOfferingIncludesFeaturesFreeConfluence",
            defaultMessage: "Kickstart team collaboration{newline}Increase transparency{newline}Capture all the knowledge{newline}Build admirable content"
        }).split("{newline}"),
        productLogos: [
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $2lKjb.ConfluenceLogo), {
                appearance: "inverse",
                size: "xlarge"
            }, "jsm")
        ],
        illustration: /*#__PURE__*/ (0, $loA2J.jsx)((0, $bhreu.Picture), {
            image: {
                src: "https://atlassian.com/dam/jcr:12b69d08-6ae8-4b14-ac1c-f3092ccaff97/Confluence%20Hero.svg",
                alt: ""
            }
        }),
        children: /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
            className: (0, $esG4f.default)([
                "_1e0c11p5 _zulp7vkz _6rthckbl"
            ]),
            children: [
                /*#__PURE__*/ (0, $loA2J.jsx)("h2", {
                    className: (0, $esG4f.default)([
                        "_1wyb14no _k48pbfng _19pkidpf _2hwxidpf _otyridpf _18u0idpf _y3gn1h6o"
                    ]),
                    children: formatMessage({
                        id: "WacSignupForm.signupOfferingIncludesFeaturesSignupFormHeading",
                        defaultMessage: "Start now"
                    })
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)("p", {
                    className: (0, $esG4f.default)([
                        "_1wyb7vkz _y3gn1h6o _19pkidpf _2hwxidpf _otyridpf _18u0idpf"
                    ]),
                    children: formatMessage({
                        id: "WacSignupForm.signupOfferingIncludesFeaturesSignupFormSubheadingStandardConfluence",
                        defaultMessage: "7-day free trial for up to 50,000 users"
                    })
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)((0, $axg8K.default), {
                    Submit: /*#__PURE__*/ (0, $loA2J.jsxs)((0, $loA2J.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $loA2J.jsx)((0, $axg8K.Submit), {
                                buttonText: formatMessage({
                                    id: "WacSignupForm.startButtonTextChooseSignup",
                                    defaultMessage: "Continue"
                                })
                            }),
                            /*#__PURE__*/ (0, $loA2J.jsx)((0, $eZrnm.NoCreditCardRequired), {})
                        ]
                    }),
                    Separator: /*#__PURE__*/ (0, $loA2J.jsx)((0, $axg8K.Separator), {
                        separatorText: formatMessage({
                            id: "WacSignupForm.socialSignUpOr",
                            defaultMessage: "OR"
                        })
                    }),
                    Social: /*#__PURE__*/ (0, $loA2J.jsx)((0, $axg8K.Social), {
                        providers: {
                            google: formatMessage({
                                id: "WacSignupForm.socialSignUpButtonContinueWithGoogle",
                                defaultMessage: "Continue with Google"
                            })
                        }
                    })
                })
            ]
        })
    });
};
const $4f4da40538c750d4$var$containerCss = null;
const $4f4da40538c750d4$var$siteActivationHeadingCss = null;
const $4f4da40538c750d4$var$subheaderCss = null;

});

parcelRegister("4hS2F", function(module, exports) {

$parcel$export(module.exports, "UnderlineWord", function () { return $5e1d59615420375e$export$57e8eacc3000643c; });
/* underline-word.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $5ohHq = parcelRequire("5ohHq");
const $5e1d59615420375e$export$57e8eacc3000643c = (node)=>/*#__PURE__*/ (0, $loA2J.jsxs)("span", {
        className: (0, $esG4f.default)([
            "_kqswh2mm"
        ]),
        children: [
            node,
            /*#__PURE__*/ (0, $loA2J.jsx)("svg", {
                "aria-hidden": true,
                viewBox: "0 0 105 17",
                className: (0, $esG4f.default)([
                    "_lswu6nkb _4t3io7ao _u7co1bs0 _1e02idpf _kqswstnw _t9ec1bh4 _1bsb1l8a"
                ]),
                style: {
                    "--_1vwzriw": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.primary.yellow"))
                },
                children: /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                    d: "M104.435 9.68613C86.4938 6.51631 73.1262 13.83 55.0489 7.43996C54.1658 10.0608 51.9298 13.3276 48.6487 13.3318C51.3855 13.3082 55.8543 6.49074 51.3954 11.0379C48.7638 14.5108 37.5257 10.0724 46.1409 13.2376C40.1743 12.5113 34.7527 8.16936 30.7652 4.31768C24.1184 -1.18196 29.0775 9.35501 24.148 14.5541C17.1646 21.7785 -3.47552 2.46837 0.735557 2.51293C3.38441 4.93365 6.96197 6.46719 8.41505 9.13148C34.4142 25.1383 15.8926 -4.08831 31.4374 0.975475C56.6666 21.4402 44.0238 3.05288 58.9761 4.49783C67.6031 11.908 104.856 0.972575 104.442 9.68622L104.435 9.68613Z"
                })
            })
        ]
    });
const $5e1d59615420375e$var$scribbleSpanCss = null;
const $5e1d59615420375e$var$accentImageCss = null;

});




parcelRegister("STWoZ", function(module, exports) {
$parcel$export(module.exports, "LoggedInConfluenceStandard", function () { return (parcelRequire("4pojm")).LoggedInConfluenceStandard; });
parcelRequire("4pojm");

});
parcelRegister("4pojm", function(module, exports) {

$parcel$export(module.exports, "LoggedInConfluenceStandard", function () { return $3714e4ee3632d309$export$fc75c0072efce545; });

var $loA2J = parcelRequire("loA2J");

var $f6qj2 = parcelRequire("f6qj2");
parcelRequire("25Gvl");
var $lRUWQ = parcelRequire("lRUWQ");
const $3714e4ee3632d309$export$fc75c0072efce545 = ()=>{
    const { formatMessage: formatMessage } = (0, $f6qj2.default)();
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $lRUWQ.LoggedInConfluenceBlueWaveTemplate), {
        productEditionText: formatMessage({
            id: "WacSignupHeader.cloudStandard",
            defaultMessage: "Cloud Standard"
        })
    });
};

});



parcelRegister("6ZE25", function(module, exports) {

$parcel$export(module.exports, "LoggedOutConfluence", function () { return $3f5afa00f6b0c2f6$export$503b52f3bcb382d7; });

var $loA2J = parcelRequire("loA2J");

var $iMdoL = parcelRequire("iMdoL");
parcelRequire("9uYPO");
var $gklLv = parcelRequire("gklLv");
parcelRequire("lL2Id");
var $3R6mE = parcelRequire("3R6mE");
parcelRequire("cTRp6");
var $gWzPV = parcelRequire("gWzPV");
const $3f5afa00f6b0c2f6$export$503b52f3bcb382d7 = ()=>{
    const { edition: edition } = (0, $iMdoL.useUserContext)();
    switch(edition){
        case "premium":
            return /*#__PURE__*/ (0, $loA2J.jsx)((0, $3R6mE.LoggedOutConfluencePremium), {});
        case "standard":
            return /*#__PURE__*/ (0, $loA2J.jsx)((0, $gWzPV.LoggedOutConfluenceStandard), {});
        default:
            return /*#__PURE__*/ (0, $loA2J.jsx)((0, $gklLv.LoggedOutConfluenceFree), {});
    }
};

});
parcelRegister("9uYPO", function(module, exports) {
$parcel$export(module.exports, "LoggedOutConfluenceFree", function () { return (parcelRequire("gklLv")).LoggedOutConfluenceFree; });
parcelRequire("gklLv");

});
parcelRegister("gklLv", function(module, exports) {

$parcel$export(module.exports, "LoggedOutConfluenceFree", function () { return $14f0b91e3e440907$export$7bfce75e49986fcd; });
/* logged-out-confluence-free.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $dFnC9 = parcelRequire("dFnC9");

var $axg8K = parcelRequire("axg8K");

var $9O063 = parcelRequire("9O063");

var $iu8Ap = parcelRequire("iu8Ap");

var $5ohHq = parcelRequire("5ohHq");

var $1MbAx = parcelRequire("1MbAx");
parcelRequire("ia5W9");
var $5cDws = parcelRequire("5cDws");
parcelRequire("25Gvl");
var $4hS2F = parcelRequire("4hS2F");
const $14f0b91e3e440907$export$7bfce75e49986fcd = ()=>/*#__PURE__*/ (0, $loA2J.jsx)("div", {
        "data-testid": "logged-out-confluence-free",
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $1MbAx.FeatureExposed), {
            experimentKey: "cfind-2409-v2-cobranding-signup",
            group: "test",
            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $1MbAx.FeatureExposed), {
                experimentKey: "jfind-1192-signup-button-update-cfind",
                group: "test",
                children: /*#__PURE__*/ (0, $loA2J.jsxs)((0, $iu8Ap.SignupBackgroundLayout), {
                    ProductLogo: /*#__PURE__*/ (0, $loA2J.jsx)((0, $9O063.CobrandedProductLogo), {}),
                    children: [
                        /*#__PURE__*/ (0, $loA2J.jsx)("h1", {
                            className: (0, $esG4f.default)([
                                "_syaz1hlo _ect41pz4 _1wybzwfg _k48p1fw0 _19pkidpf _2hwxidpf _otyridpf _18u0idpf _y3gn1h6o"
                            ]),
                            style: {
                                "--_188070z": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.primary.black")),
                                "--_1h6bnby": (0, $43MIc.default)((0, $5ohHq.wacToken)("font.charlie.display"))
                            },
                            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                                id: "BxpUiSignup.SignupForm.cfind2049.header",
                                defaultMessage: "Get <underline-word>started</underline-word> with Confluence",
                                values: {
                                    "underline-word": (0, $4hS2F.UnderlineWord)
                                }
                            })
                        }),
                        /*#__PURE__*/ (0, $loA2J.jsx)("p", {
                            className: (0, $esG4f.default)([
                                "_syaz1hlo _19pkidpf _2hwxidpf _otyr1tcg _18u0idpf _y3gn1h6o"
                            ]),
                            style: {
                                "--_188070z": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.primary.black"))
                            },
                            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                                id: "signupForm.accountCreation.subHeaderText",
                                defaultMessage: "It\u2019s free for up to 10 users - no credit card needed."
                            })
                        }),
                        /*#__PURE__*/ (0, $loA2J.jsx)((0, $axg8K.default), {
                            Input: /*#__PURE__*/ (0, $loA2J.jsx)((0, $5cDws.InputSubmitButton), {}),
                            Submit: null
                        })
                    ]
                })
            })
        })
    });
const $14f0b91e3e440907$var$h1Css = null;
const $14f0b91e3e440907$var$subHeaderCss = null;

});


parcelRegister("lL2Id", function(module, exports) {
$parcel$export(module.exports, "LoggedOutConfluencePremium", function () { return (parcelRequire("3R6mE")).LoggedOutConfluencePremium; });
parcelRequire("3R6mE");

});
parcelRegister("3R6mE", function(module, exports) {

$parcel$export(module.exports, "LoggedOutConfluencePremium", function () { return $b29c9a49964d0b57$export$1ffaa19e2ed0b38d; });

var $loA2J = parcelRequire("loA2J");

var $f6qj2 = parcelRequire("f6qj2");

var $8D1yP = parcelRequire("8D1yP");
const $b29c9a49964d0b57$export$1ffaa19e2ed0b38d = ()=>{
    const { formatMessage: formatMessage } = (0, $f6qj2.default)();
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $8D1yP.LoggedOutConfluenceBlueWaveTemplate), {
        productEditionText: formatMessage({
            id: "WacSignupHeader.cloudPremium",
            defaultMessage: "Cloud Premium"
        })
    });
};

});


parcelRegister("cTRp6", function(module, exports) {
$parcel$export(module.exports, "LoggedOutConfluenceStandard", function () { return (parcelRequire("gWzPV")).LoggedOutConfluenceStandard; });
parcelRequire("gWzPV");

});
parcelRegister("gWzPV", function(module, exports) {

$parcel$export(module.exports, "LoggedOutConfluenceStandard", function () { return $9d7e623f6d1e95b7$export$32193c0ac4b4fb45; });

var $loA2J = parcelRequire("loA2J");

var $f6qj2 = parcelRequire("f6qj2");

var $8D1yP = parcelRequire("8D1yP");
const $9d7e623f6d1e95b7$export$32193c0ac4b4fb45 = ()=>{
    const { formatMessage: formatMessage } = (0, $f6qj2.default)();
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $8D1yP.LoggedOutConfluenceBlueWaveTemplate), {
        productEditionText: formatMessage({
            id: "WacSignupHeader.cloudStandard",
            defaultMessage: "Cloud Standard"
        })
    });
};

});




parcelRegister("i6YkX", function(module, exports) {

$parcel$export(module.exports, "DevAiSignup", function () { return $b18f873902ac9409$export$dca868915a34f0ef; });

var $loA2J = parcelRequire("loA2J");

var $iMdoL = parcelRequire("iMdoL");

var $jNHi0 = parcelRequire("jNHi0");

var $9QTZE = parcelRequire("9QTZE");
const $b18f873902ac9409$export$dca868915a34f0ef = ()=>{
    const { user: { isUserLoggedIn: isUserLoggedIn } } = (0, $iMdoL.useUserContext)();
    if (isUserLoggedIn) return /*#__PURE__*/ (0, $loA2J.jsx)((0, $jNHi0.LoggedInDevAI), {});
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $9QTZE.LoggedOutDevAI), {});
};

});
parcelRegister("jNHi0", function(module, exports) {

$parcel$export(module.exports, "LoggedInDevAI", function () { return $013da63ee6f65f7e$export$13f56d3e273e1527; });

var $loA2J = parcelRequire("loA2J");

var $iMdoL = parcelRequire("iMdoL");

var $gAJUc = parcelRequire("gAJUc");

var $aYzIn = parcelRequire("aYzIn");
parcelRequire("dJ5Pe");
var $inzY3 = parcelRequire("inzY3");
const $013da63ee6f65f7e$export$13f56d3e273e1527 = ()=>{
    const { edition: edition } = (0, $iMdoL.useUserContext)();
    if (edition === "free" && (0, $gAJUc.checkFeatureFlagGate)((0, $gAJUc.featureFlags).enableRovoDevBetaSignup)) return /*#__PURE__*/ (0, $loA2J.jsx)((0, $aYzIn.LoggedInDevAIFree), {});
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $inzY3.LoggedInRovoDevStandard), {});
};

});
parcelRegister("aYzIn", function(module, exports) {

$parcel$export(module.exports, "LoggedInDevAIFree", function () { return $65d02c6d3c50b11b$export$670d83e033e97606; });

var $loA2J = parcelRequire("loA2J");

var $iMdoL = parcelRequire("iMdoL");

var $igRZ2 = parcelRequire("igRZ2");

var $jUUAq = parcelRequire("jUUAq");
const $65d02c6d3c50b11b$export$670d83e033e97606 = ()=>{
    const cohort = (0, $iMdoL.useCohort)();
    if (cohort === "new-user") return /*#__PURE__*/ (0, $loA2J.jsx)((0, $jUUAq.LoggedInDevAIFreeNewUser), {});
    if (cohort) return /*#__PURE__*/ (0, $loA2J.jsx)((0, $igRZ2.LoggedInDevAIFreeExistingSitesUser), {});
    return null;
};

});
parcelRegister("igRZ2", function(module, exports) {

$parcel$export(module.exports, "LoggedInDevAIFreeExistingSitesUser", function () { return $4d7bcd1b2cbaeef4$export$bd3a7e49877d234e; });
/* existing-sites-user.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $f6qj2 = parcelRequire("f6qj2");

var $iu8Ap = parcelRequire("iu8Ap");

var $47Euo = parcelRequire("47Euo");

var $jgJpJ = parcelRequire("jgJpJ");
parcelRequire("d7ONi");
var $l1yhM = parcelRequire("l1yhM");
var $g4P0o = parcelRequire("g4P0o");
const $4d7bcd1b2cbaeef4$export$bd3a7e49877d234e = ()=>{
    const intl = (0, $f6qj2.default)();
    const subHeaderText = intl.formatMessage({
        id: "BxpUiSignup.nameSite.cobrandedExistingUserSubHeader",
        defaultMessage: "Join the free beta program"
    });
    return /*#__PURE__*/ (0, $loA2J.jsxs)((0, $iu8Ap.SignupBackgroundLayout), {
        ProductLogo: /*#__PURE__*/ (0, $loA2J.jsx)((0, $jgJpJ.RovoDevAgentsLogo), {}),
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("h1", {
                className: (0, $esG4f.default)([
                    "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _y3gn1h6o"
                ]),
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $l1yhM.WelcomeBackHeading), {})
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("p", {
                className: (0, $esG4f.default)([
                    "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _y3gn1h6o"
                ]),
                children: subHeaderText
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $47Euo.default), {
                ExistingUser: /*#__PURE__*/ (0, $loA2J.jsx)((0, $47Euo.ExistingUser), {
                    PrivacyPolicy: /*#__PURE__*/ (0, $loA2J.jsx)((0, $g4P0o.PrivacyPolicy), {})
                }),
                WeekOneUser: null,
                ManagedUser: null
            })
        ]
    });
};
const $4d7bcd1b2cbaeef4$var$headerCss = null;

});
parcelRegister("d7ONi", function(module, exports) {
$parcel$export(module.exports, "WelcomeBackHeading", function () { return (parcelRequire("l1yhM")).WelcomeBackHeading; });
$parcel$export(module.exports, "CreateASiteHeading", function () { return (parcelRequire("hAAni")).CreateASiteHeading; });
$parcel$export(module.exports, "PrivacyPolicy", function () { return (parcelRequire("g4P0o")).PrivacyPolicy; });
parcelRequire("l1yhM");
parcelRequire("hAAni");
parcelRequire("g4P0o");

});
parcelRegister("l1yhM", function(module, exports) {

$parcel$export(module.exports, "WelcomeBackHeading", function () { return $74dfba12d7e9932f$export$f8a24991e7eb3d8f; });
/* welcome-back-heading.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $dFnC9 = parcelRequire("dFnC9");

var $5ohHq = parcelRequire("5ohHq");
const $74dfba12d7e9932f$export$f8a24991e7eb3d8f = ()=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
        id: "BxpSignup.SiteExpansionForm.cobrandedHeader",
        defaultMessage: "Get <scribbleSpan>started</scribbleSpan> with Rovo Dev",
        values: {
            scribbleSpan: $74dfba12d7e9932f$var$ScribbleSpan
        }
    });
};
const $74dfba12d7e9932f$var$ScribbleSpan = (children)=>{
    return /*#__PURE__*/ (0, $loA2J.jsxs)("span", {
        className: (0, $esG4f.default)([
            "_kqswh2mm"
        ]),
        children: [
            children,
            /*#__PURE__*/ (0, $loA2J.jsx)("svg", {
                "aria-hidden": true,
                viewBox: "0 0 105 17",
                className: (0, $esG4f.default)([
                    "_lswuh727 _4t3io7ao _u7co1bs0 _1e02idpf _kqswstnw _t9ec1bh4 _1bsb1l8a",
                    "_lswu1ddq"
                ]),
                style: {
                    "--_sktsbj": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.extended.lime600"))
                },
                children: /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                    d: "M104.435 9.68613C86.4938 6.51631 73.1262 13.83 55.0489 7.43996C54.1658 10.0608 51.9298 13.3276 48.6487 13.3318C51.3855 13.3082 55.8543 6.49074 51.3954 11.0379C48.7638 14.5108 37.5257 10.0724 46.1409 13.2376C40.1743 12.5113 34.7527 8.16936 30.7652 4.31768C24.1184 -1.18196 29.0775 9.35501 24.148 14.5541C17.1646 21.7785 -3.47552 2.46837 0.735557 2.51293C3.38441 4.93365 6.96197 6.46719 8.41505 9.13148C34.4142 25.1383 15.8926 -4.08831 31.4374 0.975475C56.6666 21.4402 44.0238 3.05288 58.9761 4.49783C67.6031 11.908 104.856 0.972575 104.442 9.68622L104.435 9.68613Z"
                })
            })
        ]
    });
};
const $74dfba12d7e9932f$var$accentImageCss = null;
const $74dfba12d7e9932f$var$greenThemeCss = null;
const $74dfba12d7e9932f$var$scribbleSpanCss = null;

});

parcelRegister("hAAni", function(module, exports) {

$parcel$export(module.exports, "CreateASiteHeading", function () { return $89dd9f0568496187$export$579c0fd7de5e1861; });
/* create-a-site-heading.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $dFnC9 = parcelRequire("dFnC9");
const $89dd9f0568496187$export$579c0fd7de5e1861 = ()=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
        id: "signupForm.accountCreation.cobrandedLoggedOutHeader",
        defaultMessage: `Create a <accentImage>site</accentImage>`,
        values: {
            accentImage: $89dd9f0568496187$var$accentImage
        }
    });
};
const $89dd9f0568496187$var$accentImage = (children)=>/*#__PURE__*/ (0, $loA2J.jsxs)("span", {
        className: (0, $esG4f.default)([
            "_kqswh2mm"
        ]),
        children: [
            children,
            /*#__PURE__*/ (0, $loA2J.jsxs)("svg", {
                "aria-hidden": "true",
                viewBox: "0 0 57 52",
                className: (0, $esG4f.default)([
                    "_lswuh727 _4t3i1ex1 _152td439 _rjxp1muf _kqswstnw _1bsb1mcy"
                ]),
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                        d: "M43.9096 31.989C44.2964 32.1979 50.1032 30.4768 48.3209 29.7729C47.7086 29.434 47.1876 29.537 47.0824 30.1563C46.7711 29.0152 45.8277 30.6914 45.2428 30.3744C45.338 29.5426 43.9174 31.4167 44.1295 30.5384C37.6167 30.3944 25.6493 39.724 40.8255 33.2041C39.218 33.0188 40.6554 32.5298 41.3794 32.6287C40.4962 33.7793 43.3258 32.5457 43.8251 32.1261C42.9181 32.2503 44.3277 31.315 43.9065 31.9866L43.9096 31.989Z"
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                        d: "M31.1742 23.4941C32.0038 23.3481 34.8483 17.2583 35.2257 16.6666C35.7963 15.2515 33.8616 15.3637 33.6797 16.5353C33.5454 16.7474 33.1876 18.4271 32.7181 17.7781C31.123 18.3209 31.2287 21.2383 29.8684 21.5744C30.1331 21.9302 29.6966 22.4398 29.8375 22.6819C29.4217 22.6843 29.2562 23.2605 29.3603 23.2987C27.7702 24.9228 30.1396 26.3595 30.8463 24.2051C30.9274 24.2847 31.3634 23.8695 31.1748 23.4996L31.1742 23.4941Z"
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                        d: "M8.6666 15.2222C8.02491 16.2514 7.96222 15.2487 8.28065 14.7497C9.05234 15.52 8.82473 13.5428 8.54045 13.0616C8.52243 13.2717 8.17 13.3446 8.18227 12.9105C9.08124 13.2088 9.17211 7.72002 7.35544 10.3155C7.36042 10.4093 8.06672 10.4491 7.84889 10.5596C6.77715 10.3778 7.53675 11.2383 7.62227 11.4811C7.06702 11.477 7.58662 11.707 7.35778 11.7688C6.60614 11.4733 7.8784 12.8725 7.13341 12.5375C6.01834 13.7974 7.55678 16.2818 6.53876 17.2452C7.79737 17.9053 5.99454 21.9334 8.35492 20.3752C8.8673 18.6393 9.14873 17.2179 8.6666 15.2222Z"
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                        d: "M21.257 4.74268C19.536 4.31212 19.9685 8.08877 19.2823 9.11742C18.2988 10.3626 15.0337 23.7231 18.3519 20.2458C19.306 16.1939 20.7963 13.0387 21.3321 7.97975C21.4791 7.16432 22.4539 4.63025 21.257 4.74268Z"
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                        d: "M37.0965 44.953C36.1393 46.3589 34.6992 44.6262 33.7861 45.783C32.4207 48.0004 45.1215 48.6579 44.6732 46.3948C44.025 44.501 38.0156 45.7761 37.0965 44.953Z"
                    })
                ]
            })
        ]
    });
const $89dd9f0568496187$var$accentImageCss = null;
const $89dd9f0568496187$var$scribbleSpanCss = null;

});

parcelRegister("g4P0o", function(module, exports) {

$parcel$export(module.exports, "PrivacyPolicy", function () { return $53908b696ac4aff7$export$f37ec6636ba46d53; });
/* privacy-policy.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $5ohHq = parcelRequire("5ohHq");
const $53908b696ac4aff7$export$f37ec6636ba46d53 = ()=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        className: (0, $esG4f.default)([
            "_1wybw1gv"
        ]),
        children: /*#__PURE__*/ (0, $loA2J.jsxs)("ul", {
            className: (0, $esG4f.default)([
                "_bozgo7ao"
            ]),
            children: [
                /*#__PURE__*/ (0, $loA2J.jsx)("li", {
                    children: "Your order contains at least one auto-renewing subscription. You\u2019ll be charged $20 per user / month after your trial."
                }),
                /*#__PURE__*/ (0, $loA2J.jsxs)("li", {
                    children: [
                        "By continuing you agree to pay the total amount each billing cycle, starting from the next bill date or after any free trials end, until you cancel. Any free trials can be canceled before the trial end date to avoid being charged. Your bill may change if the usage changes, and will reflect applicable taxes.",
                        " ",
                        /*#__PURE__*/ (0, $loA2J.jsx)("a", {
                            href: "https://support.atlassian.com/subscriptions-and-billing/docs/cancel-a-subscription/",
                            className: (0, $esG4f.default)([
                                "_syaz17la _4bfu1r31 _1hms8stv _ajmmnqa1 _9oik1r31 _1bnxglyw _jf4cnqa1"
                            ]),
                            style: {
                                "--_1r6llbg": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.primary.blue"))
                            },
                            children: "Cancel"
                        }),
                        " ",
                        "or",
                        " ",
                        /*#__PURE__*/ (0, $loA2J.jsx)("a", {
                            href: "https://support.atlassian.com/subscriptions-and-billing/resources/",
                            className: (0, $esG4f.default)([
                                "_syaz17la _4bfu1r31 _1hms8stv _ajmmnqa1 _9oik1r31 _1bnxglyw _jf4cnqa1"
                            ]),
                            style: {
                                "--_1r6llbg": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.primary.blue"))
                            },
                            children: "change your plan"
                        }),
                        " ",
                        "at any time. If prices change, we\u2019ll notify you."
                    ]
                }),
                /*#__PURE__*/ (0, $loA2J.jsxs)("li", {
                    children: [
                        "Rovo Dev features allow users to connect to",
                        " ",
                        /*#__PURE__*/ (0, $loA2J.jsx)("a", {
                            href: "https://support.atlassian.com/rovo/docs/rovo-dev-and-model-context-protocol-mcp/",
                            className: (0, $esG4f.default)([
                                "_syaz17la _4bfu1r31 _1hms8stv _ajmmnqa1 _9oik1r31 _1bnxglyw _jf4cnqa1"
                            ]),
                            style: {
                                "--_1r6llbg": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.primary.blue"))
                            },
                            children: "Third-Party Products"
                        }),
                        " ",
                        "and data sources. You are responsible for obtaining all necessary rights and consents for Atlassian to process any data users submit to Rovo Dev (including data from their local devices and connected Third-Party Products)."
                    ]
                }),
                /*#__PURE__*/ (0, $loA2J.jsxs)("li", {
                    children: [
                        "By selecting ",
                        /*#__PURE__*/ (0, $loA2J.jsx)("b", {
                            children: "\u201CAgree and start now\u201D"
                        }),
                        ", you agree to the",
                        " ",
                        /*#__PURE__*/ (0, $loA2J.jsx)("a", {
                            href: "https://www.atlassian.com/legal/atlassian-customer-agreement",
                            className: (0, $esG4f.default)([
                                "_syaz17la _4bfu1r31 _1hms8stv _ajmmnqa1 _9oik1r31 _1bnxglyw _jf4cnqa1"
                            ]),
                            style: {
                                "--_1r6llbg": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.primary.blue"))
                            },
                            children: "Atlassian Customer Agreement"
                        }),
                        ", and acknowledge our",
                        " ",
                        /*#__PURE__*/ (0, $loA2J.jsx)("a", {
                            href: "https://www.atlassian.com/legal/privacy-policy",
                            className: (0, $esG4f.default)([
                                "_syaz17la _4bfu1r31 _1hms8stv _ajmmnqa1 _9oik1r31 _1bnxglyw _jf4cnqa1"
                            ]),
                            style: {
                                "--_1r6llbg": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.primary.blue"))
                            },
                            children: "Privacy Policy"
                        }),
                        ". When using Rovo Dev you must follow our",
                        " ",
                        /*#__PURE__*/ (0, $loA2J.jsx)("a", {
                            href: "https://www.atlassian.com/legal/acceptable-use-policy",
                            className: (0, $esG4f.default)([
                                "_syaz17la _4bfu1r31 _1hms8stv _ajmmnqa1 _9oik1r31 _1bnxglyw _jf4cnqa1"
                            ]),
                            style: {
                                "--_1r6llbg": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.primary.blue"))
                            },
                            children: "Acceptable Use Policy"
                        }),
                        "."
                    ]
                })
            ]
        })
    });
};
const $53908b696ac4aff7$var$privacyPolicyCss = null;
const $53908b696ac4aff7$var$listCss = null;
const $53908b696ac4aff7$var$linkCss = null;

});



parcelRegister("jUUAq", function(module, exports) {

$parcel$export(module.exports, "LoggedInDevAIFreeNewUser", function () { return $9c88b160e4a0465e$export$141fa8e8d9747294; });
/* new-user.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $f6qj2 = parcelRequire("f6qj2");

var $iu8Ap = parcelRequire("iu8Ap");

var $47Euo = parcelRequire("47Euo");

var $jgJpJ = parcelRequire("jgJpJ");
parcelRequire("d7ONi");
var $hAAni = parcelRequire("hAAni");
var $g4P0o = parcelRequire("g4P0o");
const $9c88b160e4a0465e$export$141fa8e8d9747294 = ()=>{
    const intl = (0, $f6qj2.default)();
    const subHeaderText = intl.formatMessage({
        id: "siteActivation.loggedInDevAI.newUser",
        defaultMessage: "Sites are the shared space where people organize teams, work, and projects."
    });
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $iu8Ap.SignupBackgroundLayout), {
        ProductLogo: /*#__PURE__*/ (0, $loA2J.jsx)((0, $jgJpJ.RovoDevAgentsLogo), {}),
        children: /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
            className: (0, $esG4f.default)([
                "_1e0c1txw _2lx21bp4"
            ]),
            children: [
                /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                    className: (0, $esG4f.default)([
                        "_1e0c11p5 _zulpu2gc"
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $loA2J.jsx)("h1", {
                            className: (0, $esG4f.default)([
                                "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _y3gn1h6o"
                            ]),
                            children: /*#__PURE__*/ (0, $loA2J.jsx)("span", {
                                className: (0, $esG4f.default)([
                                    "_kqswh2mm"
                                ]),
                                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $hAAni.CreateASiteHeading), {})
                            })
                        }),
                        /*#__PURE__*/ (0, $loA2J.jsx)("p", {
                            className: (0, $esG4f.default)([
                                "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _y3gn1h6o"
                            ]),
                            children: subHeaderText
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)((0, $47Euo.default), {
                    NewUser: /*#__PURE__*/ (0, $loA2J.jsx)((0, $47Euo.NewUser), {
                        PrivacyPolicy: /*#__PURE__*/ (0, $loA2J.jsx)((0, $g4P0o.PrivacyPolicy), {})
                    })
                })
            ]
        })
    });
};
const $9c88b160e4a0465e$var$containerCss = null;
const $9c88b160e4a0465e$var$headerGroupCss = null;
const $9c88b160e4a0465e$var$headerCss = null;
const $9c88b160e4a0465e$var$accentImageSpanCss = null;

});


parcelRegister("dJ5Pe", function(module, exports) {
$parcel$export(module.exports, "LoggedInRovoDevStandard", function () { return (parcelRequire("inzY3")).LoggedInRovoDevStandard; });
parcelRequire("inzY3");

});
parcelRegister("inzY3", function(module, exports) {

$parcel$export(module.exports, "LoggedInRovoDevStandard", function () { return $a48773e2fb93efa1$export$f2f71ed77d151e3c; });

var $loA2J = parcelRequire("loA2J");

var $iMdoL = parcelRequire("iMdoL");

var $7pTeH = parcelRequire("7pTeH");

var $bzMAJ = parcelRequire("bzMAJ");
const $a48773e2fb93efa1$export$f2f71ed77d151e3c = ()=>{
    const cohort = (0, $iMdoL.useCohort)();
    if (cohort === (0, $iMdoL.COHORTS).NEW_USER) return /*#__PURE__*/ (0, $loA2J.jsx)((0, $bzMAJ.LoggedInRovoDevStandardNewUser), {});
    if (cohort) return /*#__PURE__*/ (0, $loA2J.jsx)((0, $7pTeH.LoggedInRovoDevStandardExistingSitesUser), {});
    return null;
};

});
parcelRegister("7pTeH", function(module, exports) {

$parcel$export(module.exports, "LoggedInRovoDevStandardExistingSitesUser", function () { return $581b0074c57a7cc1$export$ef5b160f88db9ed5; });
/* existing-sites-user.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $iu8Ap = parcelRequire("iu8Ap");

var $47Euo = parcelRequire("47Euo");

var $jgJpJ = parcelRequire("jgJpJ");
parcelRequire("d7ONi");
var $l1yhM = parcelRequire("l1yhM");
var $g4P0o = parcelRequire("g4P0o");
const $581b0074c57a7cc1$export$ef5b160f88db9ed5 = ()=>{
    return /*#__PURE__*/ (0, $loA2J.jsxs)((0, $iu8Ap.SignupBackgroundLayout), {
        theme: "green",
        ProductLogo: /*#__PURE__*/ (0, $loA2J.jsx)((0, $jgJpJ.RovoDevAgentsLogo), {}),
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("h1", {
                className: (0, $esG4f.default)([
                    "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _y3gn1h6o"
                ]),
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $l1yhM.WelcomeBackHeading), {})
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $47Euo.default), {
                ExistingUser: /*#__PURE__*/ (0, $loA2J.jsx)((0, $47Euo.ExistingUser), {
                    PrivacyPolicy: /*#__PURE__*/ (0, $loA2J.jsx)((0, $g4P0o.PrivacyPolicy), {})
                }),
                WeekOneUser: null,
                ManagedUser: null
            })
        ]
    });
};
const $581b0074c57a7cc1$var$headerCss = null;

});

parcelRegister("bzMAJ", function(module, exports) {

$parcel$export(module.exports, "LoggedInRovoDevStandardNewUser", function () { return $e5dedd32b7f7d6b9$export$72fdccb67e0f2e54; });
/* new-user.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $f6qj2 = parcelRequire("f6qj2");

var $iu8Ap = parcelRequire("iu8Ap");

var $47Euo = parcelRequire("47Euo");

var $jgJpJ = parcelRequire("jgJpJ");
parcelRequire("d7ONi");
var $hAAni = parcelRequire("hAAni");
var $g4P0o = parcelRequire("g4P0o");
const $e5dedd32b7f7d6b9$export$72fdccb67e0f2e54 = ()=>{
    const intl = (0, $f6qj2.default)();
    const subHeaderText = intl.formatMessage({
        id: "siteActivation.loggedInRovoDev.newUser",
        defaultMessage: "Sites are the shared space where people organize teams, work, and projects."
    });
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $iu8Ap.SignupBackgroundLayout), {
        theme: "green",
        ProductLogo: /*#__PURE__*/ (0, $loA2J.jsx)((0, $jgJpJ.RovoDevAgentsLogo), {}),
        children: /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
            className: (0, $esG4f.default)([
                "_1e0c1txw _2lx21bp4"
            ]),
            children: [
                /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                    className: (0, $esG4f.default)([
                        "_1e0c11p5 _zulpu2gc"
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $loA2J.jsx)("h1", {
                            className: (0, $esG4f.default)([
                                "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _y3gn1h6o"
                            ]),
                            children: /*#__PURE__*/ (0, $loA2J.jsx)("span", {
                                className: (0, $esG4f.default)([
                                    "_kqswh2mm"
                                ]),
                                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $hAAni.CreateASiteHeading), {})
                            })
                        }),
                        /*#__PURE__*/ (0, $loA2J.jsx)("p", {
                            className: (0, $esG4f.default)([
                                "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _y3gn1h6o"
                            ]),
                            children: subHeaderText
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)((0, $47Euo.default), {
                    NewUser: /*#__PURE__*/ (0, $loA2J.jsx)((0, $47Euo.NewUser), {
                        PrivacyPolicy: /*#__PURE__*/ (0, $loA2J.jsx)((0, $g4P0o.PrivacyPolicy), {})
                    })
                })
            ]
        })
    });
};
const $e5dedd32b7f7d6b9$var$containerCss = null;
const $e5dedd32b7f7d6b9$var$headerGroupCss = null;
const $e5dedd32b7f7d6b9$var$headerCss = null;
const $e5dedd32b7f7d6b9$var$accentImageSpanCss = null;

});




parcelRegister("9QTZE", function(module, exports) {

$parcel$export(module.exports, "LoggedOutDevAI", function () { return $5c33ea2ab5db5a3c$export$b64aab519f10993d; });

var $loA2J = parcelRequire("loA2J");

var $iMdoL = parcelRequire("iMdoL");

var $gAJUc = parcelRequire("gAJUc");
parcelRequire("etelt");
var $bUqRO = parcelRequire("bUqRO");
parcelRequire("j6oAr");
var $hThMH = parcelRequire("hThMH");
const $5c33ea2ab5db5a3c$export$b64aab519f10993d = ()=>{
    const { edition: edition } = (0, $iMdoL.useUserContext)();
    if (edition === "free" && (0, $gAJUc.checkFeatureFlagGate)((0, $gAJUc.featureFlags).enableRovoDevBetaSignup)) return /*#__PURE__*/ (0, $loA2J.jsx)((0, $bUqRO.LoggedOutDevAIFree), {});
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $hThMH.LoggedOutRovoDevStandard), {});
};

});
parcelRegister("etelt", function(module, exports) {
$parcel$export(module.exports, "LoggedOutDevAIFree", function () { return (parcelRequire("bUqRO")).LoggedOutDevAIFree; });
parcelRequire("bUqRO");

});
parcelRegister("bUqRO", function(module, exports) {

$parcel$export(module.exports, "LoggedOutDevAIFree", function () { return $1e2425e52ec4da97$export$5a6527b3000ce977; });

var $loA2J = parcelRequire("loA2J");

var $axg8K = parcelRequire("axg8K");

var $iu8Ap = parcelRequire("iu8Ap");

var $jgJpJ = parcelRequire("jgJpJ");
parcelRequire("ia5W9");
var $esacZ = parcelRequire("esacZ");
const $1e2425e52ec4da97$export$5a6527b3000ce977 = ()=>{
    return /*#__PURE__*/ (0, $loA2J.jsxs)((0, $iu8Ap.SignupBackgroundLayout), {
        ProductLogo: /*#__PURE__*/ (0, $loA2J.jsx)((0, $jgJpJ.RovoDevAgentsLogo), {}),
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $esacZ.GetStartedHeading), {
                productName: "Rovo Dev Agents"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $axg8K.default), {})
        ]
    });
};

});


parcelRegister("j6oAr", function(module, exports) {

$parcel$export(module.exports, "LoggedOutRovoDevStandard", function () { return (parcelRequire("hThMH")).LoggedOutRovoDevStandard; });

var $hThMH = parcelRequire("hThMH");

});
parcelRegister("hThMH", function(module, exports) {

$parcel$export(module.exports, "LoggedOutRovoDevStandard", function () { return $4bfbe0358397d1d1$export$f7ebb395035df183; });

var $loA2J = parcelRequire("loA2J");

var $axg8K = parcelRequire("axg8K");

var $iu8Ap = parcelRequire("iu8Ap");

var $jgJpJ = parcelRequire("jgJpJ");
parcelRequire("ia5W9");
var $esacZ = parcelRequire("esacZ");
const $4bfbe0358397d1d1$export$f7ebb395035df183 = ()=>{
    return /*#__PURE__*/ (0, $loA2J.jsxs)((0, $iu8Ap.SignupBackgroundLayout), {
        theme: "green",
        ProductLogo: /*#__PURE__*/ (0, $loA2J.jsx)((0, $jgJpJ.RovoDevAgentsLogo), {}),
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $esacZ.GetStartedHeading), {
                productName: "Rovo Dev"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $axg8K.default), {})
        ]
    });
};

});




parcelRegister("dKSUZ", function(module, exports) {

$parcel$export(module.exports, "JiraSignup", function () { return $ce0d88c52bfb051d$export$661f9d14ec25fc6f; });

var $loA2J = parcelRequire("loA2J");

var $iMdoL = parcelRequire("iMdoL");

var $1SbdX = parcelRequire("1SbdX");
parcelRequire("2zT2h");
var $lv3WA = parcelRequire("lv3WA");
const $ce0d88c52bfb051d$export$661f9d14ec25fc6f = ()=>{
    const { user: { isUserLoggedIn: isUserLoggedIn } } = (0, $iMdoL.useUserContext)();
    if (isUserLoggedIn) return /*#__PURE__*/ (0, $loA2J.jsx)((0, $1SbdX.LoggedInJira), {});
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $lv3WA.LoggedOutJira), {});
};

});
parcelRegister("1SbdX", function(module, exports) {

$parcel$export(module.exports, "LoggedInJira", function () { return $fb018ca5714c70b3$export$61be21d8bd17cf0f; });

var $loA2J = parcelRequire("loA2J");

var $iMdoL = parcelRequire("iMdoL");

var $cRkaR = parcelRequire("cRkaR");

var $coFBw = parcelRequire("coFBw");

var $hV4QP = parcelRequire("hV4QP");
const $fb018ca5714c70b3$export$61be21d8bd17cf0f = ()=>{
    const isStandard = (0, $iMdoL.useStandardIntent)();
    const isPremium = (0, $iMdoL.usePremiumIntent)();
    if (isStandard) return /*#__PURE__*/ (0, $loA2J.jsx)((0, $hV4QP.LoggedInJiraStandard), {});
    if (isPremium) return /*#__PURE__*/ (0, $loA2J.jsx)((0, $coFBw.LoggedInJiraPremium), {});
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $cRkaR.LoggedInJiraFree), {});
};

});
parcelRegister("cRkaR", function(module, exports) {

$parcel$export(module.exports, "LoggedInJiraFree", function () { return $1d158e8b37093283$export$846fc313de86b008; });

var $loA2J = parcelRequire("loA2J");

var $iMdoL = parcelRequire("iMdoL");

var $2owTN = parcelRequire("2owTN");

var $coMqv = parcelRequire("coMqv");

var $46TBz = parcelRequire("46TBz");

var $iRx0w = parcelRequire("iRx0w");
const $1d158e8b37093283$export$846fc313de86b008 = ()=>{
    const cohort = (0, $iMdoL.useCohort)();
    if (cohort === "new-user") return /*#__PURE__*/ (0, $loA2J.jsx)((0, $2owTN.LoggedInJiraNewUser), {});
    if (cohort === "managed-user") return /*#__PURE__*/ (0, $loA2J.jsx)((0, $46TBz.LoggedInJiraFreeManagedUser), {});
    if (cohort === "week-one-user") return /*#__PURE__*/ (0, $loA2J.jsx)((0, $iRx0w.LoggedInJiraFreeWeekOneUser), {});
    if (cohort) return /*#__PURE__*/ (0, $loA2J.jsx)((0, $coMqv.LoggedInJiraFreeExistingSitesUser), {});
    return null;
};

});
parcelRegister("2owTN", function(module, exports) {

$parcel$export(module.exports, "LoggedInJiraNewUser", function () { return $2ece8e0e49d14d25$export$c91a3c7dfb3c7a1d; });
/* logged-in-jira-new-user.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $dFnC9 = parcelRequire("dFnC9");

var $iu8Ap = parcelRequire("iu8Ap");

var $47Euo = parcelRequire("47Euo");

var $1MbAx = parcelRequire("1MbAx");
parcelRequire("ia5W9");
var $3CPhp = parcelRequire("3CPhp");
const $2ece8e0e49d14d25$export$c91a3c7dfb3c7a1d = ()=>/*#__PURE__*/ (0, $loA2J.jsx)((0, $1MbAx.FeatureExposed), {
        experimentKey: "jfind-1565-sign-up-flow-overlay",
        group: "Test",
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $iu8Ap.JiraOverlayTemplate), {
            size: "sm",
            children: /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                className: (0, $esG4f.default)([
                    "_1e0c1txw _2lx21bp4"
                ]),
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                        className: (0, $esG4f.default)([
                            "_1e0c11p5 _zulpu2gc"
                        ]),
                        children: [
                            /*#__PURE__*/ (0, $loA2J.jsx)("h1", {
                                className: (0, $esG4f.default)([
                                    "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _y3gn1h6o"
                                ]),
                                children: /*#__PURE__*/ (0, $loA2J.jsx)("span", {
                                    className: (0, $esG4f.default)([
                                        "_kqswh2mm"
                                    ]),
                                    children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $3CPhp.CreateASiteHeading), {})
                                })
                            }),
                            /*#__PURE__*/ (0, $loA2J.jsx)("p", {
                                className: (0, $esG4f.default)([
                                    "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _y3gn1h6o"
                                ]),
                                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                                    id: "siteActivation.loggedInJira.newUser",
                                    defaultMessage: "Sites are the shared space where people organize teams, work, and projects."
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)((0, $47Euo.default), {})
                ]
            })
        })
    });
const $2ece8e0e49d14d25$var$containerCss = null;
const $2ece8e0e49d14d25$var$headerGroupCss = null;
const $2ece8e0e49d14d25$var$headerCss = null;
const $2ece8e0e49d14d25$var$accentImageSpanCss = null;

});

parcelRegister("coMqv", function(module, exports) {

$parcel$export(module.exports, "LoggedInJiraFreeExistingSitesUser", function () { return $cdcea2b860ebc57c$export$ebdf57151e82cc8b; });
/* existing-sites-user.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $dFnC9 = parcelRequire("dFnC9");

var $iu8Ap = parcelRequire("iu8Ap");

var $47Euo = parcelRequire("47Euo");

var $iMdoL = parcelRequire("iMdoL");

var $5ohHq = parcelRequire("5ohHq");

var $1MbAx = parcelRequire("1MbAx");
parcelRequire("2sSmA");
var $61OkS = parcelRequire("61OkS");
const $cdcea2b860ebc57c$export$ebdf57151e82cc8b = ()=>{
    const { user: { name: name } } = (0, $iMdoL.useUserContext)();
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $1MbAx.FeatureExposed), {
        experimentKey: "jfind-1565-sign-up-flow-overlay",
        group: "Test",
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $iu8Ap.JiraOverlayTemplate), {
            size: "sm",
            children: /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                className: (0, $esG4f.default)([
                    "_1e0c11p5 _zulp19bv"
                ]),
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsx)("h1", {
                        className: (0, $esG4f.default)([
                            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _y3gn1h6o"
                        ]),
                        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $61OkS.WelcomeBackHeading), {
                            name: name
                        })
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("p", {
                        className: (0, $esG4f.default)([
                            "_19pkidpf _2hwx1wug _otyridpf _18u01wug _syaz1hlo _y3gn1h6o"
                        ]),
                        style: {
                            "--_188070z": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.primary.black"))
                        },
                        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                            id: "signupForm.accountCreation.subHeaderText",
                            defaultMessage: "It\u2019s free for up to 10 users - no credit card needed."
                        })
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)((0, $47Euo.default), {})
                ]
            })
        })
    });
};
const $cdcea2b860ebc57c$var$containerCss = null;
const $cdcea2b860ebc57c$var$headerCss = null;
const $cdcea2b860ebc57c$var$subHeaderCss = null;

});
parcelRegister("2sSmA", function(module, exports) {
$parcel$export(module.exports, "WelcomeBackHeading", function () { return (parcelRequire("61OkS")).WelcomeBackHeading; });
$parcel$export(module.exports, "SquareVisaCiscoPfizer", function () { return (parcelRequire("a7jHq")).SquareVisaCiscoPfizer; });
parcelRequire("61OkS");
parcelRequire("a7jHq");
parcelRequire("68aRd");

});
parcelRegister("61OkS", function(module, exports) {

$parcel$export(module.exports, "WelcomeBackHeading", function () { return $775e19103e72da38$export$f8a24991e7eb3d8f; });
/* welcome-back-heading.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $dFnC9 = parcelRequire("dFnC9");

var $jgJpJ = parcelRequire("jgJpJ");
const $775e19103e72da38$export$f8a24991e7eb3d8f = ({ name: name })=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
        id: "BxpSignup.SiteExpansionForm.cobrandedHeader",
        defaultMessage: "<scribbleSpan>Welcome</scribbleSpan> back, {name}",
        values: {
            name: (0, $jgJpJ.getFirstName)(name),
            scribbleSpan: $775e19103e72da38$var$scribbleSpan
        }
    });
};
const $775e19103e72da38$var$scribbleSpan = (children)=>/*#__PURE__*/ (0, $loA2J.jsxs)("span", {
        className: (0, $esG4f.default)([
            "_kqswh2mm"
        ]),
        children: [
            children,
            /*#__PURE__*/ (0, $loA2J.jsx)("svg", {
                "aria-hidden": true,
                viewBox: "0 0 105 17",
                className: (0, $esG4f.default)([
                    "_lswuh727 _4t3io7ao _u7co1bs0 _1e02idpf _kqswstnw _t9ec1bh4 _1bsb1l8a"
                ]),
                children: /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                    d: "M104.435 9.68613C86.4938 6.51631 73.1262 13.83 55.0489 7.43996C54.1658 10.0608 51.9298 13.3276 48.6487 13.3318C51.3855 13.3082 55.8543 6.49074 51.3954 11.0379C48.7638 14.5108 37.5257 10.0724 46.1409 13.2376C40.1743 12.5113 34.7527 8.16936 30.7652 4.31768C24.1184 -1.18196 29.0775 9.35501 24.148 14.5541C17.1646 21.7785 -3.47552 2.46837 0.735557 2.51293C3.38441 4.93365 6.96197 6.46719 8.41505 9.13148C34.4142 25.1383 15.8926 -4.08831 31.4374 0.975475C56.6666 21.4402 44.0238 3.05288 58.9761 4.49783C67.6031 11.908 104.856 0.972575 104.442 9.68622L104.435 9.68613Z"
                })
            })
        ]
    });
const $775e19103e72da38$var$accentImageCss = null;
const $775e19103e72da38$var$scribbleSpanCss = null;

});

parcelRegister("a7jHq", function(module, exports) {

$parcel$export(module.exports, "SquareVisaCiscoPfizer", function () { return $18485673a7fd6056$export$5467876c6586ede6; });

var $loA2J = parcelRequire("loA2J");
const $18485673a7fd6056$export$5467876c6586ede6 = ()=>/*#__PURE__*/ (0, $loA2J.jsxs)("svg", {
        viewBox: "0 0 300 40",
        fill: "currentColor",
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M18.74,21.7a.49.49,0,0,1-.48.48h-3.4a.48.48,0,0,1-.48-.48V18.3a.48.48,0,0,1,.48-.48h3.4a.49.49,0,0,1,.48.48Zm2.91,2.54a.85.85,0,0,1-.85.85H12.31a.86.86,0,0,1-.85-.85V15.76a.86.86,0,0,1,.85-.85H20.8a.85.85,0,0,1,.85.85ZM21.89,12H11.22a2.67,2.67,0,0,0-2.66,2.67V25.33A2.67,2.67,0,0,0,11.22,28H21.89a2.67,2.67,0,0,0,2.66-2.67V14.67A2.66,2.66,0,0,0,21.89,12"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M32,25.25a3.54,3.54,0,0,1-2.5-1,3,3,0,0,1-.89-2.1h1a2,2,0,0,0,.61,1.42,2.59,2.59,0,0,0,1.82.72h0A2.28,2.28,0,0,0,34.4,22.2c0-.86-.48-1.55-2.81-2.08a4.23,4.23,0,0,1-2-.93,2.34,2.34,0,0,1-.67-1.78,2.88,2.88,0,0,1,3-2.73,3.19,3.19,0,0,1,2.11.77,2.57,2.57,0,0,1,.9,1.95H34a1.92,1.92,0,0,0-2-1.76,2,2,0,0,0-2.05,1.77c0,.88.3,1.39,1.94,1.77s3.55,1.08,3.55,3a2.9,2.9,0,0,1-1,2.18,3.57,3.57,0,0,1-2.38.87Z"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M40.42,18.44a3,3,0,1,0,2.91,3,2.94,2.94,0,0,0-2.91-3M43.28,28V23.78h0a3.33,3.33,0,0,1-2.83,1.45,3.81,3.81,0,1,1,0-7.62,3.29,3.29,0,0,1,2.83,1.46h0V17.8h.92V28Z"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M57.54,18.44a3,3,0,1,0,2.9,3,2.94,2.94,0,0,0-2.9-3m2.85,6.61V23.78h0a3.35,3.35,0,0,1-2.82,1.45,3.81,3.81,0,1,1,0-7.62,3.24,3.24,0,0,1,2.82,1.46h0V17.8h.92v7.25Z"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M64.1,20.81v4.24h-.93V17.8h.93v1h0a2.07,2.07,0,0,1,2-1.23v1a2.09,2.09,0,0,0-2.07,2.22"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M70.33,18.44a2.87,2.87,0,0,0-2.83,2.48h5.66a2.88,2.88,0,0,0-2.83-2.48m3.78,3.32H67.5a2.88,2.88,0,0,0,2.82,2.63,2.75,2.75,0,0,0,2.6-1.71h1a3.79,3.79,0,1,1-3.58-5.07,3.86,3.86,0,0,1,3.8,3.89c0,.09,0,.17,0,.26"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M51.41,25.06V23.93h0a2.48,2.48,0,0,1-2.33,1.31,3.14,3.14,0,0,1-2.51-1.09,3.76,3.76,0,0,1-.64-2.35v-4h.93v4c0,1.51.55,2.62,2.22,2.62a2.06,2.06,0,0,0,1.54-.59,2.75,2.75,0,0,0,.76-2.19V17.77h.94v7.29Z"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M189.66,28.3v1.51l.11,0a9.44,9.44,0,0,0,1.05.14,7.22,7.22,0,0,0,.93,0,4.19,4.19,0,0,0,.87-.17,2.38,2.38,0,0,0,.9-.48,1.81,1.81,0,0,0,.53-.75,2.1,2.1,0,0,0,0-1.52,1.82,1.82,0,0,0-.47-.66,2.08,2.08,0,0,0-.69-.4l-1.15-.42a.69.69,0,0,1-.31-.3.37.37,0,0,1,0-.34.41.41,0,0,1,.07-.11l.12-.09,0,0a1.48,1.48,0,0,1,.41-.12,2.48,2.48,0,0,1,.72,0,6,6,0,0,1,.85.15h.06V23.38l-.11,0a8.15,8.15,0,0,0-.86-.16,4.27,4.27,0,0,0-1.13,0,2.43,2.43,0,0,0-1.3.52,1.71,1.71,0,0,0-.55.77,2,2,0,0,0,0,1.42,1.51,1.51,0,0,0,.4.6,2.08,2.08,0,0,0,.51.37,3.17,3.17,0,0,0,.79.31l.27.09.13,0h0a1.13,1.13,0,0,1,.36.22.78.78,0,0,1,.16.24.57.57,0,0,1,0,.26.57.57,0,0,1-.26.31,1.41,1.41,0,0,1-.44.14,3.76,3.76,0,0,1-.67,0,6.42,6.42,0,0,1-.88-.12l-.46-.1-.05,0"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M183.46,29.76V28l0,0a3.21,3.21,0,0,1-1.26.32,1.9,1.9,0,0,1-1.28-.38,1.6,1.6,0,0,1-.55-.78,1.82,1.82,0,0,1,0-1.06,1.65,1.65,0,0,1,.56-.9,1.77,1.77,0,0,1,.89-.38,2.88,2.88,0,0,1,1.68.31l0,0V23.41l-.08,0a4.57,4.57,0,0,0-1.6-.2,3.68,3.68,0,0,0-1.43.32,3.34,3.34,0,0,0-1.17.91,3.51,3.51,0,0,0-.06,4.27,3.33,3.33,0,0,0,1.86,1.2,4.27,4.27,0,0,0,2.35-.09l.13,0"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("polyline", {
                points: "187.41 29.88 187.41 23.29 185.75 23.29 185.75 29.88 187.41 29.88"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M175,18a.86.86,0,0,0,.26.55.82.82,0,0,0,1.38-.55V16.17a.85.85,0,0,0-.25-.56.81.81,0,0,0-.57-.23.83.83,0,0,0-.57.23.85.85,0,0,0-.25.56V18"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M179.57,18a.82.82,0,0,0,1.38.55.86.86,0,0,0,.26-.55V13.9a.85.85,0,0,0-.25-.56.82.82,0,0,0-1.14,0,.85.85,0,0,0-.25.56V18"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M184.09,19.64a.84.84,0,0,0,.26.54.82.82,0,0,0,1.12,0,.79.79,0,0,0,.26-.54V10.79a.85.85,0,0,0-.25-.56.82.82,0,0,0-1.14,0,.85.85,0,0,0-.25.56v8.85"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M188.64,18a.82.82,0,0,0,1.38.55.86.86,0,0,0,.26-.55V13.9a.85.85,0,0,0-.25-.56.83.83,0,0,0-.57-.23.81.81,0,0,0-.57.23.77.77,0,0,0-.25.56V18"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M193.16,18a.82.82,0,0,0,.82.77.84.84,0,0,0,.83-.77V16.17a.82.82,0,0,0-.26-.56.79.79,0,0,0-.57-.23.83.83,0,0,0-.57.23.85.85,0,0,0-.25.56V18"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M197.71,18a.78.78,0,0,0,.26.55.82.82,0,0,0,.56.22.82.82,0,0,0,.82-.77V13.9a.85.85,0,0,0-.25-.56.83.83,0,0,0-.57-.23.79.79,0,0,0-.57.23.77.77,0,0,0-.25.56V18"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M202.23,19.64a.84.84,0,0,0,.26.54.82.82,0,0,0,1.12,0,.79.79,0,0,0,.26-.54V10.79a.85.85,0,0,0-.25-.56.82.82,0,0,0-1.14,0,.85.85,0,0,0-.25.56v8.85"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M206.77,18a.82.82,0,0,0,1.64,0V13.9a.85.85,0,0,0-.25-.56.82.82,0,0,0-1.14,0,.85.85,0,0,0-.25.56V18"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M211.3,18a.82.82,0,0,0,1.38.55.86.86,0,0,0,.26-.55V16.17a.85.85,0,0,0-.25-.56.83.83,0,0,0-.57-.23.81.81,0,0,0-.57.23.85.85,0,0,0-.25.56V18"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M200.81,29.76V28l0,0a3.31,3.31,0,0,1-1.27.32,1.86,1.86,0,0,1-1.27-.38,1.62,1.62,0,0,1-.56-.78,2,2,0,0,1,0-1.06,1.61,1.61,0,0,1,.57-.9,1.7,1.7,0,0,1,.89-.38,2.85,2.85,0,0,1,1.67.31l0,0V23.41l-.08,0a4.57,4.57,0,0,0-1.6-.2,3.72,3.72,0,0,0-1.43.32,3.22,3.22,0,0,0-1.16.91,3.5,3.5,0,0,0-.07,4.27,3.36,3.36,0,0,0,1.86,1.2,4.27,4.27,0,0,0,2.35-.09l.13,0"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M202.56,26.58a3.47,3.47,0,0,0,1.32,2.67,3.42,3.42,0,0,0,2.89.66,3.37,3.37,0,0,0,1.11-6.22,3.48,3.48,0,0,0-5.32,2.89M205,25.23a1.73,1.73,0,0,1,2.16,2.71,1.72,1.72,0,0,1-2.43-.27,1.74,1.74,0,0,1,.27-2.44"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M279.19,18.75a3.23,3.23,0,0,0-1.14,1.83,3.25,3.25,0,0,0,2.09-.6,1.5,1.5,0,0,0,.68-1.13c0-.19-.12-.49-.65-.49a1.83,1.83,0,0,0-1,.38m-21.36-3.62-1.2,4.41c1.76,0,2.86-.3,3.4-2,.45-1.42.27-2.37-1.82-2.37Zm13,2.35h5.5c-.63,2.1-3.61,3.78-4.45,5.37h3.48L275,24.2h-5.65c0-2.12,3.57-4.58,4.25-5.62h-3.08Zm17.24-.12c1.22,0,1.41.73,1.41,1.29a1.05,1.05,0,0,1-1,1.11h0a.85.85,0,0,1-.66-.23.82.82,0,0,1-.24-.54c0-.18-.08-.36-.3-.4a1,1,0,0,0-.82.3,3.84,3.84,0,0,0-.88,1.3,6.92,6.92,0,0,0-.33.86l-.88,3.16h-2.21l1.8-6.72h2.16l-.39,1.35A3.73,3.73,0,0,1,288,17.36m-12.28,4.46a4.67,4.67,0,0,1,4.55-4.5c1.16,0,2.17.55,2.17,1.47a2.65,2.65,0,0,1-1.92,2.31,7.67,7.67,0,0,1-2.65.38,2.57,2.57,0,0,0,0,.48,1.25,1.25,0,0,0,1.3,1.2h0a3.47,3.47,0,0,0,2.12-1.06l.39,1a4.3,4.3,0,0,1-1,.8,4.5,4.5,0,0,1-2.1.49,2.57,2.57,0,0,1-2.82-2.6m-19.87-7.7h2.58c3.95,0,4.23,2,3.91,3.45-.43,1.77-1.5,3-6,3-.45,1.65-.84,3.08-1,3.6h-2.22c.4-1.5,2.73-10.07,2.73-10.07M275.24,8a37.34,37.34,0,0,0-7.46.78C257.32,11,249.6,17.09,249.6,22.92a6.68,6.68,0,0,0,.14,1.33c.76,3.62,4.55,6.19,9.82,7.23,1.11-4.28,3.67-14.1,3.67-14.1a12,12,0,0,1,1.28-3.53,4.06,4.06,0,0,1,3.14-2.12,4.51,4.51,0,0,1,2.62.48,1.38,1.38,0,0,1,.69,1.32A1.37,1.37,0,0,1,269.55,15a1.06,1.06,0,0,1-1.13-1v-.09c0-.57.33-.65.33-1.07,0-.22-.2-.55-.74-.47a2.18,2.18,0,0,0-1.58,1.55,8.17,8.17,0,0,0-.32,1l-.66,2.56h4.36c-.57,2.06-1.54,5.72-1.81,6.72h-2.2l1.5-5.62h-2.15L261.7,31.81a29,29,0,0,0,3.36.19h.13a35.75,35.75,0,0,0,7.29-.78C283,29,291,22.85,291,17a6.21,6.21,0,0,0-.13-1.29c-1-4.79-7.52-7.72-15.63-7.72Z"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M112.17,12.89l-6,14.26h-3.9L99.36,15.77a1.56,1.56,0,0,0-.88-1.25,15.37,15.37,0,0,0-3.64-1.21l.09-.42h6.28a1.73,1.73,0,0,1,1.7,1.46l1.55,8.24,3.84-9.7h3.87m15.27,9.6c0-3.76-5.2-4-5.16-5.65,0-.51.49-1.05,1.56-1.19a6.93,6.93,0,0,1,3.63.64l.65-3a10,10,0,0,0-3.45-.63c-3.64,0-6.21,1.94-6.23,4.71,0,2.06,1.83,3.2,3.23,3.88s1.92,1.15,1.91,1.77c0,1-1.14,1.38-2.2,1.4a7.7,7.7,0,0,1-3.79-.9l-.67,3.12a11.12,11.12,0,0,0,4.1.76c3.88,0,6.41-1.91,6.42-4.88m9.63,4.66h3.41l-3-14.26h-3.15a1.68,1.68,0,0,0-1.57,1l-5.53,13.21h3.87l.77-2.13h4.73Zm-4.12-5,1.94-5.36L136,22.1Zm-15.51-9.21-3,14.26H110.7l3-14.26Z"
            })
        ]
    });

});

parcelRegister("68aRd", function(module, exports) {

var $loA2J = parcelRequire("loA2J");

var $f6qj2 = parcelRequire("f6qj2");

var $fsv0y = parcelRequire("fsv0y");
const $13970fe0e0293ff0$export$8dd3620498a5658a = ()=>{
    const intl = (0, $f6qj2.default)();
    const submitMessage = intl.formatMessage({
        id: "JiraSoftwarePageTemplate.loggedInHero.goToJira",
        defaultMessage: "Go to Jira"
    });
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $fsv0y.SubmitButton), {
        submitMessage: submitMessage
    });
};

});



parcelRegister("46TBz", function(module, exports) {

$parcel$export(module.exports, "LoggedInJiraFreeManagedUser", function () { return $211abaa53fd31892$export$da59075d59da0bc5; });
/* managed-user.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $dFnC9 = parcelRequire("dFnC9");

var $iu8Ap = parcelRequire("iu8Ap");

var $47Euo = parcelRequire("47Euo");

var $iMdoL = parcelRequire("iMdoL");

var $5ohHq = parcelRequire("5ohHq");

var $1MbAx = parcelRequire("1MbAx");
parcelRequire("2sSmA");
var $61OkS = parcelRequire("61OkS");
const $211abaa53fd31892$export$da59075d59da0bc5 = ()=>{
    const { user: { name: name } } = (0, $iMdoL.useUserContext)();
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $1MbAx.FeatureExposed), {
        experimentKey: "jfind-1565-sign-up-flow-overlay",
        group: "Test",
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $iu8Ap.JiraOverlayTemplate), {
            size: "sm",
            children: /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                className: (0, $esG4f.default)([
                    "_1e0c1txw _2lx21bp4 _16jlkb7n"
                ]),
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsx)("h1", {
                        className: (0, $esG4f.default)([
                            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _y3gn1h6o"
                        ]),
                        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $61OkS.WelcomeBackHeading), {
                            name: name
                        })
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("p", {
                        className: (0, $esG4f.default)([
                            "_syaz1hlo _1pfh1y44 _6rth7vkz _y3gn1h6o"
                        ]),
                        style: {
                            "--_188070z": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.primary.black"))
                        },
                        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                            id: "JiraSoftwarePageTemplate.loggedInHero.pickUpWhereYouLeftOff",
                            defaultMessage: "Pick up where you left off in Jira."
                        })
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)((0, $47Euo.default), {})
                ]
            })
        })
    });
};
const $211abaa53fd31892$var$containerCss = null;
const $211abaa53fd31892$var$headerCss = null;
const $211abaa53fd31892$var$subHeaderCss = null;

});

parcelRegister("iRx0w", function(module, exports) {

$parcel$export(module.exports, "LoggedInJiraFreeWeekOneUser", function () { return $6701c8d2a19aa05d$export$d8dccd22f722bb13; });
/* week-one-user.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $dFnC9 = parcelRequire("dFnC9");

var $iu8Ap = parcelRequire("iu8Ap");

var $47Euo = parcelRequire("47Euo");

var $iMdoL = parcelRequire("iMdoL");

var $5ohHq = parcelRequire("5ohHq");

var $1MbAx = parcelRequire("1MbAx");
parcelRequire("2sSmA");
var $61OkS = parcelRequire("61OkS");
const $6701c8d2a19aa05d$export$d8dccd22f722bb13 = ()=>{
    const { user: { name: name } } = (0, $iMdoL.useUserContext)();
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $1MbAx.FeatureExposed), {
        experimentKey: "jfind-1565-sign-up-flow-overlay",
        group: "Test",
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $iu8Ap.JiraOverlayTemplate), {
            size: "sm",
            children: /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                className: (0, $esG4f.default)([
                    "_1e0c1txw _2lx21bp4 _16jlkb7n"
                ]),
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsx)("h1", {
                        className: (0, $esG4f.default)([
                            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _y3gn1h6o"
                        ]),
                        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $61OkS.WelcomeBackHeading), {
                            name: name
                        })
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("p", {
                        className: (0, $esG4f.default)([
                            "_syaz1hlo _1pfh1y44 _6rth7vkz _y3gn1h6o"
                        ]),
                        style: {
                            "--_188070z": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.primary.black"))
                        },
                        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                            id: "JiraSoftwarePageTemplate.loggedInHero.pickUpWhereYouLeftOff",
                            defaultMessage: "Pick up where you left off in Jira."
                        })
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)((0, $47Euo.default), {})
                ]
            })
        })
    });
};
const $6701c8d2a19aa05d$var$containerCss = null;
const $6701c8d2a19aa05d$var$headerCss = null;
const $6701c8d2a19aa05d$var$subHeaderCss = null;

});


parcelRegister("coFBw", function(module, exports) {

$parcel$export(module.exports, "LoggedInJiraPremium", function () { return $e2d4dc116df02cc8$export$6a2883bc58010609; });

var $loA2J = parcelRequire("loA2J");

var $iMdoL = parcelRequire("iMdoL");

var $2owTN = parcelRequire("2owTN");

var $hR7VD = parcelRequire("hR7VD");

var $gpUdZ = parcelRequire("gpUdZ");
const $e2d4dc116df02cc8$export$6a2883bc58010609 = ()=>{
    const cohort = (0, $iMdoL.useCohort)();
    if (cohort === (0, $iMdoL.COHORTS).NEW_USER) return /*#__PURE__*/ (0, $loA2J.jsx)((0, $2owTN.LoggedInJiraNewUser), {});
    if (cohort === (0, $iMdoL.COHORTS).UPGRADE_ELIGIBLE_USER) return /*#__PURE__*/ (0, $loA2J.jsx)((0, $gpUdZ.LoggedInJiraPremiumUpgradeEligibleUser), {});
    if (cohort) return /*#__PURE__*/ (0, $loA2J.jsx)((0, $hR7VD.LoggedInJiraPremiumExistingUser), {});
    return null;
};

});
parcelRegister("hR7VD", function(module, exports) {

$parcel$export(module.exports, "LoggedInJiraPremiumExistingUser", function () { return $4de96eedf0c6903f$export$59403246109877db; });

var $loA2J = parcelRequire("loA2J");

var $f6qj2 = parcelRequire("f6qj2");

var $dSfKs = parcelRequire("dSfKs");
const $4de96eedf0c6903f$export$59403246109877db = ()=>{
    const { formatMessage: formatMessage } = (0, $f6qj2.default)();
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $dSfKs.LoggedInJiraBlueWaveTemplateExistingUser), {
        productEditionText: formatMessage({
            id: "WacSignupHeader.cloudPremium",
            defaultMessage: "Cloud Premium"
        })
    });
};

});
parcelRegister("dSfKs", function(module, exports) {

$parcel$export(module.exports, "LoggedInJiraBlueWaveTemplateExistingUser", function () { return $67e4c7b9a3074fdc$export$15d703e99d473a81; });
/* logged-in-blue-wave-template-jira-existing-user.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $f6qj2 = parcelRequire("f6qj2");

var $bLpA6 = parcelRequire("bLpA6");

var $coCMP = parcelRequire("coCMP");

var $47Euo = parcelRequire("47Euo");

var $gNKPy = parcelRequire("gNKPy");

var $jgJpJ = parcelRequire("jgJpJ");

var $iMdoL = parcelRequire("iMdoL");

var $bhreu = parcelRequire("bhreu");
parcelRequire("ia5W9");
var $cHXak = parcelRequire("cHXak");
var $587P6 = parcelRequire("587P6");
var $eZrnm = parcelRequire("eZrnm");
parcelRequire("2sSmA");
var $a7jHq = parcelRequire("a7jHq");
const $67e4c7b9a3074fdc$export$15d703e99d473a81 = ({ productEditionText: productEditionText })=>{
    const { formatMessage: formatMessage } = (0, $f6qj2.default)();
    const { user: { name: name, email: email } } = (0, $iMdoL.useUserContext)();
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $coCMP.BlueWaveTemplate), {
        productEditionText: productEditionText,
        socialProofLogos: /*#__PURE__*/ (0, $loA2J.jsx)((0, $a7jHq.SquareVisaCiscoPfizer), {}),
        tagline: formatMessage({
            id: "WacSignupForm.signupOfferingIncludesFeaturesSocialProofTextJira",
            defaultMessage: "Trusted by over 65,000 teams worldwide"
        }),
        valueProps: formatMessage({
            id: "WacSignupForm.signupOfferingIncludesFeaturesFreeJSWFI",
            defaultMessage: "Scale agile practices{newline}Consolidate workflows{newline}Expand visibility{newline}Plan, track, and release"
        }).split("{newline}"),
        productLogos: [
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $bLpA6.JiraLogo), {
                appearance: "inverse",
                size: "xlarge"
            }, "jsm")
        ],
        illustration: /*#__PURE__*/ (0, $loA2J.jsx)((0, $bhreu.Picture), {
            image: {
                src: "https://atlassian.com/dam/jcr:775fdafc-0622-4a54-acdf-1c3ca0da5e83/jira-family-hero.png",
                alt: ""
            }
        }),
        children: /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
            className: (0, $esG4f.default)([
                "_1e0c11p5 _zulpftgi"
            ]),
            children: [
                /*#__PURE__*/ (0, $loA2J.jsx)("h2", {
                    className: (0, $esG4f.default)([
                        "_1wyb1tcg _k48pbfng _19pkidpf _2hwxidpf _otyridpf _18u0idpf _y3gn1h6o"
                    ]),
                    children: name ? formatMessage({
                        id: "BxpUiSignup.nameSite.header",
                        defaultMessage: "Welcome back, {name}"
                    }, {
                        name: (0, $jgJpJ.getFirstName)(name)
                    }) : formatMessage({
                        id: "JiraSoftwarePageTemplate.loggedInHero.welcomeBack",
                        defaultMessage: "Welcome back"
                    })
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)((0, $cHXak.InputEmail), {
                    email: email
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)((0, $47Euo.default), {
                    ExistingUser: /*#__PURE__*/ (0, $loA2J.jsx)((0, $47Euo.ExistingUser), {
                        SubmitButton: /*#__PURE__*/ (0, $loA2J.jsx)((0, $587P6.SubmitButtonExistingUser), {}),
                        SitePicker: /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                            className: (0, $esG4f.default)([
                                "_84yz1wa3 _eeia15se _5pvqc4v4"
                            ]),
                            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $gNKPy.SitePicker), {})
                        })
                    }),
                    ManagedUser: null,
                    WeekOneUser: null
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                    className: (0, $esG4f.default)([
                        "_1pfh1crf _6rth1tcg _clfd1crf _11pqidpf _q0a5idpf _c3k8idpf"
                    ]),
                    children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $eZrnm.NoCreditCardRequired), {})
                })
            ]
        })
    });
};
const $67e4c7b9a3074fdc$var$containerCss = null;
const $67e4c7b9a3074fdc$var$siteActivationHeadingCss = null;
const $67e4c7b9a3074fdc$var$spacingSyles = null;
const $67e4c7b9a3074fdc$var$sitePickerCss = null;

});


parcelRegister("gpUdZ", function(module, exports) {

$parcel$export(module.exports, "LoggedInJiraPremiumUpgradeEligibleUser", function () { return $1c27915590d98bfe$export$c4bff09cf0f8d30d; });

var $loA2J = parcelRequire("loA2J");

var $f6qj2 = parcelRequire("f6qj2");

var $5kVBY = parcelRequire("5kVBY");

var $2X17f = parcelRequire("2X17f");

var $ctYD4 = parcelRequire("ctYD4");

var $cm6I6 = parcelRequire("cm6I6");

var $7Mypa = parcelRequire("7Mypa");

var $30lzE = parcelRequire("30lzE");

var $guk0p = parcelRequire("guk0p");

var $kwHar = parcelRequire("kwHar");

var $gAJUc = parcelRequire("gAJUc");

var $kuWtz = parcelRequire("kuWtz");
const $1c27915590d98bfe$export$c4bff09cf0f8d30d = ()=>{
    const { formatMessage: formatMessage } = (0, $f6qj2.default)();
    // NOTE: When productionizing this feature, ensure the styles are updated as well. See:
    // https://bitbucket.org/atlassian/atlassian-frontend-monorepo/pull-requests/253829/diff#comment-2000978780
    const useWhitewaveCopy = (0, $gAJUc.checkFeatureFlagGate)((0, $gAJUc.featureFlags).wacJiraUpgradeWhiteWaveCopyUpdate);
    const whitewaveValueProps = [
        {
            icon: /*#__PURE__*/ (0, $loA2J.jsx)((0, $5kVBY.default), {
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($cm6I6))),
                label: "",
                appearance: "blue",
                shape: "circle",
                size: "40"
            }),
            heading: formatMessage({
                id: "WacSignupForm.updatedSignupOfferingIncludesFeaturesPremiumJswBullet1Title",
                defaultMessage: "Admin insights"
            }),
            body: formatMessage({
                id: "WacSignupForm.updatedSignupOfferingIncludesFeaturesPremiumJswBullet1Body",
                defaultMessage: "See data such as level of security, access levels, and activity over time"
            })
        },
        {
            icon: /*#__PURE__*/ (0, $loA2J.jsx)((0, $5kVBY.default), {
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($30lzE))),
                label: "",
                appearance: "blue",
                shape: "circle",
                size: "40"
            }),
            heading: formatMessage({
                id: "WacSignupForm.signupOfferingIncludesFeaturesPremiumJswBullet2Title",
                defaultMessage: "Advanced planning"
            }),
            body: formatMessage({
                id: "WacSignupForm.signupOfferingIncludesFeaturesPremiumJswBullet2Body",
                defaultMessage: "Plan work and track progress across multiple teams and projects"
            })
        },
        {
            icon: /*#__PURE__*/ (0, $loA2J.jsx)((0, $5kVBY.default), {
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($7Mypa))),
                label: "",
                appearance: "blue",
                shape: "circle",
                size: "40"
            }),
            heading: formatMessage({
                id: "WacSignupForm.updatedSignupOfferingIncludesFeaturesPremiumJswBullet3Title",
                defaultMessage: "Permissions"
            }),
            body: formatMessage({
                id: "WacSignupForm.updatedSignupOfferingIncludesFeaturesPremiumJswBullet3Body",
                defaultMessage: "Control what users can create, view, and comment on"
            })
        }
    ];
    // Current valueProps
    const currentValueProps = [
        {
            icon: /*#__PURE__*/ (0, $loA2J.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($2X17f))), {
                color: (0, $kwHar.default)("color.icon.brand"),
                label: "Atlassian Intelligence"
            }),
            heading: formatMessage({
                id: "WacSignupForm.signupOfferingIncludesFeaturesPremiumJswBullet1Title",
                defaultMessage: "Atlassian Intelligence (AI)"
            }),
            body: formatMessage({
                id: "WacSignupForm.signupOfferingIncludesFeaturesPremiumJswBullet1Body",
                defaultMessage: "AI-powered features to help teams create value faster"
            })
        },
        {
            icon: /*#__PURE__*/ (0, $loA2J.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($guk0p))), {
                color: (0, $kwHar.default)("color.icon.brand"),
                label: "Timeline"
            }),
            heading: formatMessage({
                id: "WacSignupForm.signupOfferingIncludesFeaturesPremiumJswBullet2Title",
                defaultMessage: "Advanced planning"
            }),
            body: formatMessage({
                id: "WacSignupForm.signupOfferingIncludesFeaturesPremiumJswBullet2Body",
                defaultMessage: "Plan work and track progress across multiple teams and projects"
            })
        },
        {
            icon: /*#__PURE__*/ (0, $loA2J.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ctYD4))), {
                color: (0, $kwHar.default)("color.icon.brand"),
                label: "Comment"
            }),
            heading: formatMessage({
                id: "WacSignupForm.signupOfferingIncludesFeaturesPremiumJswBullet3Title",
                defaultMessage: "Premium support"
            }),
            body: formatMessage({
                id: "WacSignupForm.signupOfferingIncludesFeaturesPremiumJswBullet3Body",
                defaultMessage: "Get 24/7 support from Atlassian's team of experts"
            })
        }
    ];
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $kuWtz.LoggedInJiraWhiteTemplateUpgradeEligibleUser), {
        productEditionText: formatMessage({
            id: "WacSignupHeader.cloudPremium",
            defaultMessage: "Cloud Premium"
        }),
        textHeading: formatMessage({
            id: "WacSignupForm.signupOfferingIncludesFeaturesPremiumUpgradeTitle",
            defaultMessage: "Upgrade to the Premium plan"
        }),
        textBody: formatMessage({
            id: "WacSignupForm.signupOfferingIncludesFeaturesPremiumJswUpgradeBody",
            defaultMessage: "Get a free 30-day trial of Jira Premium for unlimited users, unlimited storage, and much more. Cancel anytime."
        }),
        valuePropsHeading: formatMessage({
            id: "WacSignupForm.signupOfferingIncludesFeaturesPremiumBulletIntro",
            defaultMessage: "The Premium plan also includes:"
        }),
        valueProps: useWhitewaveCopy ? whitewaveValueProps : currentValueProps,
        useWhitewaveCopyUpdate: useWhitewaveCopy
    });
};

});
parcelRegister("5kVBY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3e2b826bd948fe1f$export$2e2bcd8739ae039; });
/* icon-tile.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $iSvIT = parcelRequire("iSvIT");

var $bsx9n = parcelRequire("bsx9n");

var $jxLBU = parcelRequire("jxLBU");
var $3e2b826bd948fe1f$var$sizeMap = {
    "16": "_1bsb7vkz _4t3i7vkz",
    "24": "_1bsb1tcg _4t3i1tcg",
    "32": "_1bsbzwfg _4t3izwfg",
    "40": "_1bsb1ylp _4t3i1ylp",
    "48": "_1bsbckbl _4t3ickbl"
};
var $3e2b826bd948fe1f$var$appearanceMap = {
    grayBold: "_bfhk1t1b _syaz5w2r",
    limeBold: "_bfhktde4 _syaz5w2r",
    greenBold: "_bfhk1e5c _syaz5w2r",
    blueBold: "_bfhkc8cv _syaz5w2r",
    redBold: "_bfhkuibq _syaz5w2r",
    purpleBold: "_bfhkygwo _syaz5w2r",
    magentaBold: "_bfhkc3uk _syaz5w2r",
    tealBold: "_bfhk2c8p _syaz5w2r",
    orangeBold: "_bfhkjgng _syaz5w2r",
    yellowBold: "_bfhk1vop _syaz5w2r",
    gray: "_bfhk1v33 _syaz16ni",
    lime: "_bfhkz2ec _syaz8645",
    orange: "_bfhkf2vu _syaz7r97",
    magenta: "_bfhkv9ra _syazv8hk",
    green: "_bfhk1wnw _syaz17hp",
    blue: "_bfhk4v9p _syaz1ov1",
    red: "_bfhk1rtt _syaznbxb",
    purple: "_bfhk1jkz _syaz5yjc",
    teal: "_bfhk1a17 _syaz8uof",
    yellow: "_bfhk3fv2 _syaz1oqg"
};
var $3e2b826bd948fe1f$var$shapeMap = {
    square: "_2rkoiti9",
    circle: "_2rko14q2"
};
var $3e2b826bd948fe1f$var$iconTileStyles = null;
function $3e2b826bd948fe1f$export$2e2bcd8739ae039(props) {
    var Icon = props.icon, label = props.label, appearance = props.appearance, _props$size = props.size, size = _props$size === void 0 ? "24" : _props$size, _props$shape = props.shape, shape = _props$shape === void 0 ? "square" : _props$shape, LEGACY_fallbackComponent = props.LEGACY_fallbackComponent, testId = props.testId;
    var ExpandedIcon = Icon;
    // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
    if (LEGACY_fallbackComponent && !(0, $jxLBU.fg)("platform-visual-refresh-icons")) return LEGACY_fallbackComponent;
    else return /*#__PURE__*/ $iSvIT.createElement("span", {
        "data-testid": testId,
        className: (0, $bsx9n.default)([
            "_1e0c116y _vchhusvi _4cvr1h6o _1bah1h6o _1wybidpf",
            $3e2b826bd948fe1f$var$appearanceMap[appearance],
            $3e2b826bd948fe1f$var$sizeMap[size],
            $3e2b826bd948fe1f$var$shapeMap[shape]
        ])
    }, /*#__PURE__*/ $iSvIT.createElement(ExpandedIcon, {
        color: "currentColor",
        label: label,
        spacing: "spacious",
        shouldScale: true
    }));
}

});

parcelRegister("2X17f", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b8054c1d672105cf334f7f37a83f0cf2>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $2261f51209fdb137$var$_react = $2261f51209fdb137$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $2261f51209fdb137$var$_baseNew = $2261f51209fdb137$var$_interopRequireDefault((parcelRequire("2zXTv")));
function $2261f51209fdb137$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "AtlassianIntelligence".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for Atlassian Intelligence products or experiences.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $2261f51209fdb137$var$AtlassianIntelligenceIcon = (props)=>/*#__PURE__*/ $2261f51209fdb137$var$_react.default.createElement($2261f51209fdb137$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M7.25 4V1h1.5v3zM5.47 6.53l-4-4 1.06-1.06 4 4zm4-1.06 4-4 1.06 1.06-4 4zM1 7.25h3v1.5H1zm11 0h3v1.5h-3zM1.47 13.47l4-4 1.06 1.06-4 4zm12 1.06-4-4 1.06-1.06 4 4zM7.25 15v-3h1.5v3z" clip-rule="evenodd"/>`
    }, props));
$2261f51209fdb137$var$AtlassianIntelligenceIcon.displayName = "AtlassianIntelligenceIcon";
var $2261f51209fdb137$var$_default = module.exports.default = $2261f51209fdb137$var$AtlassianIntelligenceIcon;

});

parcelRegister("7Mypa", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::25e57ba6be3183cfa1e359a1a5374e32>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5aa7b42f5f6227e4$var$_react = $5aa7b42f5f6227e4$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $5aa7b42f5f6227e4$var$_baseNew = $5aa7b42f5f6227e4$var$_interopRequireDefault((parcelRequire("2zXTv")));
function $5aa7b42f5f6227e4$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "LockUnlocked".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: unlocked page in Confluence.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $5aa7b42f5f6227e4$var$LockUnlockedIcon = (props)=>/*#__PURE__*/ $5aa7b42f5f6227e4$var$_react.default.createElement($5aa7b42f5f6227e4$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 1.5A2.5 2.5 0 0 0 5.5 4v3H12a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V9a2 2 0 0 1 2-2V4a4 4 0 1 1 8 0h-1.5A2.5 2.5 0 0 0 8 1.5m-4 7a.5.5 0 0 0-.5.5v5a.5.5 0 0 0 .5.5h8a.5.5 0 0 0 .5-.5V9a.5.5 0 0 0-.5-.5z" clip-rule="evenodd"/>`
    }, props));
$5aa7b42f5f6227e4$var$LockUnlockedIcon.displayName = "LockUnlockedIcon";
var $5aa7b42f5f6227e4$var$_default = module.exports.default = $5aa7b42f5f6227e4$var$LockUnlockedIcon;

});

parcelRegister("kuWtz", function(module, exports) {

$parcel$export(module.exports, "LoggedInJiraWhiteTemplateUpgradeEligibleUser", function () { return $c92d27fefb993d07$export$957409ddf7533d80; });
/* logged-in-jira-upgrade-eligible-user.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $f6qj2 = parcelRequire("f6qj2");

var $bLpA6 = parcelRequire("bLpA6");

var $iu8Ap = parcelRequire("iu8Ap");

var $47Euo = parcelRequire("47Euo");

var $jgJpJ = parcelRequire("jgJpJ");

var $iMdoL = parcelRequire("iMdoL");
parcelRequire("ia5W9");
var $cHXak = parcelRequire("cHXak");
var $jN1Op = parcelRequire("jN1Op");
var $eZrnm = parcelRequire("eZrnm");
parcelRequire("ddK6j");
var $bS7zZ = parcelRequire("bS7zZ");
const $c92d27fefb993d07$export$957409ddf7533d80 = (props)=>{
    const { formatMessage: formatMessage } = (0, $f6qj2.default)();
    const { user: { name: name, email: email } } = (0, $iMdoL.useUserContext)(); // Upgradeable Standard Sites Experiment
    const existingSites = (0, $bS7zZ.useGetExistingSites)();
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $iu8Ap.WhiteTemplate), (0, $6iHNw._)((0, $7Knp0._)({}, props), {
        productLogos: [
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $bLpA6.JiraLogo), {
                appearance: "brand",
                size: "xlarge"
            }, "jira")
        ],
        children: /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
            className: (0, $esG4f.default)([
                "_1e0c11p5 _zulpftgi"
            ]),
            children: [
                /*#__PURE__*/ (0, $loA2J.jsx)("h2", {
                    className: (0, $esG4f.default)([
                        "_1wyb1tcg _k48pbfng _19pkidpf _2hwxidpf _otyridpf _18u0idpf _y3gn1h6o"
                    ]),
                    children: name ? formatMessage({
                        id: "BxpUiSignup.nameSite.header",
                        defaultMessage: "Welcome back, {name}"
                    }, {
                        name: (0, $jgJpJ.getFirstName)(name)
                    }) : formatMessage({
                        id: "JiraSoftwarePageTemplate.loggedInHero.welcomeBack",
                        defaultMessage: "Welcome back"
                    })
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)((0, $cHXak.InputEmail), {
                    email: email
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)((0, $47Euo.default), {
                    existingSites: existingSites,
                    UpgradeEligibleUser: existingSites ? /*#__PURE__*/ (0, $loA2J.jsx)((0, $47Euo.UpgradeEligibleUser), {
                        SubmitButton: /*#__PURE__*/ (0, $loA2J.jsx)((0, $jN1Op.SubmitButtonMessageNext), {})
                    }) : undefined
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                    className: (0, $esG4f.default)([
                        "_1pfh1crf _6rth1tcg _clfd1crf _11pqidpf _q0a5idpf _c3k8idpf"
                    ]),
                    children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $eZrnm.NoCreditCardRequired), {})
                })
            ]
        })
    }));
};
const $c92d27fefb993d07$var$containerCss = null;
const $c92d27fefb993d07$var$siteActivationHeadingCss = null;
const $c92d27fefb993d07$var$spacingStyles = null;

});



parcelRegister("hV4QP", function(module, exports) {

$parcel$export(module.exports, "LoggedInJiraStandard", function () { return $7b844a80055a7243$export$4727bb85fea1ea28; });

var $loA2J = parcelRequire("loA2J");

var $iMdoL = parcelRequire("iMdoL");

var $2owTN = parcelRequire("2owTN");

var $dYKWe = parcelRequire("dYKWe");

var $bVBoF = parcelRequire("bVBoF");
const $7b844a80055a7243$export$4727bb85fea1ea28 = ()=>{
    const cohort = (0, $iMdoL.useCohort)();
    if (cohort === (0, $iMdoL.COHORTS).NEW_USER) return /*#__PURE__*/ (0, $loA2J.jsx)((0, $2owTN.LoggedInJiraNewUser), {});
    if (cohort === (0, $iMdoL.COHORTS).UPGRADE_ELIGIBLE_USER) return /*#__PURE__*/ (0, $loA2J.jsx)((0, $bVBoF.LoggedInJiraStandardUpgradeEligibleUser), {});
    if (cohort) return /*#__PURE__*/ (0, $loA2J.jsx)((0, $dYKWe.LoggedInJiraStandardExistingUser), {});
    return null;
};

});
parcelRegister("dYKWe", function(module, exports) {

$parcel$export(module.exports, "LoggedInJiraStandardExistingUser", function () { return $f8a40312b39d0d3c$export$ce18df5e32f27dc8; });

var $loA2J = parcelRequire("loA2J");

var $f6qj2 = parcelRequire("f6qj2");

var $dSfKs = parcelRequire("dSfKs");
const $f8a40312b39d0d3c$export$ce18df5e32f27dc8 = ()=>{
    const { formatMessage: formatMessage } = (0, $f6qj2.default)();
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $dSfKs.LoggedInJiraBlueWaveTemplateExistingUser), {
        productEditionText: formatMessage({
            id: `WacSignupForm.cloudStandard`,
            defaultMessage: "Cloud Standard"
        })
    });
};

});

parcelRegister("bVBoF", function(module, exports) {

$parcel$export(module.exports, "LoggedInJiraStandardUpgradeEligibleUser", function () { return $2e14ca69d368089d$export$af53b4a52fb13e22; });

var $loA2J = parcelRequire("loA2J");

var $f6qj2 = parcelRequire("f6qj2");

var $ctYD4 = parcelRequire("ctYD4");

var $3uD1D = parcelRequire("3uD1D");

var $iHmgk = parcelRequire("iHmgk");

var $kwHar = parcelRequire("kwHar");

var $kuWtz = parcelRequire("kuWtz");
const $2e14ca69d368089d$export$af53b4a52fb13e22 = ()=>{
    const { formatMessage: formatMessage } = (0, $f6qj2.default)();
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $kuWtz.LoggedInJiraWhiteTemplateUpgradeEligibleUser), {
        productEditionText: formatMessage({
            id: `WacSignupForm.cloudStandard`,
            defaultMessage: "Cloud Standard"
        }),
        textHeading: formatMessage({
            id: "WacSignupForm.signupOfferingIncludesFeaturesStandardUpgradeTitle",
            defaultMessage: "Upgrade to the Standard plan"
        }),
        textBody: formatMessage({
            id: "WacSignupForm.signupOfferingIncludesFeaturesStandardUpgradeBody",
            defaultMessage: "Get a free 14-day trial of Jira Standard for unlimited users, additional storage, and much more. Cancel anytime."
        }),
        valuePropsHeading: formatMessage({
            id: "WacSignupForm.signupOfferingIncludesFeaturesStandardBulletIntro",
            defaultMessage: "The Standard plan also includes:"
        }),
        valueProps: [
            {
                icon: /*#__PURE__*/ (0, $loA2J.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($3uD1D))), {
                    color: (0, $kwHar.default)("color.icon.brand"),
                    label: "PersonAdd"
                }),
                heading: formatMessage({
                    id: "WacSignupForm.signupOfferingIncludesFeaturesStandardJswBullet1Title",
                    defaultMessage: "User roles & permissions"
                }),
                body: formatMessage({
                    id: "WacSignupForm.signupOfferingIncludesFeaturesStandardJswBullet1Body",
                    defaultMessage: "Have more control over which users have access to different projects and actions."
                })
            },
            {
                icon: /*#__PURE__*/ (0, $loA2J.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($iHmgk))), {
                    color: (0, $kwHar.default)("color.icon.brand"),
                    label: "PersonAdd"
                }),
                heading: formatMessage({
                    id: "WacSignupForm.signupOfferingIncludesFeaturesStandardJswBullet2Title",
                    defaultMessage: "Anonymous access"
                }),
                body: formatMessage({
                    id: "WacSignupForm.signupOfferingIncludesFeaturesStandardJswBullet2Body",
                    defaultMessage: "Give secure access to people outside your team."
                })
            },
            {
                icon: /*#__PURE__*/ (0, $loA2J.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ctYD4))), {
                    color: (0, $kwHar.default)("color.icon.brand"),
                    label: "Comment"
                }),
                heading: formatMessage({
                    id: "WacSignupForm.signupOfferingIncludesFeaturesStandardJswBullet3Title",
                    defaultMessage: "Business hour support"
                }),
                body: formatMessage({
                    id: "WacSignupForm.signupOfferingIncludesFeaturesStandardJswBullet3Body",
                    defaultMessage: "Get support from Atlassian\u2019s team of experts."
                })
            }
        ]
    });
};

});



parcelRegister("2zT2h", function(module, exports) {
$parcel$export(module.exports, "LoggedOutJira", function () { return (parcelRequire("lv3WA")).LoggedOutJira; });
parcelRequire("lv3WA");

});
parcelRegister("lv3WA", function(module, exports) {

$parcel$export(module.exports, "LoggedOutJira", function () { return $b0bf2e8f5d1cfa57$export$beeaebb3f31e5db2; });

var $loA2J = parcelRequire("loA2J");

var $iMdoL = parcelRequire("iMdoL");
parcelRequire("8PLgs");
var $fFvsi = parcelRequire("fFvsi");
parcelRequire("lD3Wz");
var $6VrRQ = parcelRequire("6VrRQ");
parcelRequire("d6dCb");
var $hZBdX = parcelRequire("hZBdX");
const $b0bf2e8f5d1cfa57$export$beeaebb3f31e5db2 = ()=>{
    const { edition: edition } = (0, $iMdoL.useUserContext)();
    if (edition === "premium") return /*#__PURE__*/ (0, $loA2J.jsx)((0, $6VrRQ.LoggedOutJiraPremium), {});
    if (edition === "standard") return /*#__PURE__*/ (0, $loA2J.jsx)((0, $hZBdX.LoggedOutJiraStandard), {});
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $fFvsi.LoggedOutJiraFree), {});
};

});
parcelRegister("8PLgs", function(module, exports) {
$parcel$export(module.exports, "LoggedOutJiraFree", function () { return (parcelRequire("fFvsi")).LoggedOutJiraFree; });
parcelRequire("fFvsi");

});
parcelRegister("fFvsi", function(module, exports) {

$parcel$export(module.exports, "LoggedOutJiraFree", function () { return $6d7b3e0db266812f$export$f79660ec8d789c11; });
/* logged-out-jira-free.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $dFnC9 = parcelRequire("dFnC9");

var $axg8K = parcelRequire("axg8K");

var $iu8Ap = parcelRequire("iu8Ap");

var $5ohHq = parcelRequire("5ohHq");

var $1MbAx = parcelRequire("1MbAx");
parcelRequire("ia5W9");
var $esacZ = parcelRequire("esacZ");
var $5cDws = parcelRequire("5cDws");
const $6d7b3e0db266812f$export$f79660ec8d789c11 = ()=>/*#__PURE__*/ (0, $loA2J.jsx)((0, $1MbAx.FeatureExposed), {
        experimentKey: "jfind-1565-sign-up-flow-overlay",
        group: "Test",
        children: /*#__PURE__*/ (0, $loA2J.jsxs)((0, $iu8Ap.JiraOverlayTemplate), {
            size: "sm",
            children: [
                /*#__PURE__*/ (0, $loA2J.jsx)((0, $esacZ.GetStartedHeading), {
                    productName: "Jira"
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)("p", {
                    className: (0, $esG4f.default)([
                        "_syaz1hlo _19pkidpf _2hwxidpf _otyr1tcg _18u0idpf _y3gn1h6o"
                    ]),
                    style: {
                        "--_188070z": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.primary.black"))
                    },
                    children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                        id: "signupForm.accountCreation.subHeaderText",
                        defaultMessage: "It\u2019s free for up to 10 users - no credit card needed."
                    })
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)((0, $1MbAx.FeatureExposed), {
                    experimentKey: "jfind-1185-signup-button-update",
                    group: "Test",
                    children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $axg8K.default), {
                        Input: /*#__PURE__*/ (0, $loA2J.jsx)((0, $5cDws.InputSubmitButton), {}),
                        Submit: null
                    })
                })
            ]
        })
    });
const $6d7b3e0db266812f$var$subHeaderCss = null;

});


parcelRegister("lD3Wz", function(module, exports) {
$parcel$export(module.exports, "LoggedOutJiraPremium", function () { return (parcelRequire("6VrRQ")).LoggedOutJiraPremium; });
parcelRequire("6VrRQ");

});
parcelRegister("6VrRQ", function(module, exports) {

$parcel$export(module.exports, "LoggedOutJiraPremium", function () { return $556db88b3930c1dd$export$129705c0e8cc4c41; });

var $loA2J = parcelRequire("loA2J");

var $f6qj2 = parcelRequire("f6qj2");

var $axg8K = parcelRequire("axg8K");

var $iu8Ap = parcelRequire("iu8Ap");
const $556db88b3930c1dd$export$129705c0e8cc4c41 = ()=>{
    const intl = (0, $f6qj2.default)();
    const heading1 = intl.formatMessage({
        id: "BxpUiSignup.SignupForm.header",
        defaultMessage: "Get started with {product}"
    }, {
        product: "Jira"
    });
    const heading2 = intl.formatMessage({
        id: "BxpUiSignup.SignupForm.subheader.jsw.premium",
        defaultMessage: "30-day free trial for unlimited users on the Premium plan \u2014 no credit card needed"
    });
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $iu8Ap.WhiteScreenLayout), {
        heading1: heading1,
        heading2: heading2,
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $axg8K.default), {
            Input: /*#__PURE__*/ (0, $loA2J.jsx)((0, $iu8Ap.WhiteScreenInput), {}),
            Social: /*#__PURE__*/ (0, $loA2J.jsx)((0, $iu8Ap.WhiteScreenSocial), {}),
            Submit: /*#__PURE__*/ (0, $loA2J.jsx)((0, $iu8Ap.WhiteScreenSubmit), {})
        })
    });
};

});


parcelRegister("d6dCb", function(module, exports) {
$parcel$export(module.exports, "LoggedOutJiraStandard", function () { return (parcelRequire("hZBdX")).LoggedOutJiraStandard; });
parcelRequire("hZBdX");

});
parcelRegister("hZBdX", function(module, exports) {

$parcel$export(module.exports, "LoggedOutJiraStandard", function () { return $356bb7dcca2a3d0c$export$3b6cb8cefe40e033; });

var $loA2J = parcelRequire("loA2J");

var $f6qj2 = parcelRequire("f6qj2");

var $axg8K = parcelRequire("axg8K");

var $iu8Ap = parcelRequire("iu8Ap");
const $356bb7dcca2a3d0c$export$3b6cb8cefe40e033 = ()=>{
    const intl = (0, $f6qj2.default)();
    const heading1 = intl.formatMessage({
        id: "BxpUiSignup.SignupForm.header",
        defaultMessage: "Get started with {product}"
    }, {
        product: "Jira"
    });
    const heading2 = intl.formatMessage({
        id: "BxpUiSignup.SignupForm.subheader.jsw.standard",
        defaultMessage: "14-day free trial for unlimited users on the Standard plan \u2014 no credit card needed"
    });
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $iu8Ap.WhiteScreenLayout), {
        heading1: heading1,
        heading2: heading2,
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $axg8K.default), {
            Input: /*#__PURE__*/ (0, $loA2J.jsx)((0, $iu8Ap.WhiteScreenInput), {}),
            Social: /*#__PURE__*/ (0, $loA2J.jsx)((0, $iu8Ap.WhiteScreenSocial), {}),
            Submit: /*#__PURE__*/ (0, $loA2J.jsx)((0, $iu8Ap.WhiteScreenSubmit), {})
        })
    });
};

});





parcelRegister("kqBSN", function(module, exports) {

$parcel$export(module.exports, "JpdSignup", function () { return $716f4d6289e449dd$export$dc2b102bb1cfa016; });

var $loA2J = parcelRequire("loA2J");

var $iMdoL = parcelRequire("iMdoL");

var $9WJdb = parcelRequire("9WJdb");

var $k664o = parcelRequire("k664o");
const $716f4d6289e449dd$export$dc2b102bb1cfa016 = ()=>{
    const { user: { isUserLoggedIn: isUserLoggedIn } } = (0, $iMdoL.useUserContext)();
    if (isUserLoggedIn) return /*#__PURE__*/ (0, $loA2J.jsx)((0, $9WJdb.LoggedInJpd), {});
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $k664o.LoggedOutJpd), {});
};

});
parcelRegister("9WJdb", function(module, exports) {

$parcel$export(module.exports, "LoggedInJpd", function () { return $4bf92a70b012c8f9$export$cb2a08d7c43e3ee1; });

var $loA2J = parcelRequire("loA2J");

var $iMdoL = parcelRequire("iMdoL");

var $aOuDE = parcelRequire("aOuDE");
parcelRequire("ia5W9");
var $6dDlC = parcelRequire("6dDlC");

var $gsbkj = parcelRequire("gsbkj");

var $4KKXI = parcelRequire("4KKXI");

var $abOhf = parcelRequire("abOhf");
const $4bf92a70b012c8f9$export$cb2a08d7c43e3ee1 = ()=>{
    const isMobile = (0, $aOuDE.useIsMobile)();
    return isMobile ? /*#__PURE__*/ (0, $loA2J.jsx)((0, $6dDlC.SignupDefault), {}) : /*#__PURE__*/ (0, $loA2J.jsx)($4bf92a70b012c8f9$var$CohortComponent, {});
};
const $4bf92a70b012c8f9$var$CohortComponent = ()=>{
    const isStandard = (0, $iMdoL.useStandardIntent)();
    const isPremium = (0, $iMdoL.usePremiumIntent)();
    const isFree = (0, $iMdoL.useFreeIntent)();
    if (isFree) return /*#__PURE__*/ (0, $loA2J.jsx)((0, $gsbkj.LoggedInJpdFree), {});
    if (isStandard) return /*#__PURE__*/ (0, $loA2J.jsx)((0, $abOhf.LoggedInJpdStandard), {});
    if (isPremium) return /*#__PURE__*/ (0, $loA2J.jsx)((0, $4KKXI.LoggedInJpdPremium), {});
    // bxpkit catch-all (paid editions if gate is off)
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $6dDlC.SignupDefault), {});
};

});
parcelRegister("gsbkj", function(module, exports) {

$parcel$export(module.exports, "LoggedInJpdFree", function () { return $4c736e818891c37a$export$e7aa14f55abb6efc; });

var $loA2J = parcelRequire("loA2J");

var $iMdoL = parcelRequire("iMdoL");

var $7VQEu = parcelRequire("7VQEu");

var $8m0rG = parcelRequire("8m0rG");
const $4c736e818891c37a$export$e7aa14f55abb6efc = ()=>{
    const cohort = (0, $iMdoL.useCohort)();
    if (cohort === "new-user") return /*#__PURE__*/ (0, $loA2J.jsx)((0, $8m0rG.LoggedInJpdNewUser), {});
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $7VQEu.LoggedInJpdExistingUser), {});
};

});
parcelRegister("7VQEu", function(module, exports) {

$parcel$export(module.exports, "LoggedInJpdExistingUser", function () { return $21cf821a93d14d82$export$e7519de7d50e16c8; });
/* existing-user.tsx generated by @compiled/babel-plugin v0.28.8 */ // @ts-ignore

var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $eDoPe = parcelRequire("eDoPe");

var $f6qj2 = parcelRequire("f6qj2");

var $6IicP = parcelRequire("6IicP");

var $47Euo = parcelRequire("47Euo");

var $iMdoL = parcelRequire("iMdoL");

var $1MbAx = parcelRequire("1MbAx");
parcelRequire("5XFHK");
var $kBgD7 = parcelRequire("kBgD7");
const $21cf821a93d14d82$export$e7519de7d50e16c8 = ()=>{
    const { ref: ref, inView: inView } = (0, $eDoPe.useInView)();
    const isLoggedInHasJira = (0, $iMdoL.useLoggedInHasJira)();
    (0, $1MbAx.useFeatureExposed)("gwp-7053-jpd-lofi-signup", "Test", {
        conditions: [
            inView
        ],
        metadata: {
            hasJira: isLoggedInHasJira
        }
    });
    if (isLoggedInHasJira) return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        ref: ref,
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $6IicP.JiraOverlayTemplate), {
            size: "sm",
            children: /*#__PURE__*/ (0, $loA2J.jsx)($21cf821a93d14d82$var$Content, {})
        })
    });
    else return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        ref: ref,
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $6IicP.JPDOverlayTemplate), {
            size: "sm",
            children: /*#__PURE__*/ (0, $loA2J.jsx)($21cf821a93d14d82$var$Content, {})
        })
    });
};
const $21cf821a93d14d82$var$Content = ()=>{
    const { user: { name: name } } = (0, $iMdoL.useUserContext)();
    const { formatMessage: formatMessage } = (0, $f6qj2.default)();
    return /*#__PURE__*/ (0, $loA2J.jsxs)((0, $loA2J.Fragment), {
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("h1", {
                className: (0, $esG4f.default)([
                    "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _y3gn1h6o"
                ]),
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $kBgD7.WelcomeBackHeading), {
                    name: name
                })
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("p", {
                className: (0, $esG4f.default)([
                    "_19pk7vkz _2hwxidpf _otyr7vkz _18u0idpf _y3gn1h6o _ect48q0o _1wyb7vkz"
                ]),
                children: formatMessage({
                    id: "LoomTemplate.loggedInHero.subheader",
                    defaultMessage: "Sites are shared spaces to organize work, teams, and projects."
                })
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $47Euo.default), {}),
            /*#__PURE__*/ (0, $loA2J.jsx)("footer", {
                className: (0, $esG4f.default)([
                    "_1wyb1crf _k48p1nn1 _19pkidpf _2hwxidpf _otyridpf _18u0idpf _ect48q0o"
                ]),
                children: formatMessage({
                    id: "JiraSoftwarePageTemplate.loggedInHero.recatcha",
                    defaultMessage: "This page is protected by reCAPTCHA and the Google Privacy Policy and Terms of Service apply."
                })
            })
        ]
    });
};
const $21cf821a93d14d82$var$headerCss = null;
const $21cf821a93d14d82$var$subheadingCss = null;
const $21cf821a93d14d82$var$footerCss = null;

});
parcelRegister("5XFHK", function(module, exports) {
$parcel$export(module.exports, "WelcomeBackHeading", function () { return (parcelRequire("kBgD7")).WelcomeBackHeading; });
parcelRequire("kBgD7");
parcelRequire("38XOI");

});
parcelRegister("kBgD7", function(module, exports) {

$parcel$export(module.exports, "WelcomeBackHeading", function () { return $b478a262008c7c1b$export$f8a24991e7eb3d8f; });
/* welcome-back-heading.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $dFnC9 = parcelRequire("dFnC9");

var $jgJpJ = parcelRequire("jgJpJ");
const $b478a262008c7c1b$export$f8a24991e7eb3d8f = ({ name: name })=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
        id: "BxpSignup.SiteExpansionForm.cobrandedHeader.loom",
        defaultMessage: "<scribbleSpan>Welcome</scribbleSpan> back, {name}",
        values: {
            name: (0, $jgJpJ.getFirstName)(name),
            scribbleSpan: $b478a262008c7c1b$var$scribbleSpan
        }
    });
};
const $b478a262008c7c1b$var$scribbleSpan = (children)=>/*#__PURE__*/ (0, $loA2J.jsxs)("span", {
        className: (0, $esG4f.default)([
            "_kqswh2mm"
        ]),
        children: [
            children,
            /*#__PURE__*/ (0, $loA2J.jsx)("svg", {
                "aria-hidden": true,
                viewBox: "0 0 105 17",
                className: (0, $esG4f.default)([
                    "_lswuh727 _4t3io7ao _u7co1bs0 _1e02idpf _kqswstnw _t9ec1bh4 _1bsb1l8a"
                ]),
                children: /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                    d: "M104.435 9.68613C86.4938 6.51631 73.1262 13.83 55.0489 7.43996C54.1658 10.0608 51.9298 13.3276 48.6487 13.3318C51.3855 13.3082 55.8543 6.49074 51.3954 11.0379C48.7638 14.5108 37.5257 10.0724 46.1409 13.2376C40.1743 12.5113 34.7527 8.16936 30.7652 4.31768C24.1184 -1.18196 29.0775 9.35501 24.148 14.5541C17.1646 21.7785 -3.47552 2.46837 0.735557 2.51293C3.38441 4.93365 6.96197 6.46719 8.41505 9.13148C34.4142 25.1383 15.8926 -4.08831 31.4374 0.975475C56.6666 21.4402 44.0238 3.05288 58.9761 4.49783C67.6031 11.908 104.856 0.972575 104.442 9.68622L104.435 9.68613Z"
                })
            })
        ]
    });
const $b478a262008c7c1b$var$accentImageCss = null;
const $b478a262008c7c1b$var$scribbleSpanCss = null;

});

parcelRegister("38XOI", function(module, exports) {

$parcel$export(module.exports, "FreeSubheading", function () { return $b3ae9558ab08cb25$export$95472f736e92878c; });
/* free-subheading.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $f6qj2 = parcelRequire("f6qj2");

var $5ohHq = parcelRequire("5ohHq");
const $b3ae9558ab08cb25$export$95472f736e92878c = ({ returnString: returnString })=>{
    const intl = (0, $f6qj2.default)();
    const subHeaderText = intl.formatMessage({
        id: "signupForm.accountCreation.subHeaderText",
        defaultMessage: "It\u2019s free for up to 10 users - no credit card needed."
    });
    return returnString ? subHeaderText : /*#__PURE__*/ (0, $loA2J.jsx)("p", {
        className: (0, $esG4f.default)([
            "_syaz1hlo _19pkidpf _2hwxidpf _otyr1tcg _18u0idpf _y3gn1h6o"
        ]),
        style: {
            "--_188070z": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.primary.black"))
        },
        children: subHeaderText
    });
};
const $b3ae9558ab08cb25$var$subHeaderCss = null;

});



parcelRegister("8m0rG", function(module, exports) {

$parcel$export(module.exports, "LoggedInJpdNewUser", function () { return $224c226964f359f3$export$cee9af0ba2f2061c; });
/* new-user.tsx generated by @compiled/babel-plugin v0.28.8 */ // @ts-ignore

var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $eDoPe = parcelRequire("eDoPe");

var $f6qj2 = parcelRequire("f6qj2");

var $6IicP = parcelRequire("6IicP");

var $47Euo = parcelRequire("47Euo");

var $iMdoL = parcelRequire("iMdoL");

var $1MbAx = parcelRequire("1MbAx");
parcelRequire("ia5W9");
var $3CPhp = parcelRequire("3CPhp");
const $224c226964f359f3$export$cee9af0ba2f2061c = ()=>{
    const { ref: ref, inView: inView } = (0, $eDoPe.useInView)();
    const isLoggedInHasJira = (0, $iMdoL.useLoggedInHasJira)();
    (0, $1MbAx.useFeatureExposed)("gwp-7053-jpd-lofi-signup", "Test", {
        conditions: [
            inView
        ],
        metadata: {
            hasJira: isLoggedInHasJira,
            userType: "new"
        }
    });
    if (isLoggedInHasJira) return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        ref: ref,
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $6IicP.JiraOverlayTemplate), {
            size: "sm",
            children: /*#__PURE__*/ (0, $loA2J.jsx)($224c226964f359f3$var$Content, {})
        })
    });
    else return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        ref: ref,
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $6IicP.JPDOverlayTemplate), {
            size: "sm",
            children: /*#__PURE__*/ (0, $loA2J.jsx)($224c226964f359f3$var$Content, {})
        })
    });
};
const $224c226964f359f3$var$Content = ()=>{
    const { formatMessage: formatMessage } = (0, $f6qj2.default)();
    const intl = (0, $f6qj2.default)();
    const subHeaderText = intl.formatMessage({
        id: "siteActivation.loggedInJPD.newUser",
        defaultMessage: "Sites are shared spaces to organize work, teams, and projects."
    });
    return /*#__PURE__*/ (0, $loA2J.jsxs)((0, $loA2J.Fragment), {
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("h1", {
                className: (0, $esG4f.default)([
                    "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _y3gn1h6o"
                ]),
                children: /*#__PURE__*/ (0, $loA2J.jsx)("span", {
                    className: (0, $esG4f.default)([
                        "_kqswh2mm"
                    ]),
                    children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $3CPhp.CreateASiteHeading), {})
                })
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("p", {
                className: (0, $esG4f.default)([
                    "_19pk7vkz _2hwxidpf _otyr7vkz _18u0idpf _y3gn1h6o _ect48q0o _1wyb7vkz"
                ]),
                children: subHeaderText
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $47Euo.default), {}),
            /*#__PURE__*/ (0, $loA2J.jsx)("footer", {
                className: (0, $esG4f.default)([
                    "_1wyb1crf _k48p1nn1 _19pkidpf _2hwxidpf _otyridpf _18u0idpf _ect48q0o"
                ]),
                children: formatMessage({
                    id: "JiraSoftwarePageTemplate.loggedInHero.recatcha",
                    defaultMessage: "This page is protected by reCAPTCHA and the Google Privacy Policy and Terms of Service apply."
                })
            })
        ]
    });
};
const $224c226964f359f3$var$headerCss = null;
const $224c226964f359f3$var$subHeaderCss = null;
const $224c226964f359f3$var$accentImageSpanCss = null;
const $224c226964f359f3$var$footerCss = null;

});


parcelRegister("4KKXI", function(module, exports) {

$parcel$export(module.exports, "LoggedInJpdPremium", function () { return $2820dda889c06e9a$export$d6179757c2706927; });
/* logged-in-jpd-premium.tsx generated by @compiled/babel-plugin v0.28.8 */ // @ts-ignore

var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $eDoPe = parcelRequire("eDoPe");

var $f6qj2 = parcelRequire("f6qj2");

var $6IicP = parcelRequire("6IicP");

var $47Euo = parcelRequire("47Euo");

var $iMdoL = parcelRequire("iMdoL");

var $1MbAx = parcelRequire("1MbAx");
parcelRequire("ia5W9");
var $jN1Op = parcelRequire("jN1Op");
parcelRequire("5XFHK");
var $kBgD7 = parcelRequire("kBgD7");
parcelRequire("ddK6j");
var $bS7zZ = parcelRequire("bS7zZ");

var $8m0rG = parcelRequire("8m0rG");
const $2820dda889c06e9a$export$d6179757c2706927 = ()=>{
    const { ref: ref, inView: inView } = (0, $eDoPe.useInView)();
    const cohort = (0, $iMdoL.useCohort)();
    const isLoggedInHasJira = (0, $iMdoL.useLoggedInHasJira)(); // Upgradeable Standard Sites Experiment
    const existingSites = (0, $bS7zZ.useGetExistingSites)(); // Only fire useFeatureExposed if cohort is not "new-user" to avoid double exposure (NewUser component calls useFeatureExposed as well)
    (0, $1MbAx.useFeatureExposed)("gwp-7053-jpd-lofi-signup", "Test", {
        conditions: [
            inView,
            cohort !== "new-user"
        ],
        metadata: {
            hasJira: isLoggedInHasJira,
            cohort: cohort,
            tier: "premium"
        }
    });
    if (cohort === "new-user") return /*#__PURE__*/ (0, $loA2J.jsx)((0, $8m0rG.LoggedInJpdNewUser), {});
    if (isLoggedInHasJira) return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        ref: ref,
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $6IicP.JiraOverlayTemplate), {
            size: "sm",
            children: /*#__PURE__*/ (0, $loA2J.jsx)($2820dda889c06e9a$var$Content, {
                existingSites: existingSites
            })
        })
    });
    return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        ref: ref,
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $6IicP.JPDOverlayTemplate), {
            size: "sm",
            children: /*#__PURE__*/ (0, $loA2J.jsx)($2820dda889c06e9a$var$Content, {
                existingSites: existingSites
            })
        })
    });
};
const $2820dda889c06e9a$var$Content = ({ existingSites: existingSites })=>{
    const { user: { name: name } } = (0, $iMdoL.useUserContext)();
    const { formatMessage: formatMessage } = (0, $f6qj2.default)();
    return /*#__PURE__*/ (0, $loA2J.jsxs)((0, $loA2J.Fragment), {
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("h1", {
                className: (0, $esG4f.default)([
                    "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _y3gn1h6o"
                ]),
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $kBgD7.WelcomeBackHeading), {
                    name: name
                })
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("h2", {
                className: (0, $esG4f.default)([
                    "_1wyb7vkz _k48p1nn1 _y3gn1h6o _vwz41tcg _ect48q0o _19pk7vkz _2hwxidpf _otyridpf _18u0idpf"
                ]),
                children: formatMessage({
                    id: "LoomTemplate.loggedInHero.subheader",
                    defaultMessage: "Sites are shared spaces to organize work, teams, and projects."
                })
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $47Euo.default), {
                existingSites: existingSites,
                UpgradeEligibleUser: existingSites ? /*#__PURE__*/ (0, $loA2J.jsx)((0, $47Euo.UpgradeEligibleUser), {
                    SubmitButton: /*#__PURE__*/ (0, $loA2J.jsx)((0, $jN1Op.SubmitButtonMessageNext), {})
                }) : undefined
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("footer", {
                className: (0, $esG4f.default)([
                    "_1wyb1crf _k48p1nn1 _19pkidpf _2hwxidpf _otyridpf _18u0idpf _ect48q0o"
                ]),
                children: formatMessage({
                    id: "JiraSoftwarePageTemplate.loggedInHero.recatcha",
                    defaultMessage: "This page is protected by reCAPTCHA and the Google Privacy Policy and Terms of Service apply."
                })
            })
        ]
    });
};
const $2820dda889c06e9a$var$headerCss = null;
const $2820dda889c06e9a$var$subheadingCss = null;
const $2820dda889c06e9a$var$footerCss = null;

});

parcelRegister("abOhf", function(module, exports) {

$parcel$export(module.exports, "LoggedInJpdStandard", function () { return $d188981b6db428b2$export$f9e002478e7e9ef9; });
/* logged-in-jpd-standard.tsx generated by @compiled/babel-plugin v0.28.8 */ // @ts-ignore

var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $eDoPe = parcelRequire("eDoPe");

var $f6qj2 = parcelRequire("f6qj2");

var $6IicP = parcelRequire("6IicP");

var $47Euo = parcelRequire("47Euo");

var $iMdoL = parcelRequire("iMdoL");

var $1MbAx = parcelRequire("1MbAx");
parcelRequire("5XFHK");
var $kBgD7 = parcelRequire("kBgD7");

var $8m0rG = parcelRequire("8m0rG");
const $d188981b6db428b2$export$f9e002478e7e9ef9 = ()=>{
    const { ref: ref, inView: inView } = (0, $eDoPe.useInView)();
    const cohort = (0, $iMdoL.useCohort)();
    const isLoggedInHasJira = (0, $iMdoL.useLoggedInHasJira)(); // Only fire useFeatureExposed if cohort is not "new-user" to avoid double exposure (NewUser component calls useFeatureExposed as well)
    (0, $1MbAx.useFeatureExposed)("gwp-7053-jpd-lofi-signup", "Test", {
        conditions: [
            inView,
            cohort !== "new-user"
        ],
        metadata: {
            hasJira: isLoggedInHasJira,
            cohort: cohort,
            tier: "standard"
        }
    });
    if (cohort === "new-user") return /*#__PURE__*/ (0, $loA2J.jsx)((0, $8m0rG.LoggedInJpdNewUser), {});
    if (isLoggedInHasJira) return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        ref: ref,
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $6IicP.JiraOverlayTemplate), {
            size: "sm",
            children: /*#__PURE__*/ (0, $loA2J.jsx)($d188981b6db428b2$var$Content, {})
        })
    });
    else return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        ref: ref,
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $6IicP.JPDOverlayTemplate), {
            size: "sm",
            children: /*#__PURE__*/ (0, $loA2J.jsx)($d188981b6db428b2$var$Content, {})
        })
    });
};
const $d188981b6db428b2$var$Content = ()=>{
    const { user: { name: name } } = (0, $iMdoL.useUserContext)();
    const { formatMessage: formatMessage } = (0, $f6qj2.default)();
    return /*#__PURE__*/ (0, $loA2J.jsxs)((0, $loA2J.Fragment), {
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("h1", {
                className: (0, $esG4f.default)([
                    "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _y3gn1h6o"
                ]),
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $kBgD7.WelcomeBackHeading), {
                    name: name
                })
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("h2", {
                className: (0, $esG4f.default)([
                    "_1wyb7vkz _k48p1nn1 _y3gn1h6o _vwz41tcg _ect48q0o _19pk7vkz _2hwxidpf _otyridpf _18u0idpf"
                ]),
                children: formatMessage({
                    id: "LoomTemplate.loggedInHero.subheader",
                    defaultMessage: "Sites are shared spaces to organize work, teams, and projects."
                })
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $47Euo.default), {}),
            /*#__PURE__*/ (0, $loA2J.jsx)("footer", {
                className: (0, $esG4f.default)([
                    "_1wyb1crf _k48p1nn1 _19pkidpf _2hwxidpf _otyridpf _18u0idpf _ect48q0o"
                ]),
                children: formatMessage({
                    id: "JiraSoftwarePageTemplate.loggedInHero.recatcha",
                    defaultMessage: "This page is protected by reCAPTCHA and the Google Privacy Policy and Terms of Service apply."
                })
            })
        ]
    });
};
const $d188981b6db428b2$var$headerCss = null;
const $d188981b6db428b2$var$subheadingCss = null;
const $d188981b6db428b2$var$footerCss = null;

});


parcelRegister("k664o", function(module, exports) {

$parcel$export(module.exports, "LoggedOutJpd", function () { return $2193a11a2abad187$export$965e0701e24dde42; });
// @ts-ignore

var $loA2J = parcelRequire("loA2J");

var $eDoPe = parcelRequire("eDoPe");

var $axg8K = parcelRequire("axg8K");

var $iu8Ap = parcelRequire("iu8Ap");

var $iMdoL = parcelRequire("iMdoL");

var $1MbAx = parcelRequire("1MbAx");

var $aOuDE = parcelRequire("aOuDE");
parcelRequire("ia5W9");
var $6dDlC = parcelRequire("6dDlC");
var $esacZ = parcelRequire("esacZ");
var $5cDws = parcelRequire("5cDws");

var $iqL1z = parcelRequire("iqL1z");
const $2193a11a2abad187$export$965e0701e24dde42 = ()=>{
    const isMobile = (0, $aOuDE.useIsMobile)(800);
    return isMobile ? /*#__PURE__*/ (0, $loA2J.jsx)((0, $6dDlC.SignupDefault), {}) : /*#__PURE__*/ (0, $loA2J.jsx)($2193a11a2abad187$var$CohortComponent, {});
};
const $2193a11a2abad187$var$CohortComponent = ()=>{
    const { ref: ref, inView: inView } = (0, $eDoPe.useInView)();
    const isStandard = (0, $iMdoL.useStandardIntent)();
    const isPremium = (0, $iMdoL.usePremiumIntent)();
    const isFree = (0, $iMdoL.useFreeIntent)();
    // Only fire useFeatureExposed if user has free, standard, or premium intent
    (0, $1MbAx.useFeatureExposed)("gwp-7053-jpd-lofi-signup", "Test", {
        conditions: [
            inView,
            isFree || isStandard || isPremium
        ],
        metadata: {
            isFree: isFree,
            isStandard: isStandard,
            isPremium: isPremium,
            userType: "logged-out"
        }
    });
    if (isFree) return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        ref: ref,
        children: /*#__PURE__*/ (0, $loA2J.jsx)($2193a11a2abad187$var$LoggedOutJpdFree, {})
    });
    if (isStandard || isPremium) return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        ref: ref,
        children: /*#__PURE__*/ (0, $loA2J.jsx)($2193a11a2abad187$var$LoggedOutJpdStandardPremium, {})
    });
    // bxpkit catch-all (paid editions if gate is off) - no ref needed since no tracking
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $6dDlC.SignupDefault), {});
};
const $2193a11a2abad187$var$LoggedOutJpdFree = ()=>/*#__PURE__*/ (0, $loA2J.jsxs)((0, $iu8Ap.JPDOverlayTemplate), {
        size: "sm",
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $esacZ.JPDGetStartedHeading), {}),
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $iqL1z.FreeSubheading), {}),
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $axg8K.default), {
                Input: /*#__PURE__*/ (0, $loA2J.jsx)((0, $5cDws.InputSubmitButton), {}),
                Submit: null
            })
        ]
    });
const $2193a11a2abad187$var$LoggedOutJpdStandardPremium = ()=>/*#__PURE__*/ (0, $loA2J.jsxs)((0, $iu8Ap.JPDOverlayTemplate), {
        size: "sm",
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $esacZ.JPDGetStartedHeading), {}),
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $iqL1z.StandardSubheading), {}),
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $axg8K.default), {
                Input: /*#__PURE__*/ (0, $loA2J.jsx)((0, $5cDws.InputSubmitButton), {}),
                Submit: null
            })
        ]
    });

});
parcelRegister("iqL1z", function(module, exports) {

$parcel$export(module.exports, "FreeSubheading", function () { return $89c59fbc547ba2c2$export$95472f736e92878c; });
$parcel$export(module.exports, "StandardSubheading", function () { return $89c59fbc547ba2c2$export$7569928c8e756e8e; });
/* free-subheading.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $f6qj2 = parcelRequire("f6qj2");

var $5ohHq = parcelRequire("5ohHq");
const $89c59fbc547ba2c2$export$95472f736e92878c = ({ returnString: returnString })=>{
    const intl = (0, $f6qj2.default)();
    const subHeaderText = intl.formatMessage({
        id: "signupForm.accountCreation.subHeaderText.jpd.free",
        defaultMessage: "It's free for up to 3 creators - no credit card needed."
    });
    return returnString ? subHeaderText : /*#__PURE__*/ (0, $loA2J.jsx)("p", {
        className: (0, $esG4f.default)([
            "_syaz1hlo _19pkftgi _2hwxidpf _otyr1tcg _18u0idpf _y3gn1h6o _ect48q0o"
        ]),
        style: {
            "--_188070z": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.primary.black"))
        },
        children: subHeaderText
    });
};
const $89c59fbc547ba2c2$export$7569928c8e756e8e = ({ returnString: returnString })=>{
    const intl = (0, $f6qj2.default)();
    const subHeaderText = intl.formatMessage({
        id: "signupForm.accountCreation.subHeaderText.jpd.free",
        defaultMessage: "It's free to get started - no credit card needed."
    });
    return returnString ? subHeaderText : /*#__PURE__*/ (0, $loA2J.jsx)("p", {
        className: (0, $esG4f.default)([
            "_syaz1hlo _19pkftgi _2hwxidpf _otyr1tcg _18u0idpf _y3gn1h6o _ect48q0o"
        ]),
        style: {
            "--_188070z": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.primary.black"))
        },
        children: subHeaderText
    });
};
const $89c59fbc547ba2c2$var$subHeaderCss = null;

});



parcelRegister("kYwmv", function(module, exports) {

$parcel$export(module.exports, "JsmSignup", function () { return $6a4a8117f83a859d$export$892d03ae6ccca3f6; });

var $loA2J = parcelRequire("loA2J");

var $jgJpJ = parcelRequire("jgJpJ");

var $iMdoL = parcelRequire("iMdoL");

var $fbaQ6 = parcelRequire("fbaQ6");

var $bvb5p = parcelRequire("bvb5p");

var $6HNVd = parcelRequire("6HNVd");
const $6a4a8117f83a859d$export$892d03ae6ccca3f6 = ()=>{
    const { user: { isUserLoggedIn: isUserLoggedIn }, edition: edition } = (0, $iMdoL.useUserContext)();
    const isUpgradeEligible = (0, $iMdoL.useIsUpgradeEligible)();
    const shouldRedirect = (0, $fbaQ6.handleSignupRouteRedirects)({
        // Hardcoding since we don't need extra check for JSM product
        product: (0, $jgJpJ.ProductKey).JIRA_SERVICE_MANAGEMENT,
        bundle: "jira-service-management",
        isUpgradeEligible: isUpgradeEligible,
        edition: edition
    });
    if (shouldRedirect) return /*#__PURE__*/ (0, $loA2J.jsx)((0, $loA2J.Fragment), {});
    if (isUserLoggedIn) return /*#__PURE__*/ (0, $loA2J.jsx)((0, $bvb5p.LoggedInJsm), {});
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $6HNVd.LoggedOutJsm), {});
};

});
parcelRegister("bvb5p", function(module, exports) {

$parcel$export(module.exports, "LoggedInJsm", function () { return $515a811a979f52c5$export$d3f772aa4c0e5318; });

var $loA2J = parcelRequire("loA2J");

var $iMdoL = parcelRequire("iMdoL");
parcelRequire("ia5W9");
var $6dDlC = parcelRequire("6dDlC");

var $5gnnU = parcelRequire("5gnnU");

var $fdgjD = parcelRequire("fdgjD");

var $bpb4a = parcelRequire("bpb4a");
const $515a811a979f52c5$export$d3f772aa4c0e5318 = ()=>{
    const isStandard = (0, $iMdoL.useStandardIntent)();
    const isPremium = (0, $iMdoL.usePremiumIntent)();
    const isFree = (0, $iMdoL.useFreeIntent)();
    const isUpgradeEligible = (0, $iMdoL.useIsUpgradeEligible)();
    if (isPremium && !isUpgradeEligible) return /*#__PURE__*/ (0, $loA2J.jsx)((0, $fdgjD.LoggedInJsmPremium), {});
    if (isStandard && !isUpgradeEligible) return /*#__PURE__*/ (0, $loA2J.jsx)((0, $bpb4a.LoggedInJsmStandard), {});
    if (isFree) return /*#__PURE__*/ (0, $loA2J.jsx)((0, $5gnnU.LoggedInJsmFree), {});
    // bxpkit catch-all
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $6dDlC.SignupDefault), {});
};

});
parcelRegister("5gnnU", function(module, exports) {

$parcel$export(module.exports, "LoggedInJsmFree", function () { return $692f10e943b94b15$export$c5178f55d7b323c7; });

var $loA2J = parcelRequire("loA2J");

var $f6qj2 = parcelRequire("f6qj2");

var $iMdoL = parcelRequire("iMdoL");

var $6Dpzb = parcelRequire("6Dpzb");

var $iSyWs = parcelRequire("iSyWs");
const $692f10e943b94b15$export$c5178f55d7b323c7 = ()=>{
    const { formatMessage: formatMessage } = (0, $f6qj2.default)();
    const cohort = (0, $iMdoL.useCohort)();
    if (cohort === "new-user") return /*#__PURE__*/ (0, $loA2J.jsx)((0, $iSyWs.LoggedInJsmNewUser), {});
    if (cohort) return /*#__PURE__*/ (0, $loA2J.jsx)((0, $6Dpzb.LoggedInJsmExistingUser), {
        productEditionText: formatMessage({
            id: "WacSignupHeader.cloudFree",
            defaultMessage: "Cloud Free"
        })
    });
    return null;
};

});
parcelRegister("6Dpzb", function(module, exports) {

$parcel$export(module.exports, "LoggedInJsmExistingUser", function () { return $1bd698a8644f0a46$export$d95bbf4914d0e368; });
/* existing-user.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $f6qj2 = parcelRequire("f6qj2");

var $47Euo = parcelRequire("47Euo");

var $gNKPy = parcelRequire("gNKPy");

var $jgJpJ = parcelRequire("jgJpJ");

var $iMdoL = parcelRequire("iMdoL");
parcelRequire("ia5W9");
var $cHXak = parcelRequire("cHXak");
var $587P6 = parcelRequire("587P6");
var $eZrnm = parcelRequire("eZrnm");
parcelRequire("juUMc");
var $lC8Rv = parcelRequire("lC8Rv");
const $1bd698a8644f0a46$export$d95bbf4914d0e368 = ({ productEditionText: productEditionText })=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)($1bd698a8644f0a46$export$c20c1b72868f8509, {
        productEditionText: productEditionText || ""
    });
};
const $1bd698a8644f0a46$export$c20c1b72868f8509 = ({ productEditionText: productEditionText })=>{
    const { formatMessage: formatMessage } = (0, $f6qj2.default)();
    const { user: { name: name, email: email } } = (0, $iMdoL.useUserContext)();
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $lC8Rv.BlueWaveTemplateJsm), {
        productEditionText: productEditionText,
        children: /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
            className: (0, $esG4f.default)([
                "_1e0c11p5 _zulp7vkz"
            ]),
            children: [
                /*#__PURE__*/ (0, $loA2J.jsx)("h2", {
                    className: (0, $esG4f.default)([
                        "_1wyb1tcg _k48pbfng _19pkidpf _2hwxidpf _otyridpf _18u0idpf _y3gn1h6o"
                    ]),
                    children: name ? formatMessage({
                        id: "BxpUiSignup.nameSite.header",
                        defaultMessage: "Welcome back, {name}"
                    }, {
                        name: (0, $jgJpJ.getFirstName)(name)
                    }) : formatMessage({
                        id: "JiraSoftwarePageTemplate.loggedInHero.welcomeBack",
                        defaultMessage: "Welcome back"
                    })
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)((0, $cHXak.InputEmail), {
                    email: email
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)((0, $47Euo.default), {
                    ExistingUser: /*#__PURE__*/ (0, $loA2J.jsx)((0, $47Euo.ExistingUser), {
                        SubmitButton: /*#__PURE__*/ (0, $loA2J.jsx)((0, $587P6.SubmitButtonExistingUser), {}),
                        SitePicker: /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                            className: (0, $esG4f.default)([
                                "_84yz1wa3 _eeia15se"
                            ]),
                            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $gNKPy.SitePicker), {})
                        })
                    }),
                    ManagedUser: null,
                    WeekOneUser: null
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                    className: (0, $esG4f.default)([
                        "_1pfh1crf _6rth1tcg _clfd1crf _11pqidpf _q0a5idpf _c3k8idpf"
                    ]),
                    children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $eZrnm.NoCreditCardRequired), {})
                })
            ]
        })
    });
};
const $1bd698a8644f0a46$var$containerCss = null;
const $1bd698a8644f0a46$var$siteActivationHeadingCss = null;
const $1bd698a8644f0a46$var$sitePickerCss = null;
const $1bd698a8644f0a46$var$spacingSyles = null;

});
parcelRegister("juUMc", function(module, exports) {
$parcel$export(module.exports, "BlueWaveTemplateJsm", function () { return (parcelRequire("lC8Rv")).BlueWaveTemplateJsm; });
$parcel$export(module.exports, "LoggedInBlueWaveTemplateJsmExistingUser", function () { return (parcelRequire("6eEZK")).LoggedInBlueWaveTemplateJsmExistingUser; });
$parcel$export(module.exports, "LoggedInBlueWaveTemplateJsmNewUser", function () { return (parcelRequire("kq8Eb")).LoggedInBlueWaveTemplateJsmNewUser; });
$parcel$export(module.exports, "JsmSubmitButtonNewUser", function () { return (parcelRequire("ldWsL")).JsmSubmitButtonNewUser; });
parcelRequire("lJfxI");
parcelRequire("lC8Rv");
parcelRequire("6eEZK");
parcelRequire("kq8Eb");
parcelRequire("ldWsL");

});
parcelRegister("lJfxI", function(module, exports) {

$parcel$export(module.exports, "VerizonSquareDominosTwitter", function () { return $fbfec05325166c7c$export$330cb7105f47bc90; });

var $loA2J = parcelRequire("loA2J");
const $fbfec05325166c7c$export$330cb7105f47bc90 = ()=>/*#__PURE__*/ (0, $loA2J.jsxs)("svg", {
        viewBox: "0 0 300 40",
        fill: "currentColor",
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M105.17 22a.5.5 0 0 1-.51.5h-3.57a.5.5 0 0 1-.51-.5v-3.5a.51.51 0 0 1 .51-.5h3.57a.51.51 0 0 1 .51.5V22Zm3.06 2.63a.88.88 0 0 1-.89.87H98.4a.88.88 0 0 1-.89-.87v-8.76a.88.88 0 0 1 .89-.87h8.94a.88.88 0 0 1 .89.87Zm.26-12.63H97.26a2.79 2.79 0 0 0-2.81 2.75v11a2.79 2.79 0 0 0 2.81 2.75h11.22a2.79 2.79 0 0 0 2.81-2.75v-11a2.79 2.79 0 0 0-2.8-2.75"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M119.38 26a3.75 3.75 0 0 1-2.62-1 3 3 0 0 1-.94-2.13h1a2 2 0 0 0 .64 1.44 2.74 2.74 0 0 0 1.91.74 2.37 2.37 0 0 0 2.55-2.13c0-.88-.51-1.58-3-2.13a4.33 4.33 0 0 1-2.1-.94 2.34 2.34 0 0 1-.71-1.82 3 3 0 0 1 3.16-2.79 3.4 3.4 0 0 1 2.21.79 2.6 2.6 0 0 1 1 2h-1a2 2 0 0 0-2.15-1.79 2 2 0 0 0-2.15 1.8c0 .9.31 1.42 2 1.81s3.71 1.1 3.72 3.08a2.93 2.93 0 0 1-1.06 2.22 3.86 3.86 0 0 1-2.5.89Z"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M127.87 18.58a3.09 3.09 0 1 0 3.18 3.1 3.1 3.1 0 0 0-3.18-3.1M131 28.5v-4.37a3.71 3.71 0 0 1-3.1 1.5 4.07 4.07 0 0 1-4.28-4 4.08 4.08 0 0 1 4.28-3.95 3.67 3.67 0 0 1 3.1 1.52v-1.3h1v10.6Z"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M146 18.55a3 3 0 1 0 3.18 3 3.07 3.07 0 0 0-3.18-3m3.12 6.6v-1.27a3.77 3.77 0 0 1-3.12 1.45 4 4 0 0 1-4.28-3.82 4 4 0 0 1 4.28-3.8 3.66 3.66 0 0 1 3.09 1.46V17.9h1v7.25Z"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M153.1 21v4.35h-1V17.9h1V19a2.26 2.26 0 0 1 2.21-1.27v1A2.17 2.17 0 0 0 153.1 21"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M159.53 18.55a3.09 3.09 0 0 0-3.14 2.45h6.29a3.1 3.1 0 0 0-3.15-2.48m4.2 3.31h-7.34a3.23 3.23 0 0 0 6 .92h1.09a4.22 4.22 0 0 1-4 2.55 4 4 0 0 1-4.2-3.8 4 4 0 0 1 4.19-3.82 4.09 4.09 0 0 1 4.23 3.89v.26"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M139.54 25.15V24a2.5 2.5 0 0 1-2.36 1.34 3.15 3.15 0 0 1-2.54-1.12 3.78 3.78 0 0 1-.65-2.39v-4.12h.94v4.09c0 1.54.56 2.67 2.25 2.67a2.1 2.1 0 0 0 1.57-.6 2.8 2.8 0 0 0 .77-2.23v-3.93h.94v7.44Z"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M222.22 21.09c-.88-2.16-3.91-1.49-4.74-.1V19.9h-2.63v7.67h2.73v-3.86c0-1.44.29-1.54 1-1.59s1 .05 1 1.59l.05 3.86h2.63v-4c0-.72.15-1.39.88-1.39.88 0 1.08.05 1.08 1.19v4.22H227v-5.68c.1-2.72-3.56-2.78-4.78-.82Z"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M210.11 19.34a4.12 4.12 0 1 0 3.89 4.12 4 4 0 0 0-3.89-4.12Zm0 5.56a1.45 1.45 0 0 1 0-2.89 1.45 1.45 0 0 1 0 2.89Z"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M202.7 17.43a5 5 0 0 0-1.66-.51 21 21 0 0 0-2.49-.16h-3v10.81h2.78a24.3 24.3 0 0 0 2.73-.15 6.77 6.77 0 0 0 1.71-.52 6 6 0 0 0 2.1-1.95 5.68 5.68 0 0 0 0-5.56 5.85 5.85 0 0 0-2.17-1.96Zm-.34 6a2.29 2.29 0 0 1-.88.92 2.82 2.82 0 0 1-.69.26 4.21 4.21 0 0 1-1.12.05h-1.12V19.6h1.26a7.11 7.11 0 0 1 1 0 1.6 1.6 0 0 1 .68.25 2.64 2.64 0 0 1 .88.93 3 3 0 0 1 .29 1.28 4.11 4.11 0 0 1-.3 1.4Z"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M228.22 19.75h2.73v7.77h-2.73z"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M250.62 18.21a2.19 2.19 0 0 0-.1-1.39 1.49 1.49 0 0 0-1.36-.93 1.45 1.45 0 0 0-1.47 1.11 1.59 1.59 0 0 0 1 1.9c.19.05.39 0 .24.26a2.87 2.87 0 0 1-.54.56l.29.47c1.21-.64 1.8-1.32 1.94-1.98Z"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M244.47 19.34a4.12 4.12 0 1 0 3.91 4.12 4 4 0 0 0-3.91-4.12Zm0 5.56a1.4 1.4 0 0 1-1.36-1.44 1.37 1.37 0 1 1 2.73 0 1.41 1.41 0 0 1-1.37 1.44Z"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M253.7 22.37c-1.37 0-1.27-1-.44-1a3.54 3.54 0 0 1 2.44.77l.88-1.79c-2.4-1.5-6.45-1.29-6.54 1.44 0 1.54 1.07 2.31 3.36 2.57 1.67.21 1.18 1 .25 1.08a4.46 4.46 0 0 1-2.73-.93l-1.18 1.86c3.22 2.16 7 1.18 7.13-1.34.13-1.52-.98-2.71-3.17-2.66Z"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M234.86 21v-1.1h-2.64v7.67h2.64v-3.86c0-1.28.53-1.54 1.12-1.59s1.27.05 1.27 1.59l.05 3.86h2.63V22c-.04-2.81-4.05-2.81-5.07-1Z"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M229.59 15.89a1.6 1.6 0 1 0 1.51 1.6 1.57 1.57 0 0 0-1.51-1.6Z"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "m192.71 15.35-5.09-5.17a.57.57 0 0 0-.83 0l-5.38 5.42 5.92 6 5.38-5.41a.58.58 0 0 0 0-.84Zm-4.41 1.38a1.4 1.4 0 0 1-2 0 1.45 1.45 0 0 1 0-2.07 1.4 1.4 0 0 1 2 0 1.55 1.55 0 0 1 0 2.07Z"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "m181.07 16-5.44 5.46a.57.57 0 0 0 0 .83l5.09 5.17a.57.57 0 0 0 .83 0l5.39-5.46ZM180 23a1.49 1.49 0 0 1-2 0 1.45 1.45 0 0 1 0-2.07 1.49 1.49 0 0 1 2 0 1.55 1.55 0 0 1 0 2.07Zm2.18 0a1.45 1.45 0 0 1 0-2.07 1.4 1.4 0 0 1 2 0 1.45 1.45 0 0 1 0 2.07 1.4 1.4 0 0 1-2 0Z"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M292.55 12.42a7.35 7.35 0 0 1-2.77.73 5 5 0 0 0 2.08-2.75 9.8 9.8 0 0 1-3 1.21 4.63 4.63 0 0 0-3.39-1.61 4.88 4.88 0 0 0-4.78 5 6.14 6.14 0 0 0 .15 1.13 13.2 13.2 0 0 1-9.78-5.09 4.66 4.66 0 0 0-.61 2.51 5.14 5.14 0 0 0 2.08 4.12 4.65 4.65 0 0 1-2.15-.57v.09a4.87 4.87 0 0 0 3.85 4.81 5.85 5.85 0 0 1-1.24.16 3.1 3.1 0 0 1-.85-.08 4.85 4.85 0 0 0 4.4 3.47 9.06 9.06 0 0 1-5.94 2.11 5 5 0 0 1-1.15-.09 13.6 13.6 0 0 0 7.31 2.19c8.7 0 13.48-7.51 13.48-14.14v-.57a15 15 0 0 0 2.31-2.63Z"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "m82.5 10.84-4.18 9-1.59-3.44H75l2.63 5.6H79l5.18-11.13Z"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M38.05 12.46h3.4v3h-3.4Zm-26.74 15h3.55l3.85-11.1h-3.4l-2.17 7.13-2.2-7.09H7.45l3.86 11.09Zm12.47-9a2.17 2.17 0 0 1 2.14 2.17H21.4a2.3 2.3 0 0 1 2.38-2.17m.22 6.91a2.51 2.51 0 0 1-2.57-2.47h8c0-2.38-.61-4.29-1.93-5.48a5.23 5.23 0 0 0-3.72-1.34 5.57 5.57 0 0 0-5.66 5.84 5.59 5.59 0 0 0 5.87 5.89 5.79 5.79 0 0 0 3.4-1 4.33 4.33 0 0 0 1.86-2.61H26a2 2 0 0 1-2 1.17m6.22 2.12h3.37V22.4c0-2.31 1.39-3.33 3.51-3h.07v-2.97a1.8 1.8 0 0 0-.69-.09 3.22 3.22 0 0 0-3 1.9h-.07V16.4h-3.24v11.09Zm7.88 0h3.4V16.4h-3.4Zm4.33 0h9.49v-2.66H46.5v-.07L51.63 19v-2.6h-9.25v2.67h5.2v.06l-5.2 5.81v2.55Zm15.48-2.15c-1.6 0-2.45-1.34-2.45-3.37s.85-3.38 2.45-3.38 2.49 1.32 2.49 3.38-.89 3.37-2.49 3.37m0-9.24A5.66 5.66 0 0 0 52 22a5.89 5.89 0 0 0 11.78 0 5.67 5.67 0 0 0-5.88-5.87m6.63 11.39h3.37v-6.2a2.14 2.14 0 0 1 2-2.4c1.17 0 1.77.83 1.77 2v6.58h3.38v-7.24c0-2.45-1.47-4.18-3.85-4.18a3.8 3.8 0 0 0-3.38 1.84h-.07v-1.53h-3.23Z"
            })
        ]
    });

});

parcelRegister("lC8Rv", function(module, exports) {

$parcel$export(module.exports, "BlueWaveTemplateJsm", function () { return $01cf4c15245c5b94$export$5795842de5478b35; });
/* blue-wave-template-jsm.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $f6qj2 = parcelRequire("f6qj2");

var $eXoeL = parcelRequire("eXoeL");

var $iu8Ap = parcelRequire("iu8Ap");

var $bhreu = parcelRequire("bhreu");

var $lJfxI = parcelRequire("lJfxI");
const $01cf4c15245c5b94$export$5795842de5478b35 = ({ productEditionText: productEditionText, children: children })=>{
    const { formatMessage: formatMessage } = (0, $f6qj2.default)();
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $iu8Ap.BlueWaveTemplate), {
        socialProofLogos: /*#__PURE__*/ (0, $loA2J.jsx)((0, $lJfxI.VerizonSquareDominosTwitter), {}),
        tagline: formatMessage({
            id: "WacSignupForm.signupOfferingIncludesFeaturesSocialProofTextJSD",
            defaultMessage: "Powering high-velocity service teams"
        }),
        valueProps: formatMessage({
            id: "WacSignupForm.signupOfferingIncludesFeaturesFreeBundleJSD",
            defaultMessage: "Connect dev, IT Ops, and business teams on one platform{newline}Deliver great service experiences across teams, fast{newline}Respond to changes and keep services up and running{newline}Collaborate on one platform{newline}Resolve incidents quickly"
        }).split("{newline}"),
        productLogos: [
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $eXoeL.JiraServiceManagementLogo), {
                appearance: "inverse",
                size: "xlarge"
            }, "jsm")
        ],
        illustration: /*#__PURE__*/ (0, $loA2J.jsx)((0, $bhreu.Picture), {
            image: {
                src: "https://atlassian.com/dam/jcr:45864a30-5470-4cbe-be59-9aae63492229/JSD%20Hero.svg",
                alt: ""
            }
        }),
        productEditionText: productEditionText,
        children: /*#__PURE__*/ (0, $loA2J.jsx)("div", {
            className: (0, $esG4f.default)([
                "_1e0c11p5 _zulpftgi"
            ]),
            children: children
        })
    });
};
const $01cf4c15245c5b94$var$containerCss = null;

});

parcelRegister("6eEZK", function(module, exports) {

$parcel$export(module.exports, "LoggedInBlueWaveTemplateJsmExistingUser", function () { return $8f932bec69bc6fb6$export$c20c1b72868f8509; });
/* blue-wave-template-jam-existing-user.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $f6qj2 = parcelRequire("f6qj2");

var $47Euo = parcelRequire("47Euo");

var $gNKPy = parcelRequire("gNKPy");

var $jgJpJ = parcelRequire("jgJpJ");

var $iMdoL = parcelRequire("iMdoL");
parcelRequire("ia5W9");
var $cHXak = parcelRequire("cHXak");
var $587P6 = parcelRequire("587P6");
var $eZrnm = parcelRequire("eZrnm");
parcelRequire("juUMc");
var $lC8Rv = parcelRequire("lC8Rv");
const $8f932bec69bc6fb6$export$c20c1b72868f8509 = ({ productEditionText: productEditionText })=>{
    const { formatMessage: formatMessage } = (0, $f6qj2.default)();
    const { user: { name: name, email: email } } = (0, $iMdoL.useUserContext)();
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $lC8Rv.BlueWaveTemplateJsm), {
        productEditionText: productEditionText,
        children: /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
            className: (0, $esG4f.default)([
                "_1e0c11p5 _zulp7vkz"
            ]),
            children: [
                /*#__PURE__*/ (0, $loA2J.jsx)("h2", {
                    className: (0, $esG4f.default)([
                        "_1wyb1tcg _k48pbfng _19pkidpf _2hwxidpf _otyridpf _18u0idpf _y3gn1h6o"
                    ]),
                    children: name ? formatMessage({
                        id: "BxpUiSignup.nameSite.header",
                        defaultMessage: "Welcome back, {name}"
                    }, {
                        name: (0, $jgJpJ.getFirstName)(name)
                    }) : formatMessage({
                        id: "JiraSoftwarePageTemplate.loggedInHero.welcomeBack",
                        defaultMessage: "Welcome back"
                    })
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)((0, $cHXak.InputEmail), {
                    email: email
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)((0, $47Euo.default), {
                    ExistingUser: /*#__PURE__*/ (0, $loA2J.jsx)((0, $47Euo.ExistingUser), {
                        SubmitButton: /*#__PURE__*/ (0, $loA2J.jsx)((0, $587P6.SubmitButtonExistingUser), {}),
                        SitePicker: /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                            className: (0, $esG4f.default)([
                                "_84yz1wa3 _eeia15se"
                            ]),
                            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $gNKPy.SitePicker), {})
                        })
                    }),
                    ManagedUser: null,
                    WeekOneUser: null
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                    className: (0, $esG4f.default)([
                        "_1pfh1crf _6rth1tcg _clfd1crf _11pqidpf _q0a5idpf _c3k8idpf"
                    ]),
                    children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $eZrnm.NoCreditCardRequired), {})
                })
            ]
        })
    });
};
const $8f932bec69bc6fb6$var$containerCss = null;
const $8f932bec69bc6fb6$var$siteActivationHeadingCss = null;
const $8f932bec69bc6fb6$var$sitePickerCss = null;
const $8f932bec69bc6fb6$var$spacingSyles = null;

});

parcelRegister("kq8Eb", function(module, exports) {

$parcel$export(module.exports, "LoggedInBlueWaveTemplateJsmNewUser", function () { return $8257dc5645cb2995$export$2988efabf1be3838; });
/* blue-wave-template-jsm-new-user.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $f6qj2 = parcelRequire("f6qj2");

var $47Euo = parcelRequire("47Euo");

var $jgJpJ = parcelRequire("jgJpJ");

var $iMdoL = parcelRequire("iMdoL");
parcelRequire("juUMc");
var $lC8Rv = parcelRequire("lC8Rv");
var $ldWsL = parcelRequire("ldWsL");
const $8257dc5645cb2995$export$2988efabf1be3838 = ({ productEditionText: productEditionText })=>{
    const { formatMessage: formatMessage } = (0, $f6qj2.default)();
    const { user: { name: name } } = (0, $iMdoL.useUserContext)();
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $lC8Rv.BlueWaveTemplateJsm), {
        productEditionText: productEditionText,
        children: /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
            className: (0, $esG4f.default)([
                "_1e0c11p5 _zulp7vkz"
            ]),
            children: [
                /*#__PURE__*/ (0, $loA2J.jsx)("h2", {
                    className: (0, $esG4f.default)([
                        "_1wyb1tcg _k48pbfng _19pkidpf _2hwxidpf _otyridpf _18u0idpf _y3gn1h6o"
                    ]),
                    children: name ? formatMessage({
                        id: "WacSignupForm.personalizedNameSiteMessage",
                        defaultMessage: "Let's name your site, {username}"
                    }, {
                        username: (0, $jgJpJ.getFirstName)(name)
                    }) : formatMessage({
                        id: "JiraSoftwarePageTemplate.loggedInHero.welcomeBack",
                        defaultMessage: "Welcome back"
                    })
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)("p", {
                    className: (0, $esG4f.default)([
                        "_1wybdlk8 _syazl4fm _y3gn1h6o _19pkidpf _2hwxidpf _otyridpf _18u0idpf"
                    ]),
                    children: formatMessage({
                        id: "WacSignupForm.inputSiteNameMessage",
                        defaultMessage: "Your site name appears in the URL for your Atlassian products. Most people use their team or company name. You can change your site name later."
                    })
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)((0, $47Euo.default), {
                    NewUser: /*#__PURE__*/ (0, $loA2J.jsx)((0, $47Euo.NewUser), {
                        HelperText: null,
                        SubmitButton: /*#__PURE__*/ (0, $loA2J.jsx)((0, $ldWsL.JsmSubmitButtonNewUser), {})
                    })
                })
            ]
        })
    });
};
const $8257dc5645cb2995$var$containerCss = null;
const $8257dc5645cb2995$var$siteActivationHeadingCss = null;
const $8257dc5645cb2995$var$subheaderCss = null;

});

parcelRegister("ldWsL", function(module, exports) {

$parcel$export(module.exports, "JsmSubmitButtonNewUser", function () { return $e37d32f424ade61a$export$4fca978a8ca5663a; });

var $loA2J = parcelRequire("loA2J");

var $f6qj2 = parcelRequire("f6qj2");

var $fsv0y = parcelRequire("fsv0y");
const $e37d32f424ade61a$export$4fca978a8ca5663a = ()=>{
    const intl = (0, $f6qj2.default)();
    const submitMessage = intl.formatMessage({
        id: "bxpSignup.siteExpansion.goToProduct",
        defaultMessage: "Go to {productName}"
    }, {
        productName: "Jira Service Management"
    });
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $fsv0y.SubmitButton), {
        submitMessage: submitMessage
    });
};

});



parcelRegister("iSyWs", function(module, exports) {

$parcel$export(module.exports, "LoggedInJsmNewUser", function () { return $f29553c81a6bd9ae$export$6ffc4367587bf6df; });
/* new-user.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $f6qj2 = parcelRequire("f6qj2");

var $eXoeL = parcelRequire("eXoeL");

var $dyZbY = parcelRequire("dyZbY");

var $iu8Ap = parcelRequire("iu8Ap");

var $47Euo = parcelRequire("47Euo");
parcelRequire("ia5W9");
var $3CPhp = parcelRequire("3CPhp");
const $f29553c81a6bd9ae$export$6ffc4367587bf6df = ()=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)($f29553c81a6bd9ae$export$c6387527f8ecd8a4, {});
};
const $f29553c81a6bd9ae$export$c6387527f8ecd8a4 = ()=>{
    const intl = (0, $f6qj2.default)();
    const subHeaderText = intl.formatMessage({
        id: "siteActivation.loggedInJiraServiceManagement.newUser",
        defaultMessage: "Sites are the shared space where people organize teams, work, and projects."
    });
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $dyZbY.default), {
        name: "gwp6480-site-activation",
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $iu8Ap.SignupBackgroundLayout), {
            ProductLogo: /*#__PURE__*/ (0, $loA2J.jsx)((0, $eXoeL.JiraServiceManagementLogo), {
                size: "xlarge",
                appearance: "brand"
            }),
            children: /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                className: (0, $esG4f.default)([
                    "_1e0c1txw _2lx21bp4"
                ]),
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                        className: (0, $esG4f.default)([
                            "_1e0c11p5 _zulpu2gc"
                        ]),
                        children: [
                            /*#__PURE__*/ (0, $loA2J.jsx)("h1", {
                                className: (0, $esG4f.default)([
                                    "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _y3gn1h6o"
                                ]),
                                children: /*#__PURE__*/ (0, $loA2J.jsx)("span", {
                                    className: (0, $esG4f.default)([
                                        "_kqswh2mm"
                                    ]),
                                    children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $3CPhp.CreateASiteHeading), {})
                                })
                            }),
                            /*#__PURE__*/ (0, $loA2J.jsx)("p", {
                                className: (0, $esG4f.default)([
                                    "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _y3gn1h6o"
                                ]),
                                children: subHeaderText
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)((0, $47Euo.default), {})
                ]
            })
        })
    });
};
const $f29553c81a6bd9ae$var$containerCss = null;
const $f29553c81a6bd9ae$var$headerGroupCss = null;
const $f29553c81a6bd9ae$var$headerCss = null;
const $f29553c81a6bd9ae$var$accentImageSpanCss = null;

});


parcelRegister("fdgjD", function(module, exports) {

$parcel$export(module.exports, "LoggedInJsmPremium", function () { return $07c190c8de1b0767$export$85a8a83bf3efb849; });

var $loA2J = parcelRequire("loA2J");

var $f6qj2 = parcelRequire("f6qj2");

var $iMdoL = parcelRequire("iMdoL");
parcelRequire("juUMc");
var $kq8Eb = parcelRequire("kq8Eb");
var $6eEZK = parcelRequire("6eEZK");
const $07c190c8de1b0767$export$85a8a83bf3efb849 = ()=>{
    const { formatMessage: formatMessage } = (0, $f6qj2.default)();
    const cohort = (0, $iMdoL.useCohort)();
    if (cohort === "new-user") return /*#__PURE__*/ (0, $loA2J.jsx)((0, $kq8Eb.LoggedInBlueWaveTemplateJsmNewUser), {
        productEditionText: formatMessage({
            id: "WacSignupHeader.cloudPremium",
            defaultMessage: "Cloud Premium"
        })
    });
    if (cohort) return /*#__PURE__*/ (0, $loA2J.jsx)((0, $6eEZK.LoggedInBlueWaveTemplateJsmExistingUser), {
        productEditionText: formatMessage({
            id: "WacSignupHeader.cloudPremium",
            defaultMessage: "Cloud Premium"
        })
    });
    return null;
};

});

parcelRegister("bpb4a", function(module, exports) {

$parcel$export(module.exports, "LoggedInJsmStandard", function () { return $04ff600aa5f74e58$export$5b9d8332bb5cdf0b; });

var $loA2J = parcelRequire("loA2J");

var $f6qj2 = parcelRequire("f6qj2");

var $iMdoL = parcelRequire("iMdoL");
parcelRequire("ia5W9");
var $6dDlC = parcelRequire("6dDlC");
parcelRequire("juUMc");
var $kq8Eb = parcelRequire("kq8Eb");
var $6eEZK = parcelRequire("6eEZK");
const $04ff600aa5f74e58$export$5b9d8332bb5cdf0b = ()=>{
    const { formatMessage: formatMessage } = (0, $f6qj2.default)();
    const cohort = (0, $iMdoL.useCohort)();
    if (cohort === "new-user") return /*#__PURE__*/ (0, $loA2J.jsx)((0, $kq8Eb.LoggedInBlueWaveTemplateJsmNewUser), {
        productEditionText: formatMessage({
            id: "WacSignupHeader.cloudStandard",
            defaultMessage: "Cloud Standard"
        })
    });
    if (cohort) return /*#__PURE__*/ (0, $loA2J.jsx)((0, $6eEZK.LoggedInBlueWaveTemplateJsmExistingUser), {
        productEditionText: formatMessage({
            id: "WacSignupHeader.cloudStandard",
            defaultMessage: "Cloud Standard"
        })
    });
    if (cohort) // bxpkit catch-all leaving in for possible restart of experiment: https://console.statsig.com/LqivKg6ADZZaGczRfBKfX/experiments/signup_trialing_add_payment_ab/results can remove ~July 18th
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $6dDlC.SignupDefault), {});
    return null;
};

});


parcelRegister("6HNVd", function(module, exports) {

$parcel$export(module.exports, "LoggedOutJsm", function () { return $3b5ba38f60cf17a8$export$da6f22575c61fffe; });

var $loA2J = parcelRequire("loA2J");

var $iMdoL = parcelRequire("iMdoL");

var $akzie = parcelRequire("akzie");

var $cisIn = parcelRequire("cisIn");

var $eLhSY = parcelRequire("eLhSY");
const $3b5ba38f60cf17a8$export$da6f22575c61fffe = ()=>{
    const isStandard = (0, $iMdoL.useStandardIntent)();
    const isPremium = (0, $iMdoL.usePremiumIntent)();
    if (isStandard) return /*#__PURE__*/ (0, $loA2J.jsx)((0, $eLhSY.LoggedOutJsmStandard), {});
    if (isPremium) return /*#__PURE__*/ (0, $loA2J.jsx)((0, $cisIn.LoggedOutJsmPremium), {});
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $akzie.LoggedOutJsmFree), {});
};

});
parcelRegister("akzie", function(module, exports) {

$parcel$export(module.exports, "LoggedOutJsmFree", function () { return $3460ab1e9bc0092e$export$9512eb7977daf8ee; });

var $loA2J = parcelRequire("loA2J");

var $f6qj2 = parcelRequire("f6qj2");

var $axg8K = parcelRequire("axg8K");

var $iu8Ap = parcelRequire("iu8Ap");
const $3460ab1e9bc0092e$export$9512eb7977daf8ee = ()=>{
    const { formatMessage: formatMessage } = (0, $f6qj2.default)();
    const heading1 = formatMessage({
        id: "BxpUiSignup.SignupForm.header",
        defaultMessage: "Get started with {product}"
    }, {
        product: "Jira Service Management"
    });
    const heading2 = formatMessage({
        id: "BxpUiSignup.SignupForm.subheaderJSM",
        defaultMessage: "Free for up to 3 agents"
    });
    const helpText = formatMessage({
        id: "BxpUiSignup.SignupForm.workCallout",
        defaultMessage: "Find teammates, plus keep work and life separate by using your work email."
    });
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $iu8Ap.WhiteScreenLayout), {
        heading1: heading1,
        heading2: heading2,
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $axg8K.default), {
            Input: /*#__PURE__*/ (0, $loA2J.jsx)((0, $iu8Ap.WhiteScreenInput), {
                helpText: helpText
            }),
            Social: /*#__PURE__*/ (0, $loA2J.jsx)((0, $iu8Ap.WhiteScreenSocial), {}),
            Submit: /*#__PURE__*/ (0, $loA2J.jsx)((0, $iu8Ap.WhiteScreenSubmit), {})
        })
    });
};

});

parcelRegister("cisIn", function(module, exports) {

$parcel$export(module.exports, "LoggedOutJsmPremium", function () { return $8fce7e611834533f$export$906416d448322e8e; });

var $loA2J = parcelRequire("loA2J");

var $f6qj2 = parcelRequire("f6qj2");
parcelRequire("1b7D8");
var $hN1r9 = parcelRequire("hN1r9");
const $8fce7e611834533f$export$906416d448322e8e = ()=>{
    const { formatMessage: formatMessage } = (0, $f6qj2.default)();
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $hN1r9.LoggedOutBlueWaveTemplateJsm), {
        productEditionText: formatMessage({
            id: "WacSignupHeader.cloudPremium",
            defaultMessage: "Cloud Premium"
        })
    });
};

});
parcelRegister("1b7D8", function(module, exports) {
$parcel$export(module.exports, "LoggedOutBlueWaveTemplateJsm", function () { return (parcelRequire("hN1r9")).LoggedOutBlueWaveTemplateJsm; });
parcelRequire("hN1r9");
parcelRequire("h9SP4");

});
parcelRegister("hN1r9", function(module, exports) {

$parcel$export(module.exports, "LoggedOutBlueWaveTemplateJsm", function () { return $5815aa9d8dc78a9a$export$8eb2074aaa908b62; });
/* logged-out-blue-wave-template-jsm.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $f6qj2 = parcelRequire("f6qj2");

var $axg8K = parcelRequire("axg8K");
parcelRequire("ia5W9");
var $eZrnm = parcelRequire("eZrnm");
parcelRequire("juUMc");
var $lC8Rv = parcelRequire("lC8Rv");
const $5815aa9d8dc78a9a$export$8eb2074aaa908b62 = ({ productEditionText: productEditionText })=>{
    const { formatMessage: formatMessage } = (0, $f6qj2.default)();
    return /*#__PURE__*/ (0, $loA2J.jsxs)((0, $lC8Rv.BlueWaveTemplateJsm), {
        productEditionText: productEditionText,
        children: [
            /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsx)("h2", {
                        className: (0, $esG4f.default)([
                            "_1wyb14no _k48pbfng _19pkidpf _2hwxidpf _otyridpf _18u0idpf _y3gn1h6o"
                        ]),
                        children: formatMessage({
                            id: "WacSignupForm.signupOfferingIncludesFeaturesSignupFormHeading",
                            defaultMessage: "Start now"
                        })
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("p", {
                        className: (0, $esG4f.default)([
                            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _y3gn1h6o"
                        ]),
                        children: formatMessage({
                            id: "WacSignupForm.signupOfferingIncludesFeaturesSignupFormSubheadingStandard",
                            defaultMessage: "7-day free trial for up to 10,000 users"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                className: (0, $esG4f.default)([
                    "_85i588uy"
                ]),
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $axg8K.default), {
                    Login: null,
                    Separator: /*#__PURE__*/ (0, $loA2J.jsxs)((0, $loA2J.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $loA2J.jsx)((0, $eZrnm.NoCreditCardRequired), {}),
                            /*#__PURE__*/ (0, $loA2J.jsx)((0, $axg8K.Separator), {
                                separatorText: formatMessage({
                                    id: "WacSignupForm.socialSignUpOrSignUpWith",
                                    defaultMessage: "Or sign up with"
                                })
                            })
                        ]
                    })
                })
            })
        ]
    });
};
const $5815aa9d8dc78a9a$var$accountCreationHeadingCss = null;
const $5815aa9d8dc78a9a$var$accountCreationSubHeadingCss = null;
const $5815aa9d8dc78a9a$var$spacingCss = null;

});

parcelRegister("h9SP4", function(module, exports) {
/* logged-out-subheading.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $f6qj2 = parcelRequire("f6qj2");

var $5ohHq = parcelRequire("5ohHq");
const $6107a2c16c4efd79$export$95472f736e92878c = ({ returnString: returnString })=>{
    const intl = (0, $f6qj2.default)();
    const subHeaderText = intl.formatMessage({
        id: "signupForm.accountCreation.subHeaderTextJSMLoggedOutFree",
        defaultMessage: "It\u2019s free for up to 3 agents - no credit card needed."
    });
    return returnString ? subHeaderText : /*#__PURE__*/ (0, $loA2J.jsx)("p", {
        className: (0, $esG4f.default)([
            "_syaz1hlo _ect4bzd7 _k48p1nn1 _1wyb1j6v _vwz41k8s _y3gn1h6o _19pkftgi _2hwxidpf _otyrzwfg _18u0idpf",
            "body-md"
        ]),
        style: {
            "--_188070z": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.primary.black")),
            "--_1ikmwd8": (0, $43MIc.default)((0, $5ohHq.wacToken)("font.charlie.text"))
        },
        children: subHeaderText
    });
};
const $6107a2c16c4efd79$var$subHeaderCss = null;

});



parcelRegister("eLhSY", function(module, exports) {

$parcel$export(module.exports, "LoggedOutJsmStandard", function () { return $09f2d0a12b45f9de$export$8a8cbd91c0868d1e; });

var $loA2J = parcelRequire("loA2J");

var $f6qj2 = parcelRequire("f6qj2");
parcelRequire("1b7D8");
var $hN1r9 = parcelRequire("hN1r9");
const $09f2d0a12b45f9de$export$8a8cbd91c0868d1e = ()=>{
    const { formatMessage: formatMessage } = (0, $f6qj2.default)();
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $hN1r9.LoggedOutBlueWaveTemplateJsm), {
        productEditionText: formatMessage({
            id: "WacSignupHeader.cloudStandard",
            defaultMessage: "Cloud Standard"
        })
    });
};

});



parcelRegister("LBkMw", function(module, exports) {

$parcel$export(module.exports, "LoomSignup", function () { return $acfad3ba3ceee56d$export$6434524c946a590a; });

var $loA2J = parcelRequire("loA2J");

var $iMdoL = parcelRequire("iMdoL");
parcelRequire("6NfUC");
var $3TjdR = parcelRequire("3TjdR");
parcelRequire("dVfYF");
var $22H4k = parcelRequire("22H4k");
const $acfad3ba3ceee56d$export$6434524c946a590a = ()=>{
    const { user: { isUserLoggedIn: isUserLoggedIn } } = (0, $iMdoL.useUserContext)();
    if (isUserLoggedIn) return /*#__PURE__*/ (0, $loA2J.jsx)((0, $3TjdR.LoggedInLoom), {});
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $22H4k.LoggedOutLoom), {});
};

});
parcelRegister("6NfUC", function(module, exports) {
$parcel$export(module.exports, "LoggedInLoom", function () { return (parcelRequire("3TjdR")).LoggedInLoom; });
parcelRequire("793Ng");

});
parcelRegister("793Ng", function(module, exports) {
$parcel$export(module.exports, "LoggedInLoom", function () { return (parcelRequire("3TjdR")).LoggedInLoom; });
parcelRequire("3TjdR");

});
parcelRegister("3TjdR", function(module, exports) {

$parcel$export(module.exports, "LoggedInLoom", function () { return $dbf80aa52ce617e6$export$5f854ca694ed32ca; });

var $loA2J = parcelRequire("loA2J");
parcelRequire("2BIIq");
var $3yLXo = parcelRequire("3yLXo");

var $iu8Ap = parcelRequire("iu8Ap");

var $iMdoL = parcelRequire("iMdoL");

var $1MbAx = parcelRequire("1MbAx");

var $gAJUc = parcelRequire("gAJUc");

var $aOuDE = parcelRequire("aOuDE");

var $6dDlC = parcelRequire("6dDlC");

var $2cSu5 = parcelRequire("2cSu5");

var $9absl = parcelRequire("9absl");
const $dbf80aa52ce617e6$export$5f854ca694ed32ca = ()=>{
    const cohort = (0, $iMdoL.useCohort)();
    const isMobile = (0, $aOuDE.useIsMobile)(800);
    const isManagedUser = cohort === "managed-user";
    const isweekOneUser = cohort === "week-one-user";
    const isUpgradeEligibleUser = cohort === "upgrade-eligible-user";
    (0, $1MbAx.useFeatureExposed)("gwp-7282-loom-lofi-signup", "Test", {
        conditions: [
            cohort !== undefined && !isManagedUser && !isweekOneUser && !isUpgradeEligibleUser && !isMobile
        ],
        metadata: {
            cohort: cohort,
            userType: "logged-in"
        }
    });
    // Default cohorts not part of loom lofi background
    if (cohort === undefined) return null;
    else if (cohort === "managed-user" || cohort === "week-one-user" || cohort === "upgrade-eligible-user") return /*#__PURE__*/ (0, $loA2J.jsx)((0, $6dDlC.SignupDefault), {});
    else if (isMobile) return /*#__PURE__*/ (0, $loA2J.jsx)((0, $6dDlC.SignupDefault), {});
    if (cohort === "new-user") return /*#__PURE__*/ (0, $loA2J.jsx)((0, $9absl.LoggedInLoomNewUser), {});
    if (cohort === "existing-user" || cohort === "current-product-user" || (0, $gAJUc.checkFeatureFlagGate)((0, $gAJUc.featureFlags).signupModuleDeprecation)) return /*#__PURE__*/ (0, $loA2J.jsx)((0, $2cSu5.LoggedInLoomExistingSitesUser), {});
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $iu8Ap.LoomOverlayTemplate), {
        size: "sm",
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $3yLXo.default), {
            isNewUser: false,
            bundle: "loom",
            edition: "free"
        })
    });
};

});
parcelRegister("2cSu5", function(module, exports) {

$parcel$export(module.exports, "LoggedInLoomExistingSitesUser", function () { return $60f86f4edf769678$export$ef5a50e54c66f1ac; });
/* existing-sites-user.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $f6qj2 = parcelRequire("f6qj2");

var $iu8Ap = parcelRequire("iu8Ap");

var $47Euo = parcelRequire("47Euo");

var $iMdoL = parcelRequire("iMdoL");
parcelRequire("5XFHK");
var $kBgD7 = parcelRequire("kBgD7");
const $60f86f4edf769678$export$ef5a50e54c66f1ac = ()=>/*#__PURE__*/ (0, $loA2J.jsx)((0, $iu8Ap.LoomOverlayTemplate), {
        size: "sm",
        children: /*#__PURE__*/ (0, $loA2J.jsx)($60f86f4edf769678$var$Content, {})
    });
const $60f86f4edf769678$var$Content = ()=>{
    const { user: { name: name } } = (0, $iMdoL.useUserContext)();
    const { formatMessage: formatMessage } = (0, $f6qj2.default)();
    return /*#__PURE__*/ (0, $loA2J.jsxs)((0, $loA2J.Fragment), {
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("h1", {
                className: (0, $esG4f.default)([
                    "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _y3gn1h6o"
                ]),
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $kBgD7.WelcomeBackHeading), {
                    name: name
                })
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("h2", {
                className: (0, $esG4f.default)([
                    "_1wyb7vkz _k48p1nn1 _y3gn1h6o _vwz41tcg _ect48q0o _19pk7vkz _2hwxidpf _otyridpf _18u0idpf"
                ]),
                children: formatMessage({
                    id: "LoomTemplate.loggedInHero.subheader",
                    defaultMessage: "Sites are shared spaces to organize work, teams, and projects."
                })
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $47Euo.default), {}),
            /*#__PURE__*/ (0, $loA2J.jsx)("footer", {
                className: (0, $esG4f.default)([
                    "_1wyb1crf _k48p1nn1 _19pkidpf _2hwxidpf _otyridpf _18u0idpf _ect48q0o"
                ]),
                children: formatMessage({
                    id: "JiraSoftwarePageTemplate.loggedInHero.recatcha",
                    defaultMessage: "This page is protected by reCAPTCHA and the Google Privacy Policy and Terms of Service apply."
                })
            })
        ]
    });
};
const $60f86f4edf769678$var$headerCss = null;
const $60f86f4edf769678$var$subheadingCss = null;
const $60f86f4edf769678$var$footerCss = null;

});

parcelRegister("9absl", function(module, exports) {

$parcel$export(module.exports, "LoggedInLoomNewUser", function () { return $ff7208abcffe9ea7$export$7cdf426318d1c62; });
/* new-user.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $f6qj2 = parcelRequire("f6qj2");

var $iu8Ap = parcelRequire("iu8Ap");

var $47Euo = parcelRequire("47Euo");
parcelRequire("ia5W9");
var $3CPhp = parcelRequire("3CPhp");
const $ff7208abcffe9ea7$export$7cdf426318d1c62 = ()=>/*#__PURE__*/ (0, $loA2J.jsx)((0, $iu8Ap.LoomOverlayTemplate), {
        size: "sm",
        children: /*#__PURE__*/ (0, $loA2J.jsx)($ff7208abcffe9ea7$var$Content, {})
    });
const $ff7208abcffe9ea7$var$Content = ()=>{
    const { formatMessage: formatMessage } = (0, $f6qj2.default)();
    const intl = (0, $f6qj2.default)();
    const subHeaderText = intl.formatMessage({
        id: "siteActivation.loggedInLoom.newUser",
        defaultMessage: "Sites are shared spaces to organize work, teams, and projects."
    });
    return /*#__PURE__*/ (0, $loA2J.jsxs)((0, $loA2J.Fragment), {
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("h1", {
                className: (0, $esG4f.default)([
                    "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _y3gn1h6o"
                ]),
                children: /*#__PURE__*/ (0, $loA2J.jsx)("span", {
                    className: (0, $esG4f.default)([
                        "_kqswh2mm"
                    ]),
                    children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $3CPhp.CreateASiteHeading), {})
                })
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("p", {
                className: (0, $esG4f.default)([
                    "_1wyb7vkz _k48p1nn1 _y3gn1h6o _vwz41tcg _ect48q0o _19pk7vkz _2hwxidpf _otyridpf _18u0idpf"
                ]),
                children: subHeaderText
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $47Euo.default), {}),
            /*#__PURE__*/ (0, $loA2J.jsx)("footer", {
                className: (0, $esG4f.default)([
                    "_1wyb1crf _k48p1nn1 _19pkidpf _2hwxidpf _otyridpf _18u0idpf _ect48q0o"
                ]),
                children: formatMessage({
                    id: "JiraSoftwarePageTemplate.loggedInHero.recatcha",
                    defaultMessage: "This page is protected by reCAPTCHA and the Google Privacy Policy and Terms of Service apply."
                })
            })
        ]
    });
};
const $ff7208abcffe9ea7$var$headerCss = null;
const $ff7208abcffe9ea7$var$accentImageSpanCss = null;
const $ff7208abcffe9ea7$var$footerCss = null;
const $ff7208abcffe9ea7$var$subheadingCss = null;

});




parcelRegister("dVfYF", function(module, exports) {
$parcel$export(module.exports, "LoggedOutLoom", function () { return (parcelRequire("22H4k")).LoggedOutLoom; });
parcelRequire("22H4k");

});
parcelRegister("22H4k", function(module, exports) {

$parcel$export(module.exports, "LoggedOutLoom", function () { return $ca3e280004a1b863$export$cbbf580c671cecaf; });

var $loA2J = parcelRequire("loA2J");

var $axg8K = parcelRequire("axg8K");

var $iu8Ap = parcelRequire("iu8Ap");

var $1MbAx = parcelRequire("1MbAx");

var $aOuDE = parcelRequire("aOuDE");
parcelRequire("ia5W9");
var $6dDlC = parcelRequire("6dDlC");
var $esacZ = parcelRequire("esacZ");
var $5cDws = parcelRequire("5cDws");

var $38XOI = parcelRequire("38XOI");
const $ca3e280004a1b863$export$cbbf580c671cecaf = ()=>{
    const isMobile = (0, $aOuDE.useIsMobile)(800);
    (0, $1MbAx.useFeatureExposed)("gwp-7282-loom-lofi-signup", "Test", {
        conditions: [
            !isMobile
        ],
        metadata: {
            userType: "logged-out"
        }
    });
    if (!isMobile) return /*#__PURE__*/ (0, $loA2J.jsx)((0, $iu8Ap.LoomOverlayTemplate), {
        size: "sm",
        children: /*#__PURE__*/ (0, $loA2J.jsx)($ca3e280004a1b863$var$Content, {})
    });
    else return /*#__PURE__*/ (0, $loA2J.jsx)((0, $6dDlC.SignupDefault), {});
};
const $ca3e280004a1b863$var$Content = ()=>/*#__PURE__*/ (0, $loA2J.jsxs)((0, $loA2J.Fragment), {
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $esacZ.GetStartedHeading), {
                productName: "Loom"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $38XOI.FreeSubheading), {}),
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $axg8K.default), {
                Input: /*#__PURE__*/ (0, $loA2J.jsx)((0, $5cDws.InputSubmitButton), {}),
                Submit: null
            })
        ]
    });

});



parcelRegister("avirq", function(module, exports) {

$parcel$export(module.exports, "ServiceCollectionSignup", function () { return $8358236e1aebf68d$export$ab2edc20582a9660; });

var $loA2J = parcelRequire("loA2J");

var $iMdoL = parcelRequire("iMdoL");

var $eR6ZO = parcelRequire("eR6ZO");

var $iyfS1 = parcelRequire("iyfS1");

var $65tUr = parcelRequire("65tUr");

var $8PYS4 = parcelRequire("8PYS4");
const $8358236e1aebf68d$export$ab2edc20582a9660 = ()=>{
    const cohort = (0, $iMdoL.useCohort)();
    const loggedOut = (0, $iMdoL.useLoggedOut)();
    if (loggedOut) return /*#__PURE__*/ (0, $loA2J.jsx)((0, $65tUr.LoggedOut), {});
    if (!cohort) return null;
    switch(cohort){
        case (0, $iMdoL.COHORTS).MANAGED_USER:
        case (0, $iMdoL.COHORTS).WEEK_ONE_USER:
        case (0, $iMdoL.COHORTS).CURRENT_PRODUCT_USER:
            return /*#__PURE__*/ (0, $loA2J.jsx)((0, $eR6ZO.CurrentProductUser), {});
        case (0, $iMdoL.COHORTS).NEW_USER:
            return /*#__PURE__*/ (0, $loA2J.jsx)((0, $8PYS4.NewUser), {});
        default:
            return /*#__PURE__*/ (0, $loA2J.jsx)((0, $iyfS1.ExistingUser), {});
    }
};

});
parcelRegister("eR6ZO", function(module, exports) {

$parcel$export(module.exports, "CurrentProductUser", function () { return $31d092120a806db8$export$ef5a5fe6477555d4; });

var $loA2J = parcelRequire("loA2J");

var $dFnC9 = parcelRequire("dFnC9");

var $iu8Ap = parcelRequire("iu8Ap");

var $47Euo = parcelRequire("47Euo");

var $jgJpJ = parcelRequire("jgJpJ");
parcelRequire("ia5W9");
var $fy2K0 = parcelRequire("fy2K0");
var $8MW6j = parcelRequire("8MW6j");
const $31d092120a806db8$export$ef5a5fe6477555d4 = ()=>/*#__PURE__*/ (0, $loA2J.jsxs)((0, $iu8Ap.SignupBackgroundLayout), {
        ProductLogo: /*#__PURE__*/ (0, $loA2J.jsx)((0, $jgJpJ.ServiceCollectionLogo), {}),
        theme: "yellow",
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $fy2K0.WelcomeBackHeading), {}),
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $8MW6j.SubHeading), {
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                    id: "return-to-product-modal.header.text",
                    defaultMessage: "Pick up where you left off."
                })
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $47Euo.default), {
                CurrentProductUser: /*#__PURE__*/ (0, $loA2J.jsx)((0, $47Euo.ReturnToProduct), {})
            })
        ]
    });

});

parcelRegister("iyfS1", function(module, exports) {

$parcel$export(module.exports, "ExistingUser", function () { return $0097a5bd4634cc26$export$706672462bf25099; });

var $loA2J = parcelRequire("loA2J");

var $dFnC9 = parcelRequire("dFnC9");

var $iu8Ap = parcelRequire("iu8Ap");

var $47Euo = parcelRequire("47Euo");

var $jgJpJ = parcelRequire("jgJpJ");
parcelRequire("ia5W9");
var $fy2K0 = parcelRequire("fy2K0");
var $8MW6j = parcelRequire("8MW6j");
const $0097a5bd4634cc26$export$706672462bf25099 = ()=>/*#__PURE__*/ (0, $loA2J.jsxs)((0, $iu8Ap.SignupBackgroundLayout), {
        ProductLogo: /*#__PURE__*/ (0, $loA2J.jsx)((0, $jgJpJ.ServiceCollectionLogo), {}),
        theme: "yellow",
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $fy2K0.WelcomeBackHeading), {}),
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $8MW6j.SubHeading), {
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                    id: "signup.serviceCollection.subHeading",
                    defaultMessage: "It\u2019s free for up to 3 agents - no credit card needed."
                })
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $47Euo.default), {})
        ]
    });

});

parcelRegister("65tUr", function(module, exports) {

$parcel$export(module.exports, "LoggedOut", function () { return $bd41794af148fe17$export$98c2fc75a8b753f; });

var $loA2J = parcelRequire("loA2J");

var $dFnC9 = parcelRequire("dFnC9");

var $axg8K = parcelRequire("axg8K");

var $iu8Ap = parcelRequire("iu8Ap");

var $jgJpJ = parcelRequire("jgJpJ");
parcelRequire("ia5W9");
var $esacZ = parcelRequire("esacZ");
var $8MW6j = parcelRequire("8MW6j");
const $bd41794af148fe17$export$98c2fc75a8b753f = ()=>/*#__PURE__*/ (0, $loA2J.jsxs)((0, $iu8Ap.SignupBackgroundLayout), {
        ProductLogo: /*#__PURE__*/ (0, $loA2J.jsx)((0, $jgJpJ.ServiceCollectionLogo), {}),
        theme: "yellow",
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $esacZ.GetStartedHeading), {
                productName: "Service Collection"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $8MW6j.SubHeading), {
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                    id: "signup.serviceCollection.subHeading",
                    defaultMessage: "It\u2019s free for up to 3 agents - no credit card needed."
                })
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $axg8K.default), {})
        ]
    });

});

parcelRegister("8PYS4", function(module, exports) {

$parcel$export(module.exports, "NewUser", function () { return $74e7bdeefa424fbd$export$17cbb676e2e98676; });

var $loA2J = parcelRequire("loA2J");

var $dFnC9 = parcelRequire("dFnC9");

var $iu8Ap = parcelRequire("iu8Ap");

var $47Euo = parcelRequire("47Euo");

var $jgJpJ = parcelRequire("jgJpJ");
parcelRequire("ia5W9");
var $d5Q1l = parcelRequire("d5Q1l");
var $8MW6j = parcelRequire("8MW6j");
const $74e7bdeefa424fbd$export$17cbb676e2e98676 = ()=>/*#__PURE__*/ (0, $loA2J.jsxs)((0, $iu8Ap.SignupBackgroundLayout), {
        ProductLogo: /*#__PURE__*/ (0, $loA2J.jsx)((0, $jgJpJ.ServiceCollectionLogo), {}),
        theme: "yellow",
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $d5Q1l.CreateAWorkspaceHeading), {}),
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $8MW6j.SubHeading), {
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                    id: "signup.serviceCollection.newUser",
                    defaultMessage: "Workspaces are where people organize teams, work, and projects."
                })
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $47Euo.default), {})
        ]
    });

});


parcelRegister("84uw8", function(module, exports) {

$parcel$export(module.exports, "TeamworkCollectionSignup", function () { return $2242e5b3a41f7211$export$37596ea992b819a; });

var $loA2J = parcelRequire("loA2J");

var $jgJpJ = parcelRequire("jgJpJ");

var $iMdoL = parcelRequire("iMdoL");

var $lrVTP = parcelRequire("lrVTP");

var $3LX5A = parcelRequire("3LX5A");

var $6md3q = parcelRequire("6md3q");

var $coJ9d = parcelRequire("coJ9d");

var $5pnxD = parcelRequire("5pnxD");

var $6Av2Q = parcelRequire("6Av2Q");

var $efYAV = parcelRequire("efYAV");

var $2FnPN = parcelRequire("2FnPN");
const $2242e5b3a41f7211$export$37596ea992b819a = ()=>{
    const cohort = (0, $iMdoL.useCohort)();
    const loggedOut = (0, $iMdoL.useLoggedOut)();
    const location = (0, $lrVTP.useLocation)();
    const params = new URLSearchParams(location.search);
    const primaryCollectionProduct = params.get("primaryCollectionProduct");
    if (loggedOut) {
        if (primaryCollectionProduct === (0, $jgJpJ.ProductKey).ROVO) return /*#__PURE__*/ (0, $loA2J.jsx)((0, $6Av2Q.LoggedOutRovo), {});
        return /*#__PURE__*/ (0, $loA2J.jsx)((0, $5pnxD.LoggedOut), {});
    }
    if (!cohort) return null;
    switch(cohort){
        case (0, $iMdoL.COHORTS).MANAGED_USER:
        case (0, $iMdoL.COHORTS).WEEK_ONE_USER:
        case (0, $iMdoL.COHORTS).CURRENT_PRODUCT_USER:
            return /*#__PURE__*/ (0, $loA2J.jsx)((0, $6md3q.CurrentProductUser), {});
        case (0, $iMdoL.COHORTS).CROSSFLOW_ELIGIBLE_USER:
            return /*#__PURE__*/ (0, $loA2J.jsx)((0, $3LX5A.CrossflowEligibleUser), {});
        case (0, $iMdoL.COHORTS).UPLIFT_ELIGIBLE_USER:
            return /*#__PURE__*/ (0, $loA2J.jsx)((0, $2FnPN.UpliftEligibleUser), {});
        case (0, $iMdoL.COHORTS).NEW_USER:
            return /*#__PURE__*/ (0, $loA2J.jsx)((0, $efYAV.NewUser), {});
        default:
            return /*#__PURE__*/ (0, $loA2J.jsx)((0, $coJ9d.ExistingUser), {});
    }
};

});
parcelRegister("3LX5A", function(module, exports) {

$parcel$export(module.exports, "CrossflowEligibleUser", function () { return $246b1ac2e903433b$export$dd75b010f23330e6; });

var $loA2J = parcelRequire("loA2J");

var $dFnC9 = parcelRequire("dFnC9");

var $iu8Ap = parcelRequire("iu8Ap");

var $47Euo = parcelRequire("47Euo");

var $jgJpJ = parcelRequire("jgJpJ");
parcelRequire("ia5W9");
var $esacZ = parcelRequire("esacZ");
parcelRequire("gJZfF");
var $4gQUN = parcelRequire("4gQUN");
const $246b1ac2e903433b$export$dd75b010f23330e6 = ()=>/*#__PURE__*/ (0, $loA2J.jsxs)((0, $iu8Ap.SignupBackgroundLayout), {
        ProductLogo: /*#__PURE__*/ (0, $loA2J.jsx)((0, $jgJpJ.TeamworkCollectionLogo), {}),
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $esacZ.Heading), {
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                    id: "signup.teamworkCollection.uplift.heading",
                    defaultMessage: "Switch your site to Teamwork Collection"
                })
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $47Euo.default), {
                CrossflowEligibleUser: /*#__PURE__*/ (0, $loA2J.jsx)((0, $4gQUN.SwitchYourSiteMessage), {})
            })
        ]
    });

});
parcelRegister("gJZfF", function(module, exports) {
$parcel$export(module.exports, "SwitchYourSiteMessage", function () { return (parcelRequire("4gQUN")).SwitchYourSiteMessage; });
parcelRequire("4gQUN");

});
parcelRegister("4gQUN", function(module, exports) {

$parcel$export(module.exports, "SwitchYourSiteMessage", function () { return $113920d6fcad30e5$export$ebcaa81b8b47a3aa; });
/* switch-your-site-message.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $dFnC9 = parcelRequire("dFnC9");

var $47Euo = parcelRequire("47Euo");

var $jgJpJ = parcelRequire("jgJpJ");

var $1UUq1 = parcelRequire("1UUq1");
const $113920d6fcad30e5$export$ebcaa81b8b47a3aa = ()=>{
    let homeCtaUrl = "https://home.atlassian.com";
    const { primaryCollectionProduct: primaryCollectionProduct } = (0, $47Euo.useSiteActivationContext)();
    if (primaryCollectionProduct === (0, $jgJpJ.ProductKey).ROVO) homeCtaUrl = `${homeCtaUrl}/chat`;
    return /*#__PURE__*/ (0, $loA2J.jsxs)((0, $loA2J.Fragment), {
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("p", {
                className: (0, $esG4f.default)([
                    "_y3gn1h6o _6rth14no"
                ]),
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                    id: "signup.teamworkCollection.uplift",
                    defaultMessage: "You already have a site that qualifies to switch over to Teamwork Collection. Admins can convert existing sites to Teamwork Collection at Atlassian Administration."
                })
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $1UUq1.Button), {
                variant: "primary",
                href: homeCtaUrl,
                target: "_self",
                className: (0, $esG4f.default)([
                    "_p12fglyw"
                ]),
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                    id: "signup.teamworkCollection.uplift.button",
                    defaultMessage: "Back to Home"
                })
            })
        ]
    });
};
const $113920d6fcad30e5$var$contentCss = null;
const $113920d6fcad30e5$var$buttonCss = null;

});



parcelRegister("6md3q", function(module, exports) {

$parcel$export(module.exports, "CurrentProductUser", function () { return $424c1d61907683d4$export$ef5a5fe6477555d4; });

var $loA2J = parcelRequire("loA2J");

var $dFnC9 = parcelRequire("dFnC9");

var $iu8Ap = parcelRequire("iu8Ap");

var $47Euo = parcelRequire("47Euo");

var $jgJpJ = parcelRequire("jgJpJ");
parcelRequire("ia5W9");
var $fy2K0 = parcelRequire("fy2K0");
var $8MW6j = parcelRequire("8MW6j");
const $424c1d61907683d4$export$ef5a5fe6477555d4 = ()=>/*#__PURE__*/ (0, $loA2J.jsxs)((0, $iu8Ap.SignupBackgroundLayout), {
        ProductLogo: /*#__PURE__*/ (0, $loA2J.jsx)((0, $jgJpJ.TeamworkCollectionLogo), {}),
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $fy2K0.WelcomeBackHeading), {}),
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $8MW6j.SubHeading), {
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                    id: "return-to-product-modal.header.text",
                    defaultMessage: "Pick up where you left off."
                })
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $47Euo.default), {
                CurrentProductUser: /*#__PURE__*/ (0, $loA2J.jsx)((0, $47Euo.ReturnToProduct), {
                    ExistingUser: /*#__PURE__*/ (0, $loA2J.jsx)((0, $47Euo.ExistingUser), {
                        SitePicker: null
                    })
                })
            })
        ]
    });

});

parcelRegister("coJ9d", function(module, exports) {

$parcel$export(module.exports, "ExistingUser", function () { return $6f5d104193b4c89c$export$706672462bf25099; });

var $loA2J = parcelRequire("loA2J");

var $dFnC9 = parcelRequire("dFnC9");

var $iu8Ap = parcelRequire("iu8Ap");

var $47Euo = parcelRequire("47Euo");

var $jgJpJ = parcelRequire("jgJpJ");
parcelRequire("ia5W9");
var $fy2K0 = parcelRequire("fy2K0");
var $8MW6j = parcelRequire("8MW6j");
const $6f5d104193b4c89c$export$706672462bf25099 = ()=>/*#__PURE__*/ (0, $loA2J.jsxs)((0, $iu8Ap.SignupBackgroundLayout), {
        ProductLogo: /*#__PURE__*/ (0, $loA2J.jsx)((0, $jgJpJ.TeamworkCollectionLogo), {}),
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $fy2K0.WelcomeBackHeading), {}),
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $8MW6j.SubHeading), {
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                    id: "signup.teamworkCollection.subHeading",
                    defaultMessage: "It\u2019s free for up to 10 users - no credit card needed."
                })
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $47Euo.default), {})
        ]
    });

});

parcelRegister("5pnxD", function(module, exports) {

$parcel$export(module.exports, "LoggedOut", function () { return $2b720830c7880997$export$98c2fc75a8b753f; });

var $loA2J = parcelRequire("loA2J");

var $dFnC9 = parcelRequire("dFnC9");

var $axg8K = parcelRequire("axg8K");

var $iu8Ap = parcelRequire("iu8Ap");

var $jgJpJ = parcelRequire("jgJpJ");
parcelRequire("ia5W9");
var $esacZ = parcelRequire("esacZ");
var $8MW6j = parcelRequire("8MW6j");
const $2b720830c7880997$export$98c2fc75a8b753f = ()=>/*#__PURE__*/ (0, $loA2J.jsxs)((0, $iu8Ap.SignupBackgroundLayout), {
        ProductLogo: /*#__PURE__*/ (0, $loA2J.jsx)((0, $jgJpJ.TeamworkCollectionLogo), {}),
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $esacZ.GetStartedHeading), {
                productName: "Teamwork Collection"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $8MW6j.SubHeading), {
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                    id: "signup.teamworkCollection.subHeading",
                    defaultMessage: "It\u2019s free for up to 10 users - no credit card needed."
                })
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $axg8K.default), {})
        ]
    });

});

parcelRegister("6Av2Q", function(module, exports) {

$parcel$export(module.exports, "LoggedOutRovo", function () { return $3ec085d89baf94ae$export$eeed5bebd1ea63a7; });

var $loA2J = parcelRequire("loA2J");

var $dFnC9 = parcelRequire("dFnC9");

var $axg8K = parcelRequire("axg8K");

var $iu8Ap = parcelRequire("iu8Ap");

var $jgJpJ = parcelRequire("jgJpJ");
parcelRequire("ia5W9");
var $esacZ = parcelRequire("esacZ");
var $8MW6j = parcelRequire("8MW6j");
const $3ec085d89baf94ae$export$eeed5bebd1ea63a7 = ()=>/*#__PURE__*/ (0, $loA2J.jsxs)((0, $iu8Ap.SignupBackgroundLayout), {
        ProductLogo: /*#__PURE__*/ (0, $loA2J.jsx)((0, $jgJpJ.TeamworkCollectionLogo), {}),
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $esacZ.Heading), {
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                    id: "signup.teamworkCollection.rovoHeading",
                    defaultMessage: "Get Teamwork Collection to start using Rovo"
                })
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $8MW6j.SubHeading), {
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                    id: "signup.teamworkCollection.rovoSubHeading",
                    defaultMessage: "Free for up to ten users. Start using Rovo in 20 minutes or less after sign-up."
                })
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $axg8K.default), {})
        ]
    });

});

parcelRegister("efYAV", function(module, exports) {

$parcel$export(module.exports, "NewUser", function () { return $fca913b46e523472$export$17cbb676e2e98676; });

var $loA2J = parcelRequire("loA2J");

var $dFnC9 = parcelRequire("dFnC9");

var $iu8Ap = parcelRequire("iu8Ap");

var $47Euo = parcelRequire("47Euo");

var $jgJpJ = parcelRequire("jgJpJ");
parcelRequire("ia5W9");
var $d5Q1l = parcelRequire("d5Q1l");
var $8MW6j = parcelRequire("8MW6j");
const $fca913b46e523472$export$17cbb676e2e98676 = ()=>/*#__PURE__*/ (0, $loA2J.jsxs)((0, $iu8Ap.SignupBackgroundLayout), {
        ProductLogo: /*#__PURE__*/ (0, $loA2J.jsx)((0, $jgJpJ.TeamworkCollectionLogo), {}),
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $d5Q1l.CreateAWorkspaceHeading), {}),
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $8MW6j.SubHeading), {
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                    id: "signup.serviceCollection.newUser",
                    defaultMessage: "Workspaces are where people organize teams, work, and projects."
                })
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $47Euo.default), {})
        ]
    });

});

parcelRegister("2FnPN", function(module, exports) {

$parcel$export(module.exports, "UpliftEligibleUser", function () { return $dd985252e64034df$export$43d4ec0de37cd914; });
/* uplift-eligible-user.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $dFnC9 = parcelRequire("dFnC9");

var $g9kzu = parcelRequire("g9kzu");

var $9gh2a = parcelRequire("9gh2a");

var $jFQmg = parcelRequire("jFQmg");

var $iu8Ap = parcelRequire("iu8Ap");

var $47Euo = parcelRequire("47Euo");

var $jgJpJ = parcelRequire("jgJpJ");

var $iMdoL = parcelRequire("iMdoL");

var $gkhN4 = parcelRequire("gkhN4");

var $1UUq1 = parcelRequire("1UUq1");
parcelRequire("ia5W9");
var $esacZ = parcelRequire("esacZ");
parcelRequire("gJZfF");
var $4gQUN = parcelRequire("4gQUN");
const $dd985252e64034df$export$43d4ec0de37cd914 = ()=>/*#__PURE__*/ (0, $loA2J.jsxs)((0, $iu8Ap.SignupBackgroundLayout), {
        ProductLogo: /*#__PURE__*/ (0, $loA2J.jsx)((0, $jgJpJ.TeamworkCollectionLogo), {}),
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $esacZ.Heading), {
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                    id: "signup.teamworkCollection.uplift.heading",
                    defaultMessage: "Switch your site to Teamwork Collection"
                })
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $47Euo.default), {
                UpliftEligibleUser: /*#__PURE__*/ (0, $loA2J.jsx)($dd985252e64034df$var$UpliftPicker, {})
            })
        ]
    });
const $dd985252e64034df$var$UpliftPicker = ()=>{
    const [loading, setLoading] = (0, $iSvIT.useState)(true);
    const [orgs, setOrgs] = (0, $iSvIT.useState)([]);
    const { sitePickerValue: sitePickerValue } = (0, $47Euo.useSiteActivationContext)();
    const potentiallyUpliftableSites = (0, $iMdoL.useUpliftableSites)();
    const [upliftableSites, setUpliftableSites] = (0, $iSvIT.useState)([]);
    const stargateClient = (0, $gkhN4.useBxpWebStargateClient)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $g9kzu.useAnalyticsEvents)();
    const analyticsClient = (0, $jFQmg.useAnalyticsClient)();
    const onSubmit = (e)=>{
        var _selectedOrg_organization;
        e.preventDefault();
        if (!sitePickerValue) return;
        const cloudId = sitePickerValue.cloudId;
        const selectedOrg = orgs.find((org)=>{
            var _org_organization_siteIds, _org_organization;
            return (_org_organization = org.organization) === null || _org_organization === void 0 ? void 0 : (_org_organization_siteIds = _org_organization.siteIds) === null || _org_organization_siteIds === void 0 ? void 0 : _org_organization_siteIds.includes(cloudId);
        });
        const orgId = selectedOrg === null || selectedOrg === void 0 ? void 0 : (_selectedOrg_organization = selectedOrg.organization) === null || _selectedOrg_organization === void 0 ? void 0 : _selectedOrg_organization.id;
        const adminHubUrl = (0, $jgJpJ.isProduction)() ? "https://admin.atlassian.com" : "https://admin.stg.atlassian.com";
        const upgradeUrl = `${adminHubUrl}/o/${orgId}/atlassian-apps?openAddAppDrawer=TeamworkCollection`;
        createAnalyticsEvent({
            eventType: "ui",
            action: "submitted",
            actionSubject: "twcUpliftForm"
        }).fire();
        window.location.assign(upgradeUrl);
    };
    (0, $iSvIT.useEffect)(()=>{
        if (!potentiallyUpliftableSites) return;
        stargateClient.getAccountOrgs({}).then(async ({ accountOrgs: accountOrgs })=>{
            if (!accountOrgs) return;
            const orgIds = accountOrgs.filter(({ isAdmin: isAdmin })=>isAdmin).map(({ id: id })=>id);
            const orgDetails = await Promise.all(orgIds.map((orgId)=>stargateClient.getSignupAccountOrgDetails({
                    orgId: orgId
                })));
            const eligibleCloudIds = orgDetails.flatMap((org)=>{
                var _org_organization;
                var _org_organization_siteIds;
                return (_org_organization_siteIds = (_org_organization = org.organization) === null || _org_organization === void 0 ? void 0 : _org_organization.siteIds) !== null && _org_organization_siteIds !== void 0 ? _org_organization_siteIds : [];
            });
            const eligibleSites = potentiallyUpliftableSites.filter((site)=>eligibleCloudIds.includes(site.cloudId));
            setOrgs(orgDetails);
            setUpliftableSites(eligibleSites);
        }).finally(()=>{
            setLoading(false);
        });
    }, [
        stargateClient,
        potentiallyUpliftableSites
    ]);
    (0, $iSvIT.useEffect)(()=>{
        if (loading || !analyticsClient) return;
        createAnalyticsEvent({
            eventType: "ui",
            action: "viewed",
            actionSubject: "twcUpliftScreen",
            attributes: {
                eligibleSitesCount: upliftableSites.length
            }
        }).fire();
    }, [
        loading,
        analyticsClient,
        createAnalyticsEvent,
        upliftableSites.length
    ]);
    if (loading) return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        className: (0, $esG4f.default)([
            "_4cvr1h6o _1e0c1txw _16jlkb7n _1bah1h6o _ca0q1ylp _u5f31ylp _n3td1ylp _19bv1ylp"
        ]),
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $9gh2a.default), {
            size: "large"
        })
    });
    if (!upliftableSites.length) return /*#__PURE__*/ (0, $loA2J.jsx)((0, $4gQUN.SwitchYourSiteMessage), {});
    return /*#__PURE__*/ (0, $loA2J.jsxs)("form", {
        onSubmit: onSubmit,
        className: (0, $esG4f.default)([
            "_1e0c1txw _2lx21bp4 _zulp1tcg _1pfhzwfg _1bsb1osq _187zglyw"
        ]),
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $47Euo.Dropdown), {
                sites: upliftableSites
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $1UUq1.Button), {
                type: "submit",
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                    id: "siteActivation.nameSiteNewUser.continueButton",
                    defaultMessage: "Continue"
                })
            })
        ]
    });
};
const $dd985252e64034df$var$formCss = null;
const $dd985252e64034df$var$spinnerContainerCss = null;

});






//# sourceMappingURL=index.525f59c8.js.map
